import React, { PureComponent } from "react";
import { withTranslation } from "react-i18next";
import axios from "axios";
import { Typeahead } from "react-bootstrap-typeahead";
import Price from "./price";

class HeroImage2 extends React.PureComponent {
  // Definieren Sie den gemeinsamen Graphen
  defaultGraph = `<svg xmlns="http://www.w3.org/2000/svg" width="160" height="40"><path fill="none" stroke="#a1a5b7" stroke-width="1.5" d="M20,20L21.69,20L23.38,20L25.07,20L28.451,20L30.141,20L31.831,20L33.521,20L36.901,20L38.592,20L40.282,20L41.972,20L43.662,20L45.352,20L47.042,20L48.732,20L50.423,20L52.113,20L53.803,20L55.493,20L57.183,20L58.873,20L60.563,20L62.254,20L63.944,20L65.634,20L67.324,20L69.014,20L70.704,20L72.394,20L74.085,20L75.775,20L77.465,20L79.155,20L80.845,20L82.535,20L84.225,20L85.915,20L87.606,20L89.296,20L90.986,20L92.676,20L94.366,20L96.056,20L97.746,20L99.437,20L101.127,20L102.817,20L104.507,20L106.197,20L107.887,20L109.577,20L111.268,20L112.958,20L114.648,20L116.338,20L118.028,20L119.718,20L121.408,20L123.099,20L124.789,20L126.479,20L128.169,20L129.859,20L131.549,20L133.239,20L134.93,20L136.62,20L138.31,20"/></svg>`;

  state = {
    prices: [
      {
        articleId: "6458ae695175287050a4cc49",
        title: { en: "L-Arginine HCL Powder (vegan)" },
        subtitle: { en: "83% L-Arginine" },
        commodityPrice: { date: "Mon Nov 18 2024", price: 4.8359375 },
        change: -6.2,
        svg: '<svg xmlns="http://www.w3.org/2000/svg" width="160" height="40"> <path fill="none" stroke="#50cd89" stroke-width="1.5" d="M20,20L20.217,20L20.433,20L20.65,20L20.866,20L21.083,20L21.3,20L21.516,20L21.733,20L21.949,20L22.166,20L22.383,20L22.599,20L22.816,20L23.032,20L23.249,20L23.466,20L23.682,20L23.899,20L24.116,20L24.332,20L24.549,20L24.765,20L24.982,20L25.199,20L25.415,20L25.632,20L25.848,20L26.065,20L26.282,20L26.498,20L26.715,20L26.931,20L27.148,20L27.365,20L27.581,20L27.798,20L28.014,20L28.231,20L28.448,20L28.664,20L28.881,20L29.097,20L29.314,20L29.531,20L29.747,20L29.964,20L30.181,20L30.397,20L30.614,20L30.83,20L31.047,20L31.264,20L31.48,20L31.697,20L31.913,20L32.13,20L32.347,20L32.563,20L32.78,20L32.996,20L33.213,20L33.43,20L33.646,20L33.863,20L34.079,20L34.296,20L34.513,20L34.729,20L34.946,20L35.162,20L35.379,20L35.596,20L35.812,20L36.029,20L36.245,20L36.462,20L36.679,20L36.895,20L37.112,20L37.329,20L37.545,20L37.762,20L37.978,20L38.195,20L38.412,20L38.628,20L38.845,20L39.061,20L39.278,20L39.495,20L39.711,20L39.928,20L40.144,20L40.361,20L40.578,20L40.794,20L41.011,20L41.227,20L41.444,20L41.661,20L41.877,20L42.094,20L42.31,20L42.527,20L42.744,20L42.96,20L43.177,20L43.394,20L43.61,20L43.827,20L44.043,20L44.26,20L44.477,20L44.693,20L44.91,20L45.126,20L45.343,20L45.56,20L45.776,20L45.993,20L46.209,20L46.426,20L46.643,20L46.859,20L47.076,20L47.292,20L47.509,20L47.726,20L47.942,20L48.159,20L48.375,20L48.592,20L48.809,20L49.025,20L49.242,20L49.458,20L49.675,20L49.892,20L50.108,20L50.325,20L50.542,20L50.758,20L50.975,20L51.191,20L51.408,20L51.625,20L51.841,20L52.058,20L52.274,20L52.491,20L52.708,20L52.924,20L53.141,20L53.357,20L53.574,20L53.791,20L54.007,20L54.224,20L54.44,20L54.657,20L54.874,20L55.09,20L55.307,20L55.523,20L55.74,20L55.957,20L56.173,20L56.39,20L56.606,20L56.823,20L57.04,20L57.256,20L57.473,20L57.69,20L57.906,20L58.123,20L58.339,20L58.556,20L58.773,20L58.989,20L59.206,20L59.422,20L59.639,20L59.856,20L60.072,20L60.289,20L60.505,20L60.722,20L60.939,20L61.155,20L61.372,20L61.588,20L61.805,20L62.022,20L62.238,20L62.455,20L62.671,20L62.888,20L63.105,20L63.321,20L63.538,20L63.755,20L63.971,20L64.188,20L64.404,20L64.621,20L64.838,20L65.054,20L65.271,20L65.487,20L65.704,20L65.921,20L66.137,20L66.354,20L66.57,20L66.787,20L67.004,20L67.22,20L67.437,20.009L67.653,20.009L67.87,20.009L68.087,20.009L68.303,20.009L68.52,20.009L68.736,20.009L68.953,20.114L69.17,20.114L69.386,20.114L69.603,20.114L69.819,20.114L70.036,20.114L70.253,20.114L70.469,20.114L70.686,20.114L70.903,20.114L71.119,20.114L71.336,20.114L71.552,20.114L71.769,20.114L71.986,20.114L72.202,20.114L72.419,20.114L72.635,20.114L72.852,20.114L73.069,20.114L73.285,20.114L73.502,20.114L73.718,20.114L73.935,20.114L74.152,20.114L74.368,20.114L74.585,20.112L74.801,20.112L75.018,20.112L75.235,20.112L75.451,20.112L75.668,20.112L75.884,20.112L76.101,20.112L76.318,20.112L76.534,20.151L76.751,20.151L76.968,20.151L77.184,20.151L77.401,20.151L77.617,20.151L77.834,20.151L78.051,20.151L78.267,20.151L78.484,20.151L78.7,20.151L78.917,20.151L79.134,20.151L79.35,20.151L79.567,20.151L79.783,20.096L80,20.096L80.217,20.096L80.433,20.096L80.65,20.096L80.866,20.096L81.083,20.096L81.3,20.096L81.516,20.096L81.733,20.096L81.949,20.096L82.166,20.096L82.383,20.096L82.599,20.096L82.816,20.096L83.032,20.096L83.249,20.096L83.466,20.096L83.682,20.096L83.899,20.096L84.116,20.096L84.332,20.096L84.549,20.096L84.765,20.096L84.982,20.096L85.199,20.096L85.415,20.096L85.632,20.096L85.848,20.096L86.065,20.096L86.282,20.096L86.498,20.096L86.715,20.096L86.931,20.096L87.148,20.096L87.365,20.096L87.581,20.096L87.798,20.096L88.014,20.096L88.231,20.096L88.448,20.096L88.664,20.096L88.881,20.096L89.097,20.096L89.314,20.096L89.531,20.096L89.747,20.096L89.964,20.096L90.181,20.096L90.397,20.096L90.614,20.096L90.83,20.096L91.047,20.096L91.264,20.096L91.48,20.096L91.697,20.096L91.913,20.096L92.13,20.096L92.347,20.096L92.563,20.096L92.78,28.112L92.996,28.112L93.213,28.112L93.43,28.112L93.646,28.112L93.863,28.112L94.079,28.112L94.296,28.112L94.513,28.112L94.729,28.112L94.946,28.112L95.162,28.112L95.379,28.112L95.596,28.112L95.812,28.112L96.029,28.112L96.245,28.112L96.462,28.112L96.679,28.112L96.895,28.112L97.112,28.112L97.329,28.112L97.545,28.112L97.762,28.112L97.978,28.112L98.195,28.112L98.412,28.112L98.628,28.112L98.845,28.112L99.061,28.112L99.278,28.112L99.495,28.112L99.711,28.112L99.928,28.112L100.144,28.112L100.361,28.112L100.578,28.112L100.794,28.112L101.011,28.112L101.227,28.112L101.444,28.112L101.661,28.112L101.877,28.112L102.094,28.112L102.31,28.112L102.527,28.112L102.744,28.112L102.96,28.112L103.177,28.112L103.394,28.112L103.61,28.112L103.827,28.112L104.043,28.112L104.26,28.112L104.477,28.112L104.693,28.112L104.91,28.112L105.126,28.112L105.343,28.112L105.56,28.112L105.776,28.112L105.993,28.112L106.209,28.112L106.426,28.112L106.643,28.112L106.859,28.112L107.076,28.112L107.292,28.112L107.509,28.112L107.726,28.112L107.942,28.112L108.159,28.112L108.375,28.112L108.592,28.112L108.809,28.112L109.025,28.112L109.242,28.112L109.458,28.112L109.675,28.112L109.892,28.112L110.108,28.112L110.325,28.112L110.542,28.112L110.758,28.112L110.975,28.112L111.191,31.106L111.408,31.106L111.625,31.106L111.841,31.106L112.058,31.106L112.274,31.106L112.491,31.106L112.708,31.106L112.924,31.106L113.141,31.106L113.357,31.106L113.574,31.106L113.791,31.106L114.007,31.106L114.224,31.106L114.44,31.106L114.657,31.106L114.874,31.106L115.09,31.106L115.307,31.106L115.523,31.106L115.74,31.106L115.957,31.106L116.173,31.106L116.39,31.106L116.606,31.106L116.823,31.106L117.04,31.106L117.256,31.106L117.473,31.106L117.69,31.106L117.906,31.106L118.123,31.106L118.339,31.106L118.556,31.106L118.773,31.106L118.989,31.106L119.206,31.106L119.422,31.106L119.639,31.106L119.856,31.106L120.072,31.106L120.289,31.992L120.505,31.992L120.722,31.992L120.939,31.992L121.155,31.992L121.372,31.992L121.588,31.992L121.805,31.992L122.022,31.992L122.238,31.992L122.455,31.992L122.671,31.992L122.888,31.992L123.105,31.992L123.321,31.992L123.538,31.992L123.755,31.992L123.971,31.992L124.188,31.992L124.404,31.992L124.621,31.992L124.838,31.992L125.054,31.992L125.271,31.992L125.487,31.992L125.704,31.992L125.921,31.992L126.137,31.992L126.354,31.992L126.57,31.992L126.787,31.992L127.004,31.992L127.22,31.992L127.437,31.992L127.653,31.992L127.87,31.992L128.087,31.992L128.303,31.992L128.52,31.992L128.736,31.992L128.953,31.992L129.17,31.992L129.386,31.992L129.603,31.992L129.819,31.992L130.036,31.992L130.253,31.992L130.469,31.992L130.686,31.992L130.903,31.992L131.119,31.992L131.336,31.992L131.552,31.992L131.769,31.992L131.986,31.992L132.202,31.992L132.419,31.992L132.635,31.992L132.852,31.992L133.069,31.992L133.285,31.992L133.502,31.992L133.718,31.992L133.935,31.992L134.152,31.992L134.368,31.992L134.585,31.992L134.801,31.995L135.018,31.995L135.235,31.995L135.451,31.995L135.668,31.995L135.884,31.995L136.101,31.995L136.318,32L136.534,32L136.751,32L136.968,32L137.184,32L137.401,32L137.617,32L137.834,32L138.051,32L138.267,32L138.484,32L138.7,32L138.917,32L139.134,32L139.35,32L139.567,32L139.783,32"/></svg>',
      },
      {
        articleId: "645cf5e0329034f1aee8c713",
        title: { en: "L-Arginine base Powder" },
        subtitle: { en: "98% L-Arginine" },
        commodityPrice: { date: "Mon Nov 18 2024", price: 4.46875 },
        change: -20.9,
        svg: '<svg xmlns="http://www.w3.org/2000/svg" width="160" height="40"> <path fill="none" stroke="#50cd89" stroke-width="1.5" d="M20,20L20.615,20L21.231,20L21.846,20L22.462,20L23.077,20L23.692,20L24.308,20L24.923,20L25.538,20L26.154,20L26.769,20L27.385,20L28,20L28.615,20L29.231,20L29.846,20L30.462,20L31.077,20L31.692,20L32.308,20L32.923,20L33.538,20L34.154,21.524L34.769,21.524L35.385,21.524L36,21.524L36.615,21.524L37.231,21.524L37.846,21.524L38.462,21.524L39.077,21.524L39.692,21.524L40.308,21.524L40.923,21.524L41.538,21.524L42.154,21.524L42.769,21.524L43.385,21.524L44,17.46L44.615,17.46L45.231,17.46L45.846,17.46L46.462,17.46L47.077,17.46L47.692,26.175L48.308,26.175L48.923,26.175L49.538,26.857L50.154,26.857L50.769,26.857L51.385,26.857L52,26.857L52.615,26.857L53.231,26.857L53.846,26.857L54.462,26.857L55.077,26.857L55.692,26.857L56.308,26.857L56.923,26.857L57.538,26.857L58.154,26.857L58.769,26.857L59.385,26.857L60,26.857L60.615,26.857L61.231,26.857L61.846,26.857L62.462,26.857L63.077,26.857L63.692,26.857L64.308,26.857L64.923,26.857L65.538,26.857L66.154,26.857L66.769,26.857L67.385,26.857L68,26.857L68.615,26.857L69.231,26.857L69.846,26.857L70.462,26.857L71.077,26.857L71.692,26.857L72.308,26.857L72.923,26.857L73.538,26.857L74.154,26.857L74.769,26.857L75.385,22.287L76,22.287L76.615,22.287L77.231,22.346L77.846,22.346L78.462,22.346L79.077,22.346L79.692,22.346L80.308,22.351L80.923,22.351L81.538,22.351L82.154,22.352L82.769,22.356L83.385,22.356L84,22.356L84.615,22.356L85.231,27.405L85.846,27.405L86.462,27.405L87.077,27.403L87.692,27.403L88.308,27.403L88.923,27.403L89.538,27.403L90.154,27.403L90.769,27.403L91.385,27.403L92,27.403L92.615,27.403L93.231,27.968L93.846,27.968L94.462,27.968L95.077,27.968L95.692,27.968L96.308,27.968L96.923,27.968L97.538,27.968L98.154,27.968L98.769,27.968L99.385,27.968L100,27.968L100.615,27.968L101.231,27.968L101.846,26.857L102.462,26.857L103.077,26.857L103.692,31.937L104.308,31.937L104.923,30.89L105.538,31.419L106.154,31.419L106.769,31.419L107.385,31.419L108,31.419L108.615,31.35L109.231,31.349L109.846,31.349L110.462,31.349L111.077,31.349L111.692,31.349L112.308,31.444L112.923,31.444L113.538,31.444L114.154,31.444L114.769,31.966L115.385,31.956L116,31.956L116.615,31.956L117.231,31.956L117.846,31.956L118.462,31.956L119.077,31.956L119.692,31.956L120.308,31.956L120.923,31.956L121.538,31.956L122.154,31.956L122.769,31.956L123.385,31.956L124,31.956L124.615,31.956L125.231,31.956L125.846,31.956L126.462,31.956L127.077,31.956L127.692,31.956L128.308,31.311L128.923,31.311L129.538,31.312L130.154,31.312L130.769,31.312L131.385,31.312L132,31.312L132.615,31.312L133.231,31.313L133.846,31.333L134.462,31.333L135.077,32L135.692,32L136.308,32L136.923,32L137.538,32L138.154,32L138.769,32L139.385,32"/></svg>',
      },
      {
        articleId: "649443b2d67222393a8977fd",
        title: { en: "Methyl Sulfonyl Methane (MSM)" },
        subtitle: { en: "40-60 mesh, 0.5% Silicon Dioxide" },
        commodityPrice: { date: "Mon Nov 18 2024", price: 4.2 },
        change: -21.8,
        svg: '<svg xmlns="http://www.w3.org/2000/svg" width="160" height="40"> <path fill="none" stroke="#50cd89" stroke-width="1.5" d="M20,20L23.75,20L27.5,20L31.25,20L35,20L38.75,20L42.5,20L46.25,20L50,20L53.75,20L57.5,20L61.25,20L65,20L68.75,20L72.5,20L76.25,20L80,20L83.75,20L87.5,20L91.25,20L95,20L98.75,20L102.5,20L106.25,20L110,20L113.75,20L117.5,20L121.25,32L125,32L128.75,32L132.5,32L136.25,32"/></svg>',
      },
      {
        articleId: "6458ae695175287050a4cc4f",
        title: { en: "L-Citrulline Powder" },
        subtitle: { en: "99% L-Citrulline" },
        commodityPrice: { date: "Mon Nov 18 2024", price: 6.025 },
        change: -6.6,
        svg: '<svg xmlns="http://www.w3.org/2000/svg" width="160" height="40"> <path fill="none" stroke="#50cd89" stroke-width="1.5" d="M20,20L20.395,20L20.789,20L21.184,20L21.579,20L21.974,20L22.368,20L22.763,20L23.158,20L23.553,20L23.947,20L24.342,20L24.737,20L25.132,20L25.526,20L25.921,20L26.316,20L26.711,20L27.105,20L27.5,20L27.895,20L28.289,20L28.684,20L29.079,20L29.474,20L29.868,20L30.263,20L30.658,20L31.053,20L31.447,20L31.842,19.795L32.237,19.795L32.632,19.795L33.026,19.795L33.421,19.795L33.816,19.795L34.211,19.795L34.605,19.795L35,19.795L35.395,19.795L35.789,19.795L36.184,19.795L36.579,19.795L36.974,19.795L37.368,19.795L37.763,19.795L38.158,19.795L38.553,19.795L38.947,19.795L39.342,19.795L39.737,19.795L40.132,19.795L40.526,19.795L40.921,19.795L41.316,19.795L41.711,19.795L42.105,19.795L42.5,19.795L42.895,19.795L43.289,19.795L43.684,19.795L44.079,19.795L44.474,19.795L44.868,19.795L45.263,19.795L45.658,19.795L46.053,19.795L46.447,19.795L46.842,19.795L47.237,19.795L47.632,19.795L48.026,19.795L48.421,19.795L48.816,19.795L49.211,19.795L49.605,19.795L50,19.795L50.395,19.795L50.789,19.795L51.184,19.795L51.579,19.795L51.974,19.795L52.368,19.795L52.763,19.795L53.158,19.795L53.553,19.795L53.947,19.795L54.342,19.795L54.737,19.795L55.132,19.795L55.526,19.795L55.921,19.795L56.316,19.795L56.711,19.795L57.105,19.795L57.5,19.795L57.895,19.795L58.289,19.795L58.684,19.795L59.079,19.795L59.474,19.795L59.868,19.795L60.263,19.795L60.658,19.795L61.053,19.795L61.447,19.795L61.842,19.795L62.237,19.795L62.632,19.795L63.026,19.795L63.421,19.795L63.816,19.795L64.211,19.795L64.605,19.795L65,19.795L65.395,19.795L65.789,19.795L66.184,19.795L66.579,19.795L66.974,19.795L67.368,19.795L67.763,8L68.158,8L68.553,8L68.947,8L69.342,8L69.737,8L70.132,8L70.526,8L70.921,20.904L71.316,20.904L71.711,20.904L72.105,21.567L72.5,21.567L72.895,21.567L73.289,21.567L73.684,21.569L74.079,21.569L74.474,21.569L74.868,21.569L75.263,21.569L75.658,21.569L76.053,21.569L76.447,21.569L76.842,21.569L77.237,21.569L77.632,21.569L78.026,21.662L78.421,21.662L78.816,21.662L79.211,21.662L79.605,21.662L80,21.662L80.395,21.662L80.789,21.662L81.184,21.662L81.579,21.662L81.974,21.662L82.368,21.662L82.763,21.663L83.158,21.663L83.553,21.663L83.947,21.663L84.342,21.663L84.737,21.663L85.132,21.663L85.526,21.664L85.921,21.664L86.316,21.664L86.711,21.664L87.105,21.664L87.5,21.664L87.895,21.664L88.289,21.664L88.684,21.664L89.079,21.566L89.474,21.566L89.868,21.566L90.263,21.566L90.658,21.566L91.053,21.566L91.447,21.566L91.842,21.566L92.237,21.566L92.632,21.566L93.026,21.566L93.421,21.566L93.816,21.566L94.211,21.566L94.605,21.566L95,21.566L95.395,21.566L95.789,21.566L96.184,21.566L96.579,21.566L96.974,21.566L97.368,21.566L97.763,21.566L98.158,21.566L98.553,21.566L98.947,21.566L99.342,21.566L99.737,21.566L100.132,21.566L100.526,21.566L100.921,21.566L101.316,21.566L101.711,21.566L102.105,21.658L102.5,21.658L102.895,21.658L103.289,21.658L103.684,21.658L104.079,21.658L104.474,21.658L104.868,21.658L105.263,21.658L105.658,21.658L106.053,21.658L106.447,21.658L106.842,21.658L107.237,21.658L107.632,21.658L108.026,21.658L108.421,21.658L108.816,21.658L109.211,21.658L109.605,21.658L110,21.658L110.395,21.658L110.789,21.658L111.184,21.658L111.579,21.658L111.974,21.658L112.368,21.658L112.763,21.658L113.158,21.658L113.553,21.658L113.947,21.658L114.342,21.658L114.737,21.658L115.132,21.658L115.526,21.658L115.921,21.658L116.316,21.658L116.711,21.658L117.105,21.658L117.5,21.658L117.895,21.658L118.289,21.658L118.684,21.658L119.079,21.658L119.474,21.658L119.868,21.658L120.263,21.658L120.658,21.658L121.053,21.658L121.447,21.658L121.842,21.658L122.237,21.658L122.632,21.658L123.026,21.658L123.421,21.658L123.816,21.658L124.211,21.658L124.605,21.658L125,21.658L125.395,21.658L125.789,21.658L126.184,21.658L126.579,21.658L126.974,21.658L127.368,21.658L127.763,21.658L128.158,21.658L128.553,21.658L128.947,21.658L129.342,21.658L129.737,21.658L130.132,21.658L130.526,21.658L130.921,21.658L131.316,21.658L131.711,21.658L132.105,21.658L132.5,21.658L132.895,21.658L133.289,21.658L133.684,21.658L134.079,21.658L134.474,21.658L134.868,21.658L135.263,21.658L135.658,21.658L136.053,21.746L136.447,21.746L136.842,21.746L137.237,21.746L137.632,21.746L138.026,21.746L138.421,21.746L138.816,21.746L139.211,21.746L139.605,21.746"/></svg>',
      },
      {
        articleId: "6458ae695175287050a4cfd2",
        title: { en: "Magnesium Bisglycinate Powder 20%" },
        subtitle: { en: "" },
        commodityPrice: { date: "Wed Aug 21 2024", price: 6.173964843749999 },
        change: 3.1,
        svg: '<svg xmlns="http://www.w3.org/2000/svg" width="160" height="40"> <path fill="none" stroke="#f1416c" stroke-width="1.5" d="M20,20L20.331,20L20.663,20L20.994,20L21.326,20L21.657,20L21.989,20L22.32,20L22.652,20L22.983,20L23.315,20L23.646,20L23.978,19.992L24.309,19.899L24.641,19.899L24.972,19.899L25.304,19.899L25.635,19.899L25.967,19.899L26.298,19.899L26.63,19.899L26.961,19.899L27.293,19.899L27.624,19.899L27.956,19.899L28.287,19.899L28.619,19.899L28.95,19.899L29.282,19.899L29.613,19.899L29.945,19.869L30.276,19.869L30.608,19.869L30.939,19.869L31.271,19.869L31.602,19.869L31.934,19.869L32.265,19.869L32.597,19.869L32.928,19.869L33.26,19.869L33.591,19.869L33.923,19.869L34.254,19.869L34.586,19.869L34.917,19.869L35.249,19.869L35.58,19.869L35.912,19.869L36.243,19.869L36.575,19.869L36.906,19.869L37.238,19.869L37.569,19.869L37.901,19.869L38.232,8L38.564,8L38.895,8L39.227,8L39.558,8L39.89,8L40.221,8.106L40.552,8.106L40.884,8.106L41.215,8.106L41.547,8.106L41.878,8.106L42.21,8.106L42.541,8.106L42.873,8.106L43.204,8.106L43.536,8.106L43.867,8.106L44.199,8.106L44.53,8.106L44.862,8.106L45.193,8.106L45.525,8.106L45.856,8.106L46.188,8.106L46.519,8.106L46.851,8.106L47.182,8.106L47.514,8.106L47.845,8.106L48.177,8.106L48.508,8.106L48.84,8.106L49.171,8.106L49.503,8.106L49.834,8.106L50.166,8.106L50.497,8.106L50.829,8.106L51.16,8.106L51.492,8.106L51.823,8.106L52.155,8.106L52.486,8.106L52.818,8.106L53.149,8.106L53.481,8.106L53.812,8.106L54.144,8.106L54.475,8.106L54.807,8.106L55.138,8.106L55.47,8.106L55.801,8.106L56.133,8.106L56.464,8.106L56.796,8.118L57.127,8.118L57.459,8.118L57.79,8.118L58.122,8.118L58.453,8.118L58.785,8.118L59.116,8.118L59.448,8.118L59.779,16.875L60.11,16.875L60.442,16.875L60.773,16.875L61.105,16.875L61.436,16.875L61.768,16.875L62.099,16.875L62.431,16.875L62.762,16.875L63.094,16.875L63.425,16.875L63.757,16.875L64.088,16.875L64.42,16.875L64.751,16.875L65.083,16.875L65.414,16.875L65.746,16.875L66.077,16.875L66.409,16.875L66.74,16.875L67.072,16.875L67.403,16.875L67.735,16.875L68.066,16.875L68.398,16.875L68.729,16.875L69.061,16.875L69.392,16.875L69.724,16.875L70.055,16.875L70.387,16.875L70.718,16.875L71.05,16.875L71.381,16.875L71.713,16.875L72.044,16.875L72.376,16.875L72.707,16.875L73.039,16.875L73.37,16.875L73.702,16.875L74.033,16.875L74.365,16.875L74.696,16.875L75.028,16.875L75.359,16.875L75.691,16.875L76.022,16.875L76.354,16.875L76.685,16.875L77.017,16.875L77.348,16.875L77.68,16.875L78.011,16.875L78.343,16.875L78.674,16.875L79.006,16.875L79.337,16.875L79.669,16.875L80,16.875L80.331,16.875L80.663,16.875L80.994,16.875L81.326,16.875L81.657,16.875L81.989,16.875L82.32,16.875L82.652,16.875L82.983,16.875L83.315,16.875L83.646,16.875L83.978,16.875L84.309,16.875L84.641,16.875L84.972,16.875L85.304,16.875L85.635,16.875L85.967,16.875L86.298,16.875L86.63,16.875L86.961,16.875L87.293,16.875L87.624,16.875L87.956,16.875L88.287,16.875L88.619,16.875L88.95,16.875L89.282,16.875L89.613,16.875L89.945,16.875L90.276,16.875L90.608,16.875L90.939,16.875L91.271,16.875L91.602,16.875L91.934,16.875L92.265,16.875L92.597,16.875L92.928,16.875L93.26,16.878L93.591,16.878L93.923,16.878L94.254,16.878L94.586,16.878L94.917,16.878L95.249,16.878L95.58,16.878L95.912,16.878L96.243,16.878L96.575,16.878L96.906,16.878L97.238,16.878L97.569,16.878L97.901,16.878L98.232,16.875L98.564,16.875L98.895,19.21L99.227,19.216L99.558,19.216L99.89,19.216L100.221,19.216L100.552,19.216L100.884,19.216L101.215,19.216L101.547,19.216L101.878,19.216L102.21,19.216L102.541,19.216L102.873,19.216L103.204,19.216L103.536,20.16L103.867,20.16L104.199,20.16L104.53,20.16L104.862,20.16L105.193,20.16L105.525,20.16L105.856,20.16L106.188,20.16L106.519,20.16L106.851,20.16L107.182,20.16L107.514,20.16L107.845,20.16L108.177,20.16L108.508,20.16L108.84,20.16L109.171,20.16L109.503,20.16L109.834,20.16L110.166,20.16L110.497,20.16L110.829,20.16L111.16,20.16L111.492,20.16L111.823,20.16L112.155,20.16L112.486,20.16L112.818,20.16L113.149,20.16L113.481,20.16L113.812,20.16L114.144,20.16L114.475,20.16L114.807,20.16L115.138,20.16L115.47,20.16L115.801,20.16L116.133,20.16L116.464,20.16L116.796,20.16L117.127,20.16L117.459,20.16L117.79,20.16L118.122,20.16L118.453,20.16L118.785,20.16L119.116,20.16L119.448,20.16L119.779,20.16L120.11,20.16L120.442,20.16L120.773,20.16L121.105,20.16L121.436,20.16L121.768,20.525L122.099,20.525L122.431,20.525L122.762,20.525L123.094,20.525L123.425,20.525L123.757,20.525L124.088,20.525L124.42,20.525L124.751,20.525L125.083,20.525L125.414,20.525L125.746,20.525L126.077,20.525L126.409,20.525L126.74,20.525L127.072,20.525L127.403,20.525L127.735,20.525L128.066,20.525L128.398,20.525L128.729,20.525L129.061,20.525L129.392,20.525L129.724,20.525L130.055,20.525L130.387,20.525L130.718,20.525L131.05,20.525L131.381,20.525L131.713,20.525L132.044,20.525L132.376,20.525L132.707,20.525L133.039,19.197L133.37,19.197L133.702,19.197L134.033,19.197L134.365,19.197L134.696,19.197L135.028,19.197L135.359,19.197L135.691,19.197L136.022,19.197L136.354,19.197L136.685,19.197L137.017,19.197L137.348,19.197L137.68,19.197L138.011,19.197L138.343,19.197L138.674,19.197L139.006,19.197L139.337,19.197L139.669,19.197"/></svg>',
      },
      {
        articleId: "645cf5e1329034f1aee8c80e",
        title: { en: "Zinc Bisglycinate Powder" },
        subtitle: { en: "20% Zinc" },
        commodityPrice: { date: "Mon Nov 18 2024", price: 9.08681640625 },
        change: 0.2,
        svg: '<svg xmlns="http://www.w3.org/2000/svg" width="160" height="40"> <path fill="none" stroke="#f1416c" stroke-width="1.5" d="M20,20L20.351,20L20.702,20L21.053,20L21.404,19.935L21.754,19.935L22.105,19.935L22.456,19.935L22.807,19.935L23.158,19.935L23.509,19.935L23.86,19.935L24.211,19.935L24.561,19.935L24.912,19.935L25.263,19.935L25.614,19.935L25.965,19.935L26.316,19.935L26.667,19.935L27.018,19.935L27.368,19.935L27.719,19.935L28.07,19.935L28.421,19.935L28.772,19.935L29.123,19.935L29.474,19.935L29.825,19.935L30.175,19.935L30.526,19.935L30.877,19.935L31.228,19.935L31.579,19.935L31.93,19.935L32.281,19.935L32.632,19.935L32.982,19.935L33.333,19.935L33.684,19.935L34.035,19.935L34.386,19.935L34.737,19.935L35.088,19.935L35.439,19.935L35.789,19.935L36.14,19.935L36.491,19.935L36.842,19.935L37.193,19.935L37.544,19.935L37.895,19.935L38.246,19.935L38.596,19.935L38.947,19.935L39.298,19.935L39.649,19.935L40,19.935L40.351,19.935L40.702,19.935L41.053,19.935L41.404,19.935L41.754,19.935L42.105,19.935L42.456,19.935L42.807,19.935L43.158,19.935L43.509,19.935L43.86,19.935L44.211,19.935L44.561,19.935L44.912,19.935L45.263,19.935L45.614,19.935L45.965,19.935L46.316,19.935L46.667,19.935L47.018,19.935L47.368,19.935L47.719,19.935L48.07,19.935L48.421,19.935L48.772,19.935L49.123,19.935L49.474,19.935L49.825,19.935L50.175,19.935L50.526,19.935L50.877,19.935L51.228,19.935L51.579,19.935L51.93,19.935L52.281,19.935L52.632,19.935L52.982,19.935L53.333,19.935L53.684,19.935L54.035,19.935L54.386,19.935L54.737,19.935L55.088,19.935L55.439,19.935L55.789,19.935L56.14,19.935L56.491,19.935L56.842,19.935L57.193,19.935L57.544,19.935L57.895,19.935L58.246,19.935L58.596,19.935L58.947,19.935L59.298,19.935L59.649,19.935L60,19.935L60.351,19.935L60.702,19.935L61.053,19.935L61.404,19.935L61.754,19.935L62.105,19.935L62.456,19.935L62.807,19.935L63.158,19.935L63.509,19.935L63.86,19.935L64.211,19.935L64.561,19.935L64.912,19.935L65.263,19.935L65.614,19.935L65.965,19.935L66.316,19.935L66.667,19.935L67.018,19.935L67.368,19.935L67.719,19.935L68.07,19.935L68.421,19.935L68.772,19.935L69.123,19.935L69.474,19.935L69.825,19.935L70.175,19.935L70.526,19.935L70.877,19.935L71.228,19.935L71.579,19.935L71.93,19.935L72.281,19.935L72.632,19.935L72.982,19.935L73.333,19.935L73.684,19.935L74.035,19.935L74.386,19.935L74.737,19.935L75.088,19.935L75.439,19.935L75.789,19.935L76.14,19.935L76.491,19.935L76.842,19.935L77.193,19.935L77.544,19.935L77.895,19.935L78.246,19.935L78.596,19.935L78.947,19.935L79.298,19.935L79.649,19.935L80,19.935L80.351,19.935L80.702,19.935L81.053,19.935L81.404,19.935L81.754,19.935L82.105,19.935L82.456,19.935L82.807,19.935L83.158,19.935L83.509,19.935L83.86,19.935L84.211,19.935L84.561,19.935L84.912,19.935L85.263,19.935L85.614,19.935L85.965,19.935L86.316,19.935L86.667,19.935L87.018,19.935L87.368,19.935L87.719,19.935L88.07,19.935L88.421,19.935L88.772,19.935L89.123,19.935L89.474,19.935L89.825,19.935L90.175,19.935L90.526,19.935L90.877,19.935L91.228,19.935L91.579,19.935L91.93,19.935L92.281,19.935L92.632,19.935L92.982,19.935L93.333,19.935L93.684,19.935L94.035,19.935L94.386,19.935L94.737,19.935L95.088,19.935L95.439,19.935L95.789,19.935L96.14,19.935L96.491,19.935L96.842,19.935L97.193,19.935L97.544,19.935L97.895,19.935L98.246,19.935L98.596,19.935L98.947,19.935L99.298,19.935L99.649,19.935L100,19.935L100.351,19.935L100.702,19.935L101.053,19.935L101.404,19.935L101.754,19.935L102.105,19.935L102.456,19.935L102.807,32L103.158,32L103.509,32L103.86,32L104.211,32L104.561,32L104.912,32L105.263,32L105.614,32L105.965,32L106.316,32L106.667,32L107.018,32L107.368,32L107.719,32L108.07,32L108.421,32L108.772,32L109.123,32L109.474,32L109.825,32L110.175,32L110.526,32L110.877,32L111.228,32L111.579,32L111.93,32L112.281,32L112.632,32L112.982,32L113.333,32L113.684,32L114.035,32L114.386,32L114.737,32L115.088,32L115.439,19.947L115.789,19.947L116.14,19.947L116.491,19.947L116.842,19.947L117.193,19.947L117.544,19.947L117.895,19.947L118.246,19.947L118.596,19.947L118.947,19.947L119.298,19.947L119.649,19.947L120,19.947L120.351,19.947L120.702,19.947L121.053,19.947L121.404,19.947L121.754,19.947L122.105,19.947L122.456,19.947L122.807,19.947L123.158,19.947L123.509,19.947L123.86,19.947L124.211,19.947L124.561,19.947L124.912,19.947L125.263,19.947L125.614,19.947L125.965,19.947L126.316,19.947L126.667,19.947L127.018,19.947L127.368,19.947L127.719,19.947L128.07,19.947L128.421,19.947L128.772,19.947L129.123,19.947L129.474,19.947L129.825,19.947L130.175,19.947L130.526,19.947L130.877,19.947L131.228,19.947L131.579,19.947L131.93,19.947L132.281,19.947L132.632,19.947L132.982,19.947L133.333,19.947L133.684,19.947L134.035,19.947L134.386,19.947L134.737,19.947L135.088,19.947L135.439,19.947L135.789,19.947L136.14,19.947L136.491,19.947L136.842,19.947L137.193,19.947L137.544,19.947L137.895,19.947L138.246,19.947L138.596,19.947L138.947,19.947L139.298,19.947L139.649,19.947"/></svg>',
      },
      {
        articleId: "66e15472be6cd2f6f7e1fd28",
        title: { en: "Maca Extract" },
        subtitle: { en: "40:1; Lepidium meyenii Walp; Root" },
        commodityPrice: { date: "Wed Oct 09 2024", price: 32 },
        change: 0,
        svg: '<svg xmlns="http://www.w3.org/2000/svg" width="160" height="40"> <path fill="none" stroke="#a1a5b7" stroke-width="1.5" d="M20,20L24,20L28,20L32,20L36,20L40,20L44,20L48,20L52,20L56,20L60,20L64,20L68,20L72,20L76,20L80,20L84,20L88,20L92,20L96,20L100,20L104,20L108,20L112,20L116,20L120,20L124,20L128,20L132,20L136,20"/></svg>',
      },
      {
        articleId: "6458ae695175287050a4cde1",
        title: { en: "Grape Seed Extract" },
        subtitle: { en: "70% OPC; Vitis vinifera L.; Seed" },
        commodityPrice: {
          date: "Tue Nov 19 2024",
          price: 17.495859375000002,
        },
        change: 16.6,
        svg: '<svg xmlns="http://www.w3.org/2000/svg" width="160" height="40"> <path fill="none" stroke="#f1416c" stroke-width="1.5" d="M20,20L20.309,20L20.619,20L20.928,20L21.237,20L21.546,20L21.856,20L22.165,20L22.474,20L22.784,20L23.093,20L23.402,20L23.711,20L24.021,20L24.33,20L24.639,20L24.948,20L25.258,20L25.567,20L25.876,20L26.186,20L26.495,20L26.804,20L27.113,20L27.423,20L27.732,20L28.041,20L28.351,20L28.66,20L28.969,20L29.278,20L29.588,20L29.897,20L30.206,20L30.515,20L30.825,20L31.134,20L31.443,20L31.753,20L32.062,20L32.371,20L32.68,20L32.99,20L33.299,20L33.608,20L33.918,20L34.227,20L34.536,20L34.845,20L35.155,20L35.464,20L35.773,20L36.082,20L36.392,20L36.701,20L37.01,20L37.32,20L37.629,20L37.938,20L38.247,20L38.557,20L38.866,20L39.175,20L39.485,20L39.794,20L40.103,20L40.412,20L40.722,20L41.031,20L41.34,20L41.649,20L41.959,20L42.268,20L42.577,20L42.887,20L43.196,20L43.505,20L43.814,20L44.124,20L44.433,20L44.742,20L45.052,20L45.361,20L45.67,20L45.979,20L46.289,20L46.598,20L46.907,20L47.216,20L47.526,20L47.835,20L48.144,20L48.454,20L48.763,20L49.072,20L49.381,20L49.691,20L50,20L50.309,20L50.619,20L50.928,20L51.237,20L51.546,20L51.856,20L52.165,20L52.474,20L52.784,20L53.093,20L53.402,20L53.711,20L54.021,20L54.33,20L54.639,20L54.948,20L55.258,20L55.567,20L55.876,20L56.186,20L56.495,20L56.804,20L57.113,20L57.423,20L57.732,20L58.041,20L58.351,20L58.66,20L58.969,20L59.278,20L59.588,20L59.897,20L60.206,20L60.515,20L60.825,20L61.134,20L61.443,20L61.753,20L62.062,20L62.371,20L62.68,20L62.99,20L63.299,20L63.608,20L63.918,20L64.227,20L64.536,20L64.845,20L65.155,20L65.464,20L65.773,20L66.082,20L66.392,20L66.701,20L67.01,20L67.32,20L67.629,20L67.938,20L68.247,20L68.557,20L68.866,20L69.175,20L69.485,20.021L69.794,20.021L70.103,20.021L70.412,20.021L70.722,20.021L71.031,20.021L71.34,20.021L71.649,20.021L71.959,20.021L72.268,20.021L72.577,20.021L72.887,20.021L73.196,20.021L73.505,20.021L73.814,20.021L74.124,20.021L74.433,20.021L74.742,20.021L75.052,20.021L75.361,20.021L75.67,20.021L75.979,20.021L76.289,20.021L76.598,20.021L76.907,20.021L77.216,20.021L77.526,20.021L77.835,20.021L78.144,20.021L78.454,20.021L78.763,13.437L79.072,13.437L79.381,13.437L79.691,13.437L80,13.437L80.309,13.437L80.619,13.437L80.928,13.437L81.237,13.437L81.546,13.437L81.856,13.437L82.165,13.437L82.474,13.437L82.784,13.437L83.093,13.437L83.402,12.569L83.711,12.569L84.021,12.569L84.33,12.569L84.639,12.569L84.948,12.569L85.258,12.569L85.567,12.569L85.876,12.569L86.186,12.569L86.495,12.569L86.804,12.569L87.113,12.569L87.423,12.569L87.732,12.569L88.041,12.569L88.351,12.569L88.66,12.569L88.969,12.569L89.278,12.569L89.588,12.569L89.897,12.569L90.206,12.569L90.515,12.569L90.825,12.569L91.134,12.569L91.443,12.569L91.753,12.569L92.062,12.569L92.371,12.569L92.68,12.569L92.99,12.569L93.299,12.569L93.608,12.569L93.918,10.784L94.227,10.784L94.536,10.784L94.845,10.784L95.155,10.784L95.464,10.784L95.773,10.784L96.082,10.784L96.392,10.784L96.701,10.784L97.01,10.784L97.32,10.784L97.629,10.784L97.938,10.784L98.247,10.784L98.557,10.784L98.866,10.784L99.175,10.784L99.485,10.784L99.794,10.784L100.103,10.784L100.412,10.784L100.722,10.784L101.031,10.784L101.34,10.784L101.649,10.784L101.959,10.784L102.268,10.784L102.577,10.784L102.887,10.784L103.196,10.784L103.505,10.784L103.814,10.784L104.124,10.784L104.433,10.784L104.742,10.784L105.052,10.784L105.361,10.784L105.67,10.784L105.979,10.784L106.289,10.784L106.598,10.784L106.907,10.784L107.216,10.784L107.526,10.784L107.835,10.784L108.144,10.784L108.454,10.784L108.763,10.784L109.072,10.784L109.381,10.784L109.691,10.784L110,10.784L110.309,10.784L110.619,10.784L110.928,10.784L111.237,10.784L111.546,12.569L111.856,12.569L112.165,12.569L112.474,12.569L112.784,12.569L113.093,12.569L113.402,12.569L113.711,12.569L114.021,12.569L114.33,12.569L114.639,12.569L114.948,12.569L115.258,12.569L115.567,12.569L115.876,12.569L116.186,12.569L116.495,12.569L116.804,12.569L117.113,12.569L117.423,12.569L117.732,12.569L118.041,12.569L118.351,12.569L118.66,12.569L118.969,12.569L119.278,12.569L119.588,12.569L119.897,12.569L120.206,12.569L120.515,12.569L120.825,12.569L121.134,12.569L121.443,12.569L121.753,12.569L122.062,12.569L122.371,12.569L122.68,12.569L122.99,12.569L123.299,12.569L123.608,12.569L123.918,12.569L124.227,12.569L124.536,12.569L124.845,12.569L125.155,12.569L125.464,10.784L125.773,10.784L126.082,10.784L126.392,10.784L126.701,10.784L127.01,10.784L127.32,10.784L127.629,10.784L127.938,10.784L128.247,10.784L128.557,10.784L128.866,10.784L129.175,10.784L129.485,10.784L129.794,10.784L130.103,10.784L130.412,10.784L130.722,10.784L131.031,10.784L131.34,10.784L131.649,10.784L131.959,10.784L132.268,10.784L132.577,10.784L132.887,10.784L133.196,10.784L133.505,10.784L133.814,8L134.124,8L134.433,8L134.742,8L135.052,8L135.361,8L135.67,8L135.979,8L136.289,8L136.598,8L136.907,8L137.216,8L137.526,8L137.835,8L138.144,8L138.454,8L138.763,8L139.072,8L139.381,8L139.691,10.784"/></svg>',
      },
      {
        articleId: "6458ae695175287050a4d03e",
        title: { en: "Vitamin D3 Powder" },
        subtitle: { en: "100.000 IU/g" },
        commodityPrice: { date: "Mon Nov 18 2024", price: 23.096875 },
        change: 168.8,
        svg: '<svg xmlns="http://www.w3.org/2000/svg" width="160" height="40"> <path fill="none" stroke="#f1416c" stroke-width="1.5" d="M20,20L20.293,20L20.587,20L20.88,20L21.174,20L21.467,20L21.76,20L22.054,20L22.347,20L22.641,20L22.934,20L23.227,20L23.521,20L23.814,20L24.108,20L24.401,20L24.694,20L24.988,20L25.281,20L25.575,20L25.868,20L26.161,20L26.455,20L26.748,20L27.042,20L27.335,20L27.628,20L27.922,20L28.215,20L28.509,20L28.802,20L29.095,20L29.389,20L29.682,20L29.976,20L30.269,20L30.562,20L30.856,20L31.149,20L31.443,20L31.736,20L32.029,20L32.323,20L32.616,20L32.91,20L33.203,20L33.496,20L33.79,20L34.083,20L34.377,20L34.67,20L34.963,20L35.257,20L35.55,20L35.844,20L36.137,20L36.43,20L36.724,20L37.017,20L37.311,20L37.604,20L37.897,20L38.191,20L38.484,20L38.778,20L39.071,20L39.364,20L39.658,20L39.951,20L40.244,20L40.538,20L40.831,20L41.125,20L41.418,20L41.711,20L42.005,20L42.298,20L42.592,20L42.885,20L43.178,20L43.472,20L43.765,20L44.059,20L44.352,20L44.645,20L44.939,20L45.232,20L45.526,20L45.819,20L46.112,20L46.406,20L46.699,20L46.993,20L47.286,20L47.579,20L47.873,20L48.166,20L48.46,20L48.753,20L49.046,20L49.34,20L49.633,20L49.927,20L50.22,20L50.513,20L50.807,20L51.1,20L51.394,20L51.687,20L51.98,20L52.274,20L52.567,20L52.861,20L53.154,20L53.447,20L53.741,20L54.034,20L54.328,20L54.621,20L54.914,20L55.208,20L55.501,20L55.795,20L56.088,20L56.381,20L56.675,20L56.968,20L57.262,20L57.555,20L57.848,20L58.142,20L58.435,20L58.729,20L59.022,20L59.315,20L59.609,20L59.902,20L60.196,20L60.489,20L60.782,20L61.076,20L61.369,20L61.663,20L61.956,20L62.249,20L62.543,20L62.836,20L63.13,20L63.423,20.125L63.716,20.125L64.01,20.125L64.303,20.125L64.597,20.125L64.89,20.125L65.183,20.125L65.477,20.125L65.77,20.125L66.064,20.125L66.357,20.125L66.65,20.125L66.944,20.125L67.237,20.125L67.531,20.125L67.824,20.125L68.117,20.125L68.411,20L68.704,20L68.998,20L69.291,20L69.584,20L69.878,20L70.171,20L70.465,20L70.758,20L71.051,20L71.345,20L71.638,20.125L71.932,20.125L72.225,20.125L72.518,20.125L72.812,20.125L73.105,20.125L73.399,20.125L73.692,20.125L73.985,20.125L74.279,20.125L74.572,20.125L74.866,20.125L75.159,20.125L75.452,20.125L75.746,20.125L76.039,20.125L76.333,20.125L76.626,20.125L76.919,20.125L77.213,20.125L77.506,20.125L77.8,20.125L78.093,20.125L78.386,20.125L78.68,20.125L78.973,20.125L79.267,20.125L79.56,20.125L79.853,20.125L80.147,20.125L80.44,20.125L80.733,20.125L81.027,20.125L81.32,20.125L81.614,20.125L81.907,20.125L82.2,20.125L82.494,20.125L82.787,20.125L83.081,20.125L83.374,20.125L83.667,20.125L83.961,20.125L84.254,20.125L84.548,20.125L84.841,20.125L85.134,20.125L85.428,20.125L85.721,20.125L86.015,20.125L86.308,20.125L86.601,20.125L86.895,20.125L87.188,20.125L87.482,20.125L87.775,20.125L88.068,20.125L88.362,20.125L88.655,20.126L88.949,20.126L89.242,20.126L89.535,20.126L89.829,20.126L90.122,20.126L90.416,20.126L90.709,20.126L91.002,20.126L91.296,20.132L91.589,20.132L91.883,20.132L92.176,20.132L92.469,20.132L92.763,20.132L93.056,20.132L93.35,20.132L93.643,20.132L93.936,20.132L94.23,20.132L94.523,20.132L94.817,20.132L95.11,20.132L95.403,20.235L95.697,20.235L95.99,20.235L96.284,20.235L96.577,20.235L96.87,20.235L97.164,20.235L97.457,20.235L97.751,20.235L98.044,20.235L98.337,20.235L98.631,20.235L98.924,20.235L99.218,20.235L99.511,20.235L99.804,20.235L100.098,20.235L100.391,20.235L100.685,20.235L100.978,20.235L101.271,20.235L101.565,20.235L101.858,20.235L102.152,20.235L102.445,20.235L102.738,20.235L103.032,20.235L103.325,20.235L103.619,20.235L103.912,20.128L104.205,20.128L104.499,20.134L104.792,20.134L105.086,20.134L105.379,20.134L105.672,20.134L105.966,20.134L106.259,20.134L106.553,20.134L106.846,20.134L107.139,20.134L107.433,20.134L107.726,20.134L108.02,20.134L108.313,20.134L108.606,20.235L108.9,20.235L109.193,20.235L109.487,20.235L109.78,20.235L110.073,20.235L110.367,20.235L110.66,20.235L110.954,20.235L111.247,20.235L111.54,20.235L111.834,20.235L112.127,20.235L112.421,20.235L112.714,20.235L113.007,20.235L113.301,20.235L113.594,20.235L113.888,20.235L114.181,20.235L114.474,20.235L114.768,17.104L115.061,17.104L115.355,17.104L115.648,17.104L115.941,17.104L116.235,17.104L116.528,17.104L116.822,17.104L117.115,17.104L117.408,17.104L117.702,17.104L117.995,17.104L118.289,17.104L118.582,17.104L118.875,17.104L119.169,17.104L119.462,17.104L119.756,17.104L120.049,17.104L120.342,17.104L120.636,17.104L120.929,17.104L121.222,17.104L121.516,17.104L121.809,12.479L122.103,12.479L122.396,12.479L122.689,12.479L122.983,12.479L123.276,12.484L123.57,12.484L123.863,12.484L124.156,12.484L124.45,12.605L124.743,12.605L125.037,12.605L125.33,12.605L125.623,12.605L125.917,12.605L126.21,12.605L126.504,12.605L126.797,12.605L127.09,12.605L127.384,12.605L127.677,12.605L127.971,12.605L128.264,12.605L128.557,12.605L128.851,12.605L129.144,12.605L129.438,12.605L129.731,12.605L130.024,12.605L130.318,12.605L130.611,12.605L130.905,12.605L131.198,12.605L131.491,12.605L131.785,12.605L132.078,12.605L132.372,12.605L132.665,12.605L132.958,12.605L133.252,12.605L133.545,12.605L133.839,12.605L134.132,12.605L134.425,12.605L134.719,12.605L135.012,8L135.306,8L135.599,8L135.892,8L136.186,8L136.479,8.676L136.773,8.676L137.066,8.676L137.359,8.676L137.653,8.676L137.946,8.676L138.24,8.676L138.533,8.749L138.826,8.749L139.12,8.749L139.413,8.749L139.707,8.749"/></svg>',
      },
    ],
    commodities: [
      [
        {
          _id: "640ecbf6d8d80ea33c78cec7",
          title: { en: "Creatine Monohydrate Powder 200mesh" },
          subtitle: { en: "" },
        },
        {
          _id: "640ecbf6d8d80ea33c78d068",
          title: { en: "Maca Extract " },
          subtitle: { en: "10:1; Lepidium meyenii Walp; Root" },
        },
        {
          _id: "6458ae695175287050a4d002",
          title: { en: "3.3’ Diindolylmethane Powder" },
          subtitle: { en: "99% 3.3'-Diindolylmethane" },
        },
        {
          _id: "6458ae695175287050a4cc8d",
          title: { en: "Acacia Gum Powder" },
          subtitle: { en: "Acacia Senegal; Gum" },
        },
        {
          _id: "6458ae695175287050a4cc8f",
          title: { en: "Acai Extract" },
          subtitle: { en: "4:1; Euterpe oleracea; Fruit" },
        },
        {
          _id: "645cf5e0329034f1aee8c629",
          title: { en: "Acai Extract" },
          subtitle: { en: "10:1; Euterpe oleracea; Fruit" },
        },
        {
          _id: "6458ae695175287050a4cc93",
          title: { en: "Acerola Extract - added" },
          subtitle: { en: "25% Vitamin C; Malpighia glabra L.; Fruit" },
        },
        {
          _id: "6458ae695175287050a4cc97",
          title: { en: "African Mango Extract" },
          subtitle: { en: "10:1; Irvingia Gabonensis; Seed" },
        },
        {
          _id: "6458ae695175287050a4cf44",
          title: { en: "Agaricus Extract" },
          subtitle: { en: "30% Polysaccharides; Agaricus Blazei; Fruit Body" },
        },
        {
          _id: "6458ae695175287050a4cc9b",
          title: { en: "Alfalfa Extract" },
          subtitle: { en: "10% Chlorophyllin; Medicago Sativa; Herb" },
        },
        {
          _id: "6458ae695175287050a4cff0",
          title: { en: "Almond Flour" },
          subtitle: { en: "55% Protein; Fruit" },
        },
        {
          _id: "645cf5e0329034f1aee8c632",
          title: { en: "Almond Extract" },
          subtitle: { en: "10% Polysaccharides; Prunus armeniaca; Seed" },
        },
        {
          _id: "6458ae695175287050a4cc9f",
          title: { en: "Aloe Leaf Extract" },
          subtitle: { en: "10:1; Aloe Vera; Stem" },
        },
        {
          _id: "6458ae695175287050a4cc2e",
          title: { en: "Alpha Amylase Powder 50.000 SKB" },
          subtitle: { en: "Aspergillus Oryzae" },
        },
        {
          _id: "6458ae695175287050a4cc1c",
          title: { en: "Alpha Glycerylphosphorylcholine (GPC) Powder" },
          subtitle: { en: "98% Alpha-GPC" },
        },
        {
          _id: "6458ae695175287050a4cc1e",
          title: { en: "Alpha Lipoic Acid Powder" },
          subtitle: { en: "" },
        },
        {
          _id: "6458ae695175287050a4cca5",
          title: { en: "Amla Extract" },
          subtitle: { en: "25% Vitamin C; Phyllanthus Emblica L.; Fruit" },
        },
        {
          _id: "6458ae695175287050a4cca9",
          title: { en: "Angelica Extract" },
          subtitle: { en: "1% Ligustilide; Angelica sinensis Diels; Root" },
        },
        {
          _id: "6458ae695175287050a4ccb9",
          title: { en: "Aronia Extract" },
          subtitle: { en: "10:1; Aronia Melanocarpa; Fruit" },
        },
        {
          _id: "6458ae695175287050a4ccbd",
          title: { en: "Artemisia Annua Extract" },
          subtitle: { en: "30:1; Artemisia annua L.; Herb" },
        },
        {
          _id: "6458ae695175287050a4ccc1",
          title: { en: "Artichoke Extract" },
          subtitle: { en: "5% Cynarin; 7-10:1; Cynara scolymus L.; Leaf" },
        },
        {
          _id: "6458ae695175287050a4ccbf",
          title: { en: "Artichoke Extract" },
          subtitle: { en: "2.5% Cynarin; Cynara scolymus L.; Leaf" },
        },
        {
          _id: "6458ae695175287050a4ccc3",
          title: { en: "Ashwagandha Extract" },
          subtitle: { en: "5:1; Withania Somnifera; Whole plant" },
        },
        {
          _id: "645cf5e0329034f1aee8c63f",
          title: { en: "Ashwagandha Extract" },
          subtitle: { en: "5% Withanolide; 10:1; Withania Somnifera; Root" },
        },
        {
          _id: "645cf5e0329034f1aee8c641",
          title: { en: "Ashwagandha Extract" },
          subtitle: { en: "10% Withanolide; 25:1; Withania Somnifera; Root" },
        },
        {
          _id: "6458ae695175287050a4cf34",
          title: { en: "Astaxanthin Powder" },
          subtitle: { en: "5% Astaxanthin; Haematoccocus Pluvialis; Herb" },
        },
        {
          _id: "6458ae695175287050a4ccc5",
          title: { en: "Astragalus Extract" },
          subtitle: {
            en: "50% Polysaccharides; 10:1; Astragalus Membranaceus; Root",
          },
        },
        {
          _id: "645cf5e0329034f1aee8c646",
          title: { en: "Astragalus Extract" },
          subtitle: { en: "20% Polysaccharides; Astragalus Membranaceus; Root" },
        },
        {
          _id: "6458ae695175287050a4ccc7",
          title: { en: "Avocado Extract" },
          subtitle: { en: "10:1; Persea americana Mill; Fruit" },
        },
        {
          _id: "6458ae695175287050a4cccf",
          title: { en: "Banaba Extract" },
          subtitle: {
            en: "1% Corosolic Acid; 10:1; Lagerstroemia Speciosa; Lythraceae",
          },
        },
        {
          _id: "6458ae695175287050a4ccd1",
          title: { en: "Baobab Extract" },
          subtitle: { en: "10:1; Adansonia digitata L.; Fruit" },
        },
        {
          _id: "6458ae695175287050a4ccd5",
          title: { en: "Bayberry Extract" },
          subtitle: { en: "98% Myricetin; 120:1; Ampelopsis grossedentata; Leaf" },
        },
        {
          _id: "6458ae695175287050a4cc30",
          title: { en: "BCAA 2:1:1 Powder Instant (vegan)" },
          subtitle: { en: "50% L-Leucin, 25% L-Valin, 25% L-Isoleucin" },
        },
        {
          _id: "645cf5e0329034f1aee8c64d",
          title: { en: "BCAA 2:1:1 DC (granular)" },
          subtitle: { en: "50% L-Leucin, 25% L-Valin, 25% L-Isoleucin" },
        },
        {
          _id: "6458ae695175287050a4ccd7",
          title: { en: "Bearberry Extract" },
          subtitle: { en: "10:1; Arctostaphylos uva Ursi; Leaf" },
        },
        {
          _id: "6458ae695175287050a4ccdb",
          title: { en: "Beetroot Extract" },
          subtitle: { en: "4:1; Beta vulgaris L.; Root" },
        },
        {
          _id: "6458ae695175287050a4ccdd",
          title: { en: "Berberine Extract" },
          subtitle: {
            en: "97% Berberine Hydrochloride; Berberis Aristata, Berberis Vulgaris; Root",
          },
        },
        {
          _id: "6458ae695175287050a4ccdf",
          title: { en: "Berberine Extract Granular" },
          subtitle: {
            en: "97% Berberine Hydrochloride; Berberis Aristata, Berberis Vulgaris; Tree bark",
          },
        },
        {
          _id: "6458ae695175287050a4cce1",
          title: { en: "Citrus Bergamot Extract" },
          subtitle: { en: "4:1; Citrus Bergamia; Fruit" },
        },
        {
          _id: "645cf5e0329034f1aee8c654",
          title: { en: "Citrus Bergamot Extract" },
          subtitle: { en: "30% Polyphenols; 5:1; Citrus Bergamia; Fruit" },
        },
        {
          _id: "6458ae695175287050a4cc32",
          title: { en: "Beta Alanine Powder" },
          subtitle: { en: "" },
        },
        {
          _id: "6458ae695175287050a4cf42",
          title: { en: "Beta Carotene Powder - natural" },
          subtitle: { en: "10% Provitamin A" },
        },
        {
          _id: "6458ae695175287050a4cce3",
          title: { en: "Birch Extract" },
          subtitle: { en: "10:1; Betula pendula; Leaf" },
        },
        {
          _id: "6458ae695175287050a4cce7",
          title: { en: "Bitter Melon Extract" },
          subtitle: { en: "4:1; Momordica Charantia L.; Fruit" },
        },
        {
          _id: "6458ae695175287050a4cce5",
          title: { en: "Bitter Melon Extract" },
          subtitle: { en: "10% Charantin; Momordica Charantia L.; Fruit" },
        },
        {
          _id: "6458ae695175287050a4ccef",
          title: { en: "Bitter Orange Extract" },
          subtitle: { en: "98% Hesperidin; 15:1; Citrus Aurantium; Fruit" },
        },
        {
          _id: "6458ae695175287050a4cceb",
          title: { en: "Bitter Orange Extract" },
          subtitle: { en: "30% Synephrine; Citrus Aurantium; Fruit" },
        },
        {
          _id: "6458ae695175287050a4ccf9",
          title: { en: "Black Cohosh Extract" },
          subtitle: { en: "10:1; Actaea racemosa L; Root" },
        },
        {
          _id: "6458ae695175287050a4ccfb",
          title: { en: "Black Cumin Extract" },
          subtitle: { en: "10:1; Nigella sativa; Seed" },
        },
        {
          _id: "6458ae695175287050a4ccfd",
          title: { en: "Black Currant Extract" },
          subtitle: { en: "5:1; Ribes nigrum L.; Fruit" },
        },
        {
          _id: "6458ae695175287050a4ccff",
          title: { en: "Black Garlic Extract" },
          subtitle: { en: "15:1; Allium sativum L.; Bulb" },
        },
        {
          _id: "6458ae695175287050a4cd03",
          title: { en: "Bladderwrack Extract" },
          subtitle: { en: "10:1; Fucus Vesiculosus; whole Plant" },
        },
        {
          _id: "6458ae695175287050a4cd05",
          title: { en: "Blueberry Extract" },
          subtitle: {
            en: "10% Anthocyanidin; 10:1; Vaccinium Myrtillus L.; Berry",
          },
        },
        {
          _id: "6458ae695175287050a4cf48",
          title: { en: "Boletus Edulis Extract" },
          subtitle: { en: "10:1; Boletus Edulis; Fruit Body" },
        },
        {
          _id: "6458ae695175287050a4cd07",
          title: { en: "Boswellia Extract" },
          subtitle: { en: "65% Boswellic Acid; Boswellia Serrata; Resin" },
        },
        {
          _id: "6458ae695175287050a4cd09",
          title: { en: "Boswellia Extract" },
          subtitle: { en: "85% Boswellic Acid; Boswellia Serrata; Resin" },
        },
        {
          _id: "645cf5e0329034f1aee8c667",
          title: { en: "Boswellia Extract Granules" },
          subtitle: { en: "85% Boswellic Acid; 10:1; Boswellia Serrata; Resin" },
        },
        {
          _id: "6458ae695175287050a4cd0d",
          title: { en: "Broccoli Extract 10% Sulforaphane (UV)" },
          subtitle: {
            en: "10% Sulforaphane; 30:1; Brassica oleracea italica; Flower",
          },
        },
        {
          _id: "6458ae695175287050a4cf80",
          title: { en: "Bromelain 2,500 GDU/g" },
          subtitle: { en: "Ananas Comosus" },
        },
        {
          _id: "645cf5e0329034f1aee8c66b",
          title: { en: "Bromelain 600 GDU/g Powder" },
          subtitle: { en: "Ananas Comosus" },
        },
        {
          _id: "6458ae695175287050a4cf36",
          title: { en: "Brown Algae Extract" },
          subtitle: { en: "50% Fucoxanthin; Laminaria japonica; Seaweed" },
        },
        {
          _id: "6458ae695175287050a4cd11",
          title: { en: "Sea Buckthorn Extract" },
          subtitle: { en: "50% Vitamin C; Hippophae rhamnoides L.; Fruit" },
        },
        {
          _id: "6458ae695175287050a4cd13",
          title: { en: "Buckwheat Extract" },
          subtitle: { en: "30% Bioflavonoids; Fagopyrum esculentum Moenc; Seed" },
        },
        {
          _id: "6458ae695175287050a4cd19",
          title: { en: "Butcher's Broom Extract" },
          subtitle: { en: "10% Ruscogenins; Ruscus Aculeatus; Root" },
        },
        {
          _id: "6458ae695175287050a4cd17",
          title: { en: "Butcher's Broom Extract" },
          subtitle: { en: "10:1; Ruscus Aculeatus; Root" },
        },
        {
          _id: "6458ae695175287050a4cd1d",
          title: { en: "Cacao Extract" },
          subtitle: { en: "24% Theobromine; Theobroma Cacao; Fruit" },
        },
        {
          _id: "6458ae695175287050a4cd1b",
          title: { en: "Cacao Extract" },
          subtitle: { en: "50% Cacao Alkaloids; Theobroma Cacao; Seed" },
        },
        {
          _id: "6458ae695175287050a4cf98",
          title: { en: "Calcium Ascorbate powder" },
          subtitle: { en: "" },
        },
        {
          _id: "6458ae695175287050a4cf9a",
          title: { en: "Calcium Carbonate" },
          subtitle: { en: "39% Calcium" },
        },
        {
          _id: "645cf5e0329034f1aee8c677",
          title: { en: "Calcium Carbonate Granular (DC Grade)" },
          subtitle: { en: "38% Calcium, 4.5% Starch" },
        },
        {
          _id: "6458ae695175287050a4cf9c",
          title: { en: "Calcium Gluconate Monohydrate" },
          subtitle: { en: "8% Calcium" },
        },
        {
          _id: "6458ae695175287050a4cfcc",
          title: { en: "Calcium Hydroxide Powder" },
          subtitle: { en: "54% Calcium" },
        },
        {
          _id: "6458ae695175287050a4cfce",
          title: { en: "Calcium Hydroxyapatite Powder" },
          subtitle: { en: "36% Calcium" },
        },
        {
          _id: "6458ae695175287050a4d006",
          title: { en: "Calcium Lactate Powder" },
          subtitle: { en: "18% Calcium, 28% Lactate" },
        },
        {
          _id: "6458ae695175287050a4cd1f",
          title: { en: "Camu Camu Powder" },
          subtitle: { en: "25% Vitamin C; Myrciaria dubia; Fruit" },
        },
        {
          _id: "6458ae695175287050a4cd21",
          title: { en: "Camu Camu Extract - added" },
          subtitle: { en: "50% Vitamin C; Myrciaria dubia; Fruit" },
        },
        {
          _id: "6458ae695175287050a4cd23",
          title: { en: "Camu Camu Extract - natural" },
          subtitle: { en: "25% Vitamin C; Myrciaria dubia; Fruit" },
        },
        {
          _id: "6458ae695175287050a4cd25",
          title: { en: "Capsicum Extract" },
          subtitle: { en: "2% Capsaicine; 3:1; Capsicum Frutescens L.; Fruit" },
        },
        {
          _id: "6458ae695175287050a4cd2f",
          title: { en: "Carob Powder" },
          subtitle: { en: "Ceratonia Siliqua L.; Bean" },
        },
        {
          _id: "6458ae695175287050a4cd31",
          title: { en: "Carrot Extract" },
          subtitle: { en: "10:1; Daucus Carota; Root" },
        },
        {
          _id: "6458ae695175287050a4cd35",
          title: { en: "Cassia Seed Extract" },
          subtitle: { en: "10:1; Cassia Tora; Seed" },
        },
        {
          _id: "6458ae695175287050a4cd39",
          title: { en: "Cat's Claw Extract" },
          subtitle: { en: "10:1; Uncaria Tomentosa; Root" },
        },
        {
          _id: "6458ae695175287050a4cd3b",
          title: { en: "Cat's Claw Extract" },
          subtitle: { en: "5:1; Uncaria rhynchophylla; Root" },
        },
        {
          _id: "6458ae695175287050a4cd3f",
          title: { en: "Cayenne Extract" },
          subtitle: { en: "8:1; Capsicum annuu; Fruit" },
        },
        {
          _id: "6458ae695175287050a4cd43",
          title: { en: "Celery Extract" },
          subtitle: { en: "10:1; Apium Graveolens; Seed" },
        },
        {
          _id: "6458ae695175287050a4cd47",
          title: { en: "Chamomile Extract" },
          subtitle: { en: "5% Apigenin; Matricaria chamomilla L.; Herb" },
        },
        {
          _id: "6458ae695175287050a4cd45",
          title: { en: "Chamomile Extract" },
          subtitle: { en: "4:1; Matricaria chamomilla L.; Herb, flower" },
        },
        {
          _id: "645cf5e0329034f1aee8c68d",
          title: { en: "Chamomile Extract" },
          subtitle: { en: "1% Apigenin; 10:1; Matricaria recutita; Herb" },
        },
        {
          _id: "6458ae695175287050a4cd49",
          title: { en: "Chanca Piedra Extract" },
          subtitle: { en: "10:1; Phyllanthus Urinaria; Herb" },
        },
        {
          _id: "6458ae695175287050a4cd4d",
          title: { en: "Chasteberry Extract" },
          subtitle: { en: "5:1; Vitex agnus-castus; Berry" },
        },
        {
          _id: "6458ae695175287050a4cd59",
          title: { en: "Montmorency Cherry Extract" },
          subtitle: { en: "10:1; Cerasus pseudocerasus; Fruit" },
        },
        {
          _id: "6458ae695175287050a4cee2",
          title: { en: "Montmorency Sour Cherry Extract" },
          subtitle: { en: "1% Melatonin; Prunus cerasus; Fruit" },
        },
        {
          _id: "6458ae695175287050a4cd55",
          title: { en: "Cherry Extract" },
          subtitle: { en: "Prunus Cerasus; Fruit" },
        },
        {
          _id: "6458ae695175287050a4cd5f",
          title: { en: "Chicory Extract" },
          subtitle: { en: "10:1; Cichorium Intybus; Root" },
        },
        {
          _id: "6458ae695175287050a4cd69",
          title: { en: "Chrysanthemum Extract" },
          subtitle: { en: "10:1; Chrysanthemum Morifolium; Flower" },
        },
        {
          _id: "6458ae695175287050a4cd6b",
          title: { en: "Cinnamon Extract" },
          subtitle: { en: "5:1; Cinnamomum verum; Bark" },
        },
        {
          _id: "6458ae695175287050a4cd71",
          title: { en: "Cissus Extract" },
          subtitle: { en: "40% Ketosterone; Cissus Quadrangularis; Plant" },
        },
        {
          _id: "6458ae695175287050a4cd73",
          title: { en: "Cistus Incanus Extract" },
          subtitle: { en: "10:1; Cistus Incanus; Aerial part" },
        },
        {
          _id: "6458ae695175287050a4cd75",
          title: { en: "Clove Extract" },
          subtitle: { en: "5:1; Syzygium aromaticum; Flowerbuds" },
        },
        {
          _id: "6458ae695175287050a4cd77",
          title: { en: "Coleus Extract" },
          subtitle: { en: "10% Forskohliin; 25:1; Coleus forskohlii; Root" },
        },
        {
          _id: "6458ae695175287050a4cf50",
          title: { en: "Coprinus Extract" },
          subtitle: { en: "40% Polysaccharides; Coprinus Comatus; Fruit" },
        },
        {
          _id: "6458ae695175287050a4cd7b",
          title: { en: "Coptis chinensis Extract" },
          subtitle: { en: "95% Berberine Hydrochloride; Coptis chinensis; Root" },
        },
        {
          _id: "6458ae695175287050a4cf56",
          title: { en: "Cordyceps Extract" },
          subtitle: { en: "30% Polysaccharide; Cordyceps Militaris; Fruit Body" },
        },
        {
          _id: "6458ae695175287050a4cf5a",
          title: { en: "Cordyceps Extract" },
          subtitle: {
            en: "40% Polysaccharide; 10:1; Cordyceps Militaris; Fruit Body",
          },
        },
        {
          _id: "6458ae695175287050a4cf58",
          title: { en: "Cordyceps Extract" },
          subtitle: { en: "10:1; Cordyceps Militaris; Fruit Body" },
        },
        {
          _id: "6458ae695175287050a4cd85",
          title: { en: "Cranberry Extract" },
          subtitle: { en: "50% Vitamin C; Vaccinium Macrocarpon L.; Fruit" },
        },
        {
          _id: "6458ae695175287050a4cd83",
          title: { en: "Cranberry Extract" },
          subtitle: {
            en: "50% Proanthocyane; 150:1; Vaccinium Macrocarpon L.; Fruit",
          },
        },
        {
          _id: "6458ae695175287050a4cc34",
          title: { en: "Creatine Alpha-Ketoglutarate Powder" },
          subtitle: { en: "" },
        },
        {
          _id: "6458ae695175287050a4cc36",
          title: { en: "Creatine Ethyl Ester HCL Powder" },
          subtitle: { en: "66% Creatine" },
        },
        {
          _id: "6458ae695175287050a4cc38",
          title: { en: "Creatine HCL Powder" },
          subtitle: { en: "77% Creatine" },
        },
        {
          _id: "6458ae695175287050a4cd87",
          title: { en: "Cress Extract" },
          subtitle: { en: "10:1; Lepidium Sativum L.; Seed" },
        },
        {
          _id: "6458ae695175287050a4cd89",
          title: { en: "Cumin Extract" },
          subtitle: { en: "10:1; Cuminum cyminum L.; Seed" },
        },
        {
          _id: "6458ae695175287050a4cd8b",
          title: { en: "Curcuma (Turmeric) Extract" },
          subtitle: { en: "95% Curcuminoids; Curcuma Longa Linn; Root" },
        },
        {
          _id: "6458ae695175287050a4cd8d",
          title: { en: "Curcuma (Turmeric) Extract - added" },
          subtitle: { en: "98% Curcuminoide; Curcuma Longa; Root" },
        },
        {
          _id: "6458ae695175287050a4cd8f",
          title: { en: "Curcuma (Turmeric) Extract 95% Curcuminoids Granules" },
          subtitle: { en: "95% Curcuminoids; Curcuma Longa; Root" },
        },
        {
          _id: "6458ae695175287050a4cd93",
          title: { en: "Cyanotis Arachnoidea Extract" },
          subtitle: {
            en: "90% Ecdysone; Cyanotis arachnoidea C.B. Clarke; Plant",
          },
        },
        {
          _id: "6458ae695175287050a4cd95",
          title: { en: "Damiana Extract" },
          subtitle: { en: "5:1; Turnera diffusa; Leaf" },
        },
        {
          _id: "6458ae695175287050a4cd9b",
          title: { en: "Dandelion Extract" },
          subtitle: { en: "10:1; Taraxacum officinale; Herb" },
        },
        {
          _id: "6458ae695175287050a4cd99",
          title: { en: "Dandelion Root Extract" },
          subtitle: { en: "10:1; Taraxacum officinale; Root" },
        },
        {
          _id: "645cf5e0329034f1aee8c6b6",
          title: { en: "Dandelion Leaf Extract" },
          subtitle: { en: "10:1; Taraxacum mongolicum; Leaf" },
        },
        {
          _id: "6458ae695175287050a4cd9d",
          title: { en: "Desmodium Extract" },
          subtitle: { en: "10:1; Desmodium Styracifolium; Plant" },
        },
        {
          _id: "6458ae695175287050a4cd9f",
          title: { en: "Devil's Claw Extract" },
          subtitle: { en: "4:1; Harpagophytum procumbens; Root" },
        },
        {
          _id: "6458ae695175287050a4cfa0",
          title: { en: "Di-Calcium Phosphate Powder" },
          subtitle: { en: "8.2% Calcium" },
        },
        {
          _id: "6458ae695175287050a4cc3b",
          title: { en: "Di-Creatine Malate Powder" },
          subtitle: { en: "30% Creatine" },
        },
        {
          _id: "6458ae695175287050a4cda1",
          title: { en: "Dill Extract" },
          subtitle: { en: "10:1; Anethum Graveolens L.; Seed" },
        },
        {
          _id: "6458ae695175287050a4d00a",
          title: { en: "DL-Malic Acid Powder" },
          subtitle: { en: "" },
        },
        {
          _id: "6458ae695175287050a4cc3d",
          title: { en: "DL-Methionine Powder" },
          subtitle: { en: "" },
        },
        {
          _id: "6458ae695175287050a4cda3",
          title: { en: "Echinacea Extract" },
          subtitle: {
            en: "4% Polyphenols; 1-2:1; Echinacea Purpure (Linn.) Moench; Aerial part",
          },
        },
        {
          _id: "6458ae695175287050a4cda7",
          title: { en: "Elderberry  Extract" },
          subtitle: { en: "30% Polyphenole; 4-6:1; Sambucus Nigra; Dried Fruit" },
        },
        {
          _id: "6458ae695175287050a4cda9",
          title: { en: "Elderberry Extract" },
          subtitle: { en: "4:1; Sambucus Nigra; Flower" },
        },
        {
          _id: "6458ae695175287050a4cdab",
          title: { en: "Elecampane Extract" },
          subtitle: { en: "10:1; Inula helenium L.; Root" },
        },
        {
          _id: "6458ae695175287050a4cdad",
          title: { en: "Eucalyptus Extract" },
          subtitle: { en: "10:1; Eucalyptus obliqua; Leaf" },
        },
        {
          _id: "6458ae695175287050a4cdaf",
          title: { en: "Fennel Extract" },
          subtitle: { en: "4:1; Foeniculum Vulgare Mill; Seed" },
        },
        {
          _id: "6458ae695175287050a4cdb1",
          title: { en: "Fenugreek Extract (ratio 10:1)" },
          subtitle: { en: "10:1; Trigonella foenum-graecum; Seed" },
        },
        {
          _id: "645cf5e0329034f1aee8c6c7",
          title: { en: "Fenugreek Powder" },
          subtitle: { en: "Trigonella foenum-graecum; Seed" },
        },
        {
          _id: "6458ae695175287050a4cfa2",
          title: { en: "Iron glycinate Powder (Grayish green powder)" },
          subtitle: { en: "20% Ferrous II" },
        },
        {
          _id: "6458ae695175287050a4cfa4",
          title: { en: "Ferrous Gluconate Powder" },
          subtitle: { en: "11% Ferrous" },
        },
        {
          _id: "6458ae695175287050a4cdb5",
          title: { en: "Feverfew Extract" },
          subtitle: { en: "10:1; Tanacetum parthenium; Flower" },
        },
        {
          _id: "6458ae695175287050a4d00c",
          title: { en: "Fructo-oligosaccharides (FOS) Powder" },
          subtitle: { en: "" },
        },
        {
          _id: "6458ae695175287050a4d010",
          title: { en: "Galactose Powder (vegan)" },
          subtitle: { en: "" },
        },
        {
          _id: "6458ae695175287050a4cdb9",
          title: { en: "Galangal Extract" },
          subtitle: { en: "10:1; Alpinia officinarum; Rhizome" },
        },
        {
          _id: "6458ae695175287050a4cdbd",
          title: { en: "Garlic Extract" },
          subtitle: { en: "0% Allicine; Allium Sativum L.; Bulb" },
        },
        {
          _id: "6458ae695175287050a4cdbf",
          title: { en: "Garlic Extract" },
          subtitle: { en: "5% Allicine, 10% Allin; Allium Sativum L.; Bulb" },
        },
        {
          _id: "6458ae695175287050a4cdc3",
          title: { en: "Giant Knotweed Extract" },
          subtitle: { en: "98% Resveratrol; Polygonum cuspidatum; Root" },
        },
        {
          _id: "6458ae695175287050a4cdc7",
          title: { en: "Ginger Extract" },
          subtitle: { en: "5% Gingerols; Zingiber Officinale; Root" },
        },
        {
          _id: "6458ae695175287050a4cdc9",
          title: { en: "Ginkgo Extract" },
          subtitle: { en: "50:1; Ginkgo Biloba L.; Leaf" },
        },
        {
          _id: "6458ae695175287050a4cdcb",
          title: { en: "Ginkgo Extract" },
          subtitle: {
            en: "20% Total Flavone Glycosides, 5% Total Terpene Lactones; 50:1; Ginkgo Biloba L.; Leaf",
          },
        },
        {
          _id: "6458ae695175287050a4cdcd",
          title: { en: "Ginkgo Leaf Powder" },
          subtitle: { en: "Ginkgo Biloba L.; Leaf" },
        },
        {
          _id: "6458ae695175287050a4cdd1",
          title: { en: "Panax Ginseng Extract" },
          subtitle: { en: "20% Ginsenosides; Panax ginseng C.A. Mey; Stem,Leaf" },
        },
        {
          _id: "6458ae695175287050a4cdcf",
          title: { en: "Panax Ginseng Extract" },
          subtitle: { en: "80% Ginsenosides; Panax ginseng C.A. Mey; Root,Leaf" },
        },
        {
          _id: "645cf5e0329034f1aee8c6de",
          title: { en: "Panax Ginseng Extract" },
          subtitle: { en: "30% Ginsenosides; Panax ginseng C.A. Mey; Stem,Leaf" },
        },
        {
          _id: "6458ae695175287050a4cc3f",
          title: { en: "Glucosamine HCL Powder, 80mesh" },
          subtitle: { en: "Vegan, 98% Glucosamine" },
        },
        {
          _id: "6458ae695175287050a4cdd5",
          title: { en: "Goji Berry Extract" },
          subtitle: { en: "40% Polysaccharides; Lycium Barbarum; Berries" },
        },
        {
          _id: "6458ae695175287050a4cdd7",
          title: { en: "Goji Berry Extract" },
          subtitle: { en: "50% Vitamin C; Lycium Barbarum; Fruit" },
        },
        {
          _id: "6458ae695175287050a4cdd3",
          title: { en: "Goji Berry Extract" },
          subtitle: { en: "4:1; Lycium Barbarum; Fruit" },
        },
        {
          _id: "6458ae695175287050a4cdd9",
          title: { en: "Gotu Kola Extract" },
          subtitle: { en: "4:1; Centella Asiatica; Whole Herb" },
        },
        {
          _id: "6458ae695175287050a4cde3",
          title: { en: "Grape Seed Extract" },
          subtitle: { en: "95% Proanthocyanidine; Vitis vinifera L.; Seed" },
        },
        {
          _id: "6458ae695175287050a4cde1",
          title: { en: "Grape Seed Extract" },
          subtitle: { en: "70% OPC; Vitis vinifera L.; Seed" },
        },
        {
          _id: "6458ae695175287050a4cddf",
          title: { en: "French Grape Seed Extract" },
          subtitle: {
            en: "80% Polypehnols, 60% Proanthocyanidins; Vitis vinifera L.; Seed",
          },
        },
        {
          _id: "6458ae695175287050a4cde7",
          title: { en: "Green Tea Extract" },
          subtitle: {
            en: "70% Theanin; 20-25:1; Camellia Sinensis (L.) o. Ktze.; Leaf",
          },
        },
        {
          _id: "6458ae695175287050a4cde9",
          title: { en: "Green Tea Extract" },
          subtitle: { en: "30% Theanin; Camellia Sinensis (L.) o. Ktze.; Leaf" },
        },
        {
          _id: "6458ae695175287050a4cde5",
          title: { en: "Green Tea Extract" },
          subtitle: {
            en: "50% Polyphenoles; Camellia Sinensis (L.) o. Ktze.; Leaf",
          },
        },
        {
          _id: "6458ae695175287050a4cdeb",
          title: { en: "Green Tea Extract" },
          subtitle: {
            en: "95% Polyphenoles, 45% EGCG, 0.5% Caffeine; Camellia Sinensis (L.) o. Ktze.; Leaf",
          },
        },
        {
          _id: "645cf5e0329034f1aee8c6f3",
          title: { en: "Green Tea Extract" },
          subtitle: {
            en: "50% Polyphenoles, 30% Catechins, 15% EGCG, 3% Caffeine; Camellia Sinensis (L.) o. Ktze.; Leaf",
          },
        },
        {
          _id: "645cf5e0329034f1aee8c6f5",
          title: { en: "Green Tea Extract" },
          subtitle: {
            en: "98% Polyphenoles, 50% EGCG, 9% Caffeine; Camellia Sinensis (L.) o. Ktze.; Leaf",
          },
        },
        {
          _id: "6458ae695175287050a4cded",
          title: { en: "Griffonia Extract" },
          subtitle: { en: "27-29% 5-HTP; Griffonia simplicifolia; Seed" },
        },
        {
          _id: "645cf5e0329034f1aee8c6f9",
          title: { en: "Griffonia Extract" },
          subtitle: { en: "99% 5-HTP; Griffonia simplicifolia; Seed" },
        },
        {
          _id: "6458ae695175287050a4cdf1",
          title: { en: "Guarana Extract" },
          subtitle: {
            en: "22% Caffeine; Sapindaceae Paullinia cupana Kunth; Seed",
          },
        },
        {
          _id: "6458ae695175287050a4cdef",
          title: { en: "Guarana Extract" },
          subtitle: {
            en: "10% Caffeine; Sapindaceae Paullinia cupana Kunth; Fruit",
          },
        },
        {
          _id: "6458ae695175287050a4cdf3",
          title: { en: "Guava Extract" },
          subtitle: { en: "4% Zinc; 10:1; Psidium guajava; Leaf" },
        },
        {
          _id: "6458ae695175287050a4cf5e",
          title: { en: "Hericium Extract" },
          subtitle: {
            en: "30% Polysaccharides, 5% Beta Glucan; Hericium Erinaceus; Fruiting body",
          },
        },
        {
          _id: "6458ae695175287050a4cf5c",
          title: { en: "Hericium Extract" },
          subtitle: { en: "Hericium Erinaceus; Fruit" },
        },
        {
          _id: "6458ae695175287050a4cdf9",
          title: { en: "Hops Extract" },
          subtitle: { en: "4:1; Humulus Lupulus L.; Strobile" },
        },
        {
          _id: "6458ae695175287050a4cdfb",
          title: { en: "Icariin Extract" },
          subtitle: { en: "98% Icariin; Epimedium brevicornum L.; Stem,Leaf" },
        },
        {
          _id: "6458ae695175287050a4cc41",
          title: { en: "Inosine Powder" },
          subtitle: { en: "" },
        },
        {
          _id: "6458ae695175287050a4cdff",
          title: { en: "Kalmegh Extract" },
          subtitle: { en: "Andrographis paniculata (Burm. f.); Stem,Leaf" },
        },
        {
          _id: "6458ae695175287050a4ce03",
          title: { en: "Kelp Extract" },
          subtitle: { en: "Laminaria digitate L.; Whole Herb" },
        },
        {
          _id: "6458ae695175287050a4ce01",
          title: { en: "Kelp Extract" },
          subtitle: { en: "10:1; Laminaria japonica A resch; Whole Herb" },
        },
        {
          _id: "6458ae695175287050a4ce05",
          title: { en: "Kiwi Extract" },
          subtitle: { en: "10:1; Actinidia Deliciosa; Fruit" },
        },
        {
          _id: "6458ae695175287050a4ce07",
          title: { en: "Knotted Wrack Extract" },
          subtitle: { en: "50% Fucoxanthin; Ascophyllum nodosum; Whole Herb" },
        },
        {
          _id: "6458ae695175287050a4ce0b",
          title: { en: "Konjac Glucomannan Powder" },
          subtitle: { en: "95% Glucomannan; Anorphophallus konjac; Tuber" },
        },
        {
          _id: "645cf5e0329034f1aee8c70c",
          title: { en: "Konjac Glucomannan Powder" },
          subtitle: { en: "90% Glucomannan; Anorphophallus konjac; Tuber" },
        },
        {
          _id: "6458ae695175287050a4cf86",
          title: { en: "Lactase 100.000 ALU/g Powder" },
          subtitle: { en: "" },
        },
        {
          _id: "6458ae695175287050a4cc45",
          title: { en: "L-Alanine Powder" },
          subtitle: { en: "" },
        },
        {
          _id: "6458ae695175287050a4cc47",
          title: { en: "L-Arginine alpha-ketoglutarate (AAKG) 2:1 Powder" },
          subtitle: { en: "65% L-Arginine, 26% Alpha-Ketoglutarate; 2:1" },
        },
        {
          _id: "6458ae695175287050a4cc49",
          title: { en: "L-Arginine HCL Powder (vegan)" },
          subtitle: { en: "83% L-Arginine" },
        },
        {
          _id: "645cf5e0329034f1aee8c713",
          title: { en: "L-Arginine base Powder" },
          subtitle: { en: "98% L-Arginine" },
        },
        {
          _id: "645cf5e0329034f1aee8c715",
          title: { en: "L-Arginine Nitrate Powder" },
          subtitle: { en: "65% L-Arginine" },
        },
        {
          _id: "6458ae695175287050a4ce0f",
          title: { en: "Lavender Extract" },
          subtitle: { en: "5:1; Lavandula angustifolia; Herb" },
        },
        {
          _id: "6458ae695175287050a4cc20",
          title: { en: "L-Carnitine Base Powder" },
          subtitle: { en: "98% L-Carnitine" },
        },
        {
          _id: "6458ae695175287050a4cc22",
          title: { en: "L-Carnitine Fumarate Powder" },
          subtitle: { en: "56% L-Carnitine" },
        },
        {
          _id: "6458ae695175287050a4cc26",
          title: { en: "L-Carnitine Tartrate Powder" },
          subtitle: { en: "68% L-Carnitine" },
        },
        {
          _id: "6458ae695175287050a4cc4d",
          title: { en: "L-Carnosine Powder" },
          subtitle: { en: "98% L-Carnosine" },
        },
        {
          _id: "6458ae695175287050a4cc4f",
          title: { en: "L-Citrulline Powder" },
          subtitle: { en: "99% L-Citrulline" },
        },
        {
          _id: "645cf5e0329034f1aee8c71d",
          title: { en: "L-Citrulline base Powder" },
          subtitle: { en: "100% L-Citrulline" },
        },
        {
          _id: "645cf5e0329034f1aee8c720",
          title: { en: "L-Citrulline DL-Malate 2:1 Powder (vegan)" },
          subtitle: { en: "65% L-Citrulline, 30% DL-Malic acid; 2:1" },
        },
        {
          _id: "6458ae695175287050a4cc51",
          title: { en: "L-Cysteine HCL Powder" },
          subtitle: { en: "100% L-Cysteine" },
        },
        {
          _id: "6458ae695175287050a4cc53",
          title: { en: "L-Cysteine base Powder" },
          subtitle: { en: "100% L-Cysteine" },
        },
        {
          _id: "6458ae695175287050a4ce17",
          title: { en: "Lemon Balm Extract" },
          subtitle: { en: "10:1; Melissa Officinalis L.; Herb" },
        },
        {
          _id: "6458ae695175287050a4ce15",
          title: { en: "Lemon Balm Extract" },
          subtitle: { en: "4:1; Melissa Officinalis L.; Herb" },
        },
        {
          _id: "6458ae695175287050a4cc55",
          title: { en: "L-Glutamine fermented Powder" },
          subtitle: { en: "99% L-Glutamine" },
        },
        {
          _id: "6458ae695175287050a4cc57",
          title: { en: "L-Glutathione Powder reduced" },
          subtitle: { en: "98% L-Glutathione" },
        },
        {
          _id: "6458ae695175287050a4cc59",
          title: { en: "L-Histidine Base Powder" },
          subtitle: { en: "99% L-Histidine" },
        },
        {
          _id: "6458ae695175287050a4cc5b",
          title: { en: "L-Histidine HCL Monohydrate Powder" },
          subtitle: { en: "99% L-Histidine" },
        },
        {
          _id: "6458ae695175287050a4cc5d",
          title: { en: "Hydroxyproline (L-) Powder" },
          subtitle: { en: "99% Hydroxyproline (L-)" },
        },
        {
          _id: "6458ae695175287050a4ce21",
          title: { en: "Licorice Extract" },
          subtitle: { en: "4:1; Glycyrrhiza Glabra L.; Root" },
        },
        {
          _id: "6458ae695175287050a4cc5f",
          title: { en: "L-Isoleucine fermented Powder" },
          subtitle: { en: "" },
        },
        {
          _id: "6458ae695175287050a4cc61",
          title: { en: "L-Leucine fermented Powder" },
          subtitle: { en: "100% L-Leucine" },
        },
        {
          _id: "6458ae695175287050a4cc63",
          title: { en: "L-Lysine HCL fermented Powder" },
          subtitle: { en: "80% L-Lysine" },
        },
        {
          _id: "6458ae695175287050a4cc65",
          title: { en: "L-Methionine Powder" },
          subtitle: { en: "99% L-Methionine" },
        },
        {
          _id: "6458ae695175287050a4cc67",
          title: { en: "L-Norvaline Powder" },
          subtitle: { en: "100% L-Norvaline" },
        },
        {
          _id: "6458ae695175287050a4cc2c",
          title: { en: "L-Ornithine HCL Powder" },
          subtitle: { en: "100% L-Ornithine" },
        },
        {
          _id: "6458ae695175287050a4cc6b",
          title: { en: "L-Phenylalanine fermented Powder" },
          subtitle: { en: "99% L-Phenylalanine" },
        },
        {
          _id: "6458ae695175287050a4cc6d",
          title: { en: "Proline (L-) Powder" },
          subtitle: { en: "100% L-Proline" },
        },
        {
          _id: "6458ae695175287050a4cc73",
          title: { en: "L-Taurine Powder" },
          subtitle: { en: "100% L-Taurine" },
        },
        {
          _id: "6458ae695175287050a4cc75",
          title: { en: "L-Theanine Powder" },
          subtitle: { en: "100% L-Theanin" },
        },
        {
          _id: "6458ae695175287050a4cc77",
          title: { en: "L-Threonine fermented Powder" },
          subtitle: { en: "100% L-Threonine" },
        },
        {
          _id: "6458ae695175287050a4cc79",
          title: { en: "L-Tryptophan fermented Powder" },
          subtitle: { en: "99% L-Tryptophan" },
        },
        {
          _id: "645cf5e1329034f1aee8c73c",
          title: { en: "L-Tryptophan Granules" },
          subtitle: { en: "95% L-Tryptophan" },
        },
        {
          _id: "6458ae695175287050a4cc7b",
          title: { en: "L-Tyrosine fermented Powder" },
          subtitle: { en: "100% L-Tyrosine" },
        },
        {
          _id: "6458ae695175287050a4cc7d",
          title: { en: "L-Valine fermented Powder" },
          subtitle: { en: "99% L-Valine" },
        },
        {
          _id: "6458ae695175287050a4cea6",
          title: { en: "Red Maca Extract" },
          subtitle: { en: "10:1; Lepidium meyenii Walp; Root" },
        },
        {
          _id: "645cf5e1329034f1aee8c742",
          title: { en: "Black Maca Extract" },
          subtitle: { en: "10:1; Lepidium meyenii Walp; Root" },
        },
        {
          _id: "645cf5e1329034f1aee8c744",
          title: { en: "Maca Extract" },
          subtitle: { en: "20:1; Lepidium meyenii Walp; Root" },
        },
        {
          _id: "645cf5e1329034f1aee8c746",
          title: { en: "Maca Extract (80% black, 15% red-purple, 5% yellow)" },
          subtitle: { en: "6:1; Lepidium meyenii Walp; Root" },
        },
        {
          _id: "645cf5e1329034f1aee8c748",
          title: { en: "Maca Extract" },
          subtitle: { en: "10:1; Lepidium meyenii Walp; Root" },
        },
        {
          _id: "6458ae695175287050a4cfa6",
          title: { en: "Magnesium Ascorbate Blend Powder" },
          subtitle: { en: "10% Magnesium, 79% Ascorbinsäure" },
        },
        {
          _id: "6458ae695175287050a4cfd2",
          title: { en: "Magnesium Bisglycinate Powder 20%" },
          subtitle: { en: "" },
        },
        {
          _id: "6458ae695175287050a4cfa8",
          title: { en: "Magnesium L-Threonate Powder" },
          subtitle: { en: "8% Magnesium" },
        },
        {
          _id: "6458ae695175287050a4cfaa",
          title: { en: "Magnesium Malate Powder" },
          subtitle: { en: "15% Magnesium" },
        },
        {
          _id: "645cf5e1329034f1aee8c74f",
          title: { en: "Magnesium Malate Powder" },
          subtitle: { en: "20% Magnesium" },
        },
        {
          _id: "6458ae695175287050a4cfac",
          title: { en: "Magnesium Orotate Powder" },
          subtitle: { en: "6% Magnesium" },
        },
        {
          _id: "645cf5e1329034f1aee8c752",
          title: { en: "Magnesium Oxide Heavy Powder" },
          subtitle: { en: "" },
        },
        {
          _id: "645cf5e1329034f1aee8c754",
          title: { en: "Magnesium Oxide DC Powder" },
          subtitle: { en: "58% Magnesium" },
        },
        {
          _id: "6458ae695175287050a4ce2c",
          title: { en: "Magnolia Extract" },
          subtitle: { en: "90% Honokiol; Magnolia officinalis; Bark" },
        },
        {
          _id: "6458ae695175287050a4cf60",
          title: { en: "Maitake Extract" },
          subtitle: { en: "30% Polysaccharides; Grifola Frondosa; Fruit Body" },
        },
        {
          _id: "6458ae695175287050a4d014",
          title: { en: "Maltodextrin Powder" },
          subtitle: { en: "Corn Starch" },
        },
        {
          _id: "6458ae695175287050a4ce2e",
          title: { en: "Malva Extract" },
          subtitle: { en: "5:1; Malva sylvestris L.; Whole Herb" },
        },
        {
          _id: "6458ae695175287050a4ce30",
          title: { en: "Mangosteen Extract" },
          subtitle: { en: "4:1; Garcinia mangostana; Fruit" },
        },
        {
          _id: "6458ae695175287050a4ce32",
          title: { en: "Mangosteen Extract" },
          subtitle: { en: "10:1; Garcinia mangostana; Fruit" },
        },
        {
          _id: "6458ae695175287050a4ce36",
          title: { en: "Marigold Extract" },
          subtitle: { en: "10% Lutein, 2% Zeaxanthin; Tagetes Erecta; Petals" },
        },
        {
          _id: "6458ae695175287050a4ce38",
          title: { en: "Marigold Extract" },
          subtitle: { en: "20% Lutein, 4% Zeaxanthin; Tagetes Erecta L.; Flower" },
        },
        {
          _id: "6458ae695175287050a4ce34",
          title: { en: "Marigold Extract" },
          subtitle: { en: "10:1; Calendula Officinalis; Flower" },
        },
        {
          _id: "6458ae695175287050a4d016",
          title: { en: "Melatonin Powder" },
          subtitle: { en: "99% Melatonin" },
        },
        {
          _id: "6458ae695175287050a4d018",
          title: { en: "Microcrystalline Cellulose (MCC) Powder" },
          subtitle: { en: "MCC 102" },
        },
        {
          _id: "6458ae695175287050a4ce44",
          title: { en: "Millet Extract" },
          subtitle: { en: "4:1; Mollugo Pentaphylla Linn; Seed" },
        },
        {
          _id: "6458ae695175287050a4ce4a",
          title: { en: "Morus Alba Extract" },
          subtitle: { en: "10:1; Morus alba; Leaf" },
        },
        {
          _id: "6458ae695175287050a4ce4c",
          title: { en: "Mucuna Pruriens Extract" },
          subtitle: {
            en: "15% L-3.4-Dihydroxyphenylalanine; Mucuna pruriens L.; Seed",
          },
        },
        {
          _id: "6458ae695175287050a4ce50",
          title: { en: "Mugwort Powder" },
          subtitle: { en: "Artemisia vulgaris herba; Herb" },
        },
        {
          _id: "6458ae695175287050a4ce52",
          title: { en: "Mumijo Extract" },
          subtitle: { en: "50% Fulvic Acid; Asphaltum punjabinum; Whole Fruit" },
        },
        {
          _id: "6458ae695175287050a4cff4",
          title: { en: "Mung Bean Powder" },
          subtitle: { en: "Vigna Radiata (Linn.) Wilczek; Bean" },
        },
        {
          _id: "6458ae695175287050a4ce56",
          title: { en: "Mustard Extract" },
          subtitle: { en: "20:1; Brassica juncea; Seed" },
        },
        {
          _id: "6458ae695175287050a4d01a",
          title: { en: "Inositol Powder" },
          subtitle: { en: "" },
        },
        {
          _id: "6458ae695175287050a4ce58",
          title: { en: "Myrrh Extract" },
          subtitle: { en: "10:1; Commiphora Myrrha Engl.; Resin" },
        },
        {
          _id: "6458ae695175287050a4cc7f",
          title: { en: "N-Acetyl-D-Glucosamine Powder" },
          subtitle: { en: "" },
        },
        {
          _id: "6458ae695175287050a4cc81",
          title: { en: "N-Acetyl-L-Carnitine HCL Powder" },
          subtitle: { en: "67% Carnitine" },
        },
        {
          _id: "6458ae695175287050a4cc83",
          title: { en: "N-Acetyl-L-Cysteine Powder" },
          subtitle: { en: "" },
        },
        {
          _id: "6458ae695175287050a4cc85",
          title: { en: "N-Acetyl-L-Tyrosine Powder" },
          subtitle: { en: "" },
        },
        {
          _id: "6458ae695175287050a4cf8a",
          title: { en: "Nattokinase 20.000 FU/g" },
          subtitle: {
            en: "40% Soy Protein, 22% Microcrystalline Cellulose, 6% Nattokinase; Seed",
          },
        },
        {
          _id: "6458ae695175287050a4ce5c",
          title: { en: "Nettle Extract" },
          subtitle: { en: "2% Silicia; Urtica Dioica L.; Leaf" },
        },
        {
          _id: "6458ae695175287050a4ce5e",
          title: { en: "Nettle Extract" },
          subtitle: { en: "20:1; Urtica Fissa E. Pritz.; Root" },
        },
        {
          _id: "6458ae695175287050a4ce5a",
          title: { en: "Nettle Extract" },
          subtitle: { en: "10:1; Urtica Fissa E. Pritz.; Root" },
        },
        {
          _id: "645cf5e1329034f1aee8c776",
          title: { en: "Nettle Extract" },
          subtitle: { en: "10:1; Urtica Dioica L.; Leaf" },
        },
        {
          _id: "6458ae695175287050a4ce6c",
          title: { en: "Olive Extract" },
          subtitle: { en: "Oleuropein; Olea europaea; Leaf" },
        },
        {
          _id: "645cf5e1329034f1aee8c779",
          title: { en: "Olive Extract" },
          subtitle: { en: "40% Oleuropein; Olea europaea; Leaf" },
        },
        {
          _id: "6458ae695175287050a4ce6e",
          title: { en: "Onion Extract" },
          subtitle: { en: "10:1; Allium Cepa L.; Bulb" },
        },
        {
          _id: "6458ae695175287050a4cf8c",
          title: { en: "Papain 6.000 USP-U/mg Powder" },
          subtitle: { en: "Fruit" },
        },
        {
          _id: "6458ae695175287050a4cf38",
          title: { en: "Papaya Extract" },
          subtitle: { en: "2:1; Chaenomeles Sinensis Thouin Koehne; Fruit" },
        },
        {
          _id: "6458ae695175287050a4ce78",
          title: { en: "Passionflower Extract" },
          subtitle: {
            en: "5% Flavonoide; 10:1; Passiflora Incarnata L.; Flowers & Leaves",
          },
        },
        {
          _id: "6458ae695175287050a4ce7a",
          title: { en: "Passionflower Extract" },
          subtitle: { en: "4:1; Passiflora Incarnata L.; Herb" },
        },
        {
          _id: "6458ae695175287050a4cf8e",
          title: { en: "Pepsin 10.000 NF/mg Powder" },
          subtitle: { en: "" },
        },
        {
          _id: "6458ae695175287050a4ce7c",
          title: { en: "Pine Bark Extract" },
          subtitle: { en: "95% Proanthocyanidins; 25:1; Pinus pinaster; Bark" },
        },
        {
          _id: "6458ae695175287050a4ce84",
          title: { en: "Pineapple Extract" },
          subtitle: { en: "10:1; Ananas Comosus; Fruit" },
        },
        {
          _id: "6458ae695175287050a4cf6a",
          title: { en: "Polyporus Extract" },
          subtitle: { en: "10:1; Polyporus Umbellatus; Fruit" },
        },
        {
          _id: "6458ae695175287050a4ce88",
          title: { en: "Pomegranate Extract" },
          subtitle: { en: "40% Ellagic Acid; 45:1; Punica granatum L.; Seed" },
        },
        {
          _id: "6458ae695175287050a4ce86",
          title: { en: "Pomegranate Extract" },
          subtitle: { en: "10:1; Punica granatum L.; Seed" },
        },
        {
          _id: "6458ae695175287050a4cfae",
          title: { en: "Potassium Carbonate Powder" },
          subtitle: { en: "38% Potassium" },
        },
        {
          _id: "6458ae695175287050a4cfb0",
          title: { en: "Potassium Chloride Powder" },
          subtitle: { en: "52% Potassium" },
        },
        {
          _id: "6458ae695175287050a4cfb2",
          title: { en: "Potassium Citrate Powder" },
          subtitle: { en: "35% Potassium" },
        },
        {
          _id: "645cf5e1329034f1aee8c78a",
          title: { en: "Tri-Potassium Citrate Monodydrate Powder" },
          subtitle: { en: "35-37% Potassium" },
        },
        {
          _id: "6458ae695175287050a4cfb6",
          title: { en: "Potassium Sorbate Granules" },
          subtitle: { en: "" },
        },
        {
          _id: "6458ae695175287050a4cf90",
          title: { en: "Protease 396,620 HUT/g Powder" },
          subtitle: { en: "" },
        },
        {
          _id: "6458ae695175287050a4ce8a",
          title: { en: "Psyllium Husk (95%) Powder" },
          subtitle: { en: "Plantago Ovata L.; Husk" },
        },
        {
          _id: "6458ae695175287050a4ce8c",
          title: { en: "Psyllium Husk (99%) Powder" },
          subtitle: { en: "Plantago Ovata L.; Husk" },
        },
        {
          _id: "6458ae695175287050a4cff8",
          title: { en: "Pumpkin Seed Extract" },
          subtitle: { en: "10:1; Cucurbita moschata Duch; Seed" },
        },
        {
          _id: "645cf5e1329034f1aee8c794",
          title: { en: "Pumpkin Seed Extract" },
          subtitle: {
            en: "45% Fatty acids; 15:1; Cucurbita moschata Poiret; Seed",
          },
        },
        {
          _id: "645cf5e1329034f1aee8c796",
          title: { en: "Pumpkin Seed Extract" },
          subtitle: { en: "15:1; Cucurbita moschata Duch; Seed" },
        },
        {
          _id: "6458ae695175287050a4cfb8",
          title: { en: "Pyrroloquinoline Quinone Disodium Salt (PQQ) Powder" },
          subtitle: { en: "" },
        },
        {
          _id: "6458ae695175287050a4cc87",
          title: { en: "R-alpha lipoic acid (+) bioactive Powder" },
          subtitle: { en: "" },
        },
        {
          _id: "6458ae695175287050a4ce96",
          title: { en: "Raspberry Extract" },
          subtitle: { en: "4% Ketones; Rubus Idaeus L.; Fruit" },
        },
        {
          _id: "6458ae695175287050a4cea2",
          title: { en: "Sweet Clover Extract" },
          subtitle: { en: "10:1; Melilotus Officinalis; Herb" },
        },
        {
          _id: "6458ae695175287050a4cea0",
          title: { en: "Red Clover Extract" },
          subtitle: { en: "4:1; Trifolium Pratense L.; Aerial part" },
        },
        {
          _id: "6458ae695175287050a4ce9e",
          title: { en: "Red Clover Extract" },
          subtitle: { en: "8% Isoflavone; Trifolium Pratense L.; Aerial part" },
        },
        {
          _id: "6458ae695175287050a4ce9c",
          title: { en: "Red Clover Extract" },
          subtitle: { en: "40% Isoflavone; Trifolium Pratense L.; Aerial part" },
        },
        {
          _id: "6458ae695175287050a4cef2",
          title: { en: "Sweet Clover Powder" },
          subtitle: { en: "Melilotus Officinalis; Herb" },
        },
        {
          _id: "6458ae695175287050a4cea4",
          title: { en: "Red Ginseng Extract" },
          subtitle: { en: "20:1; Panax ginseng C.A. Mey; Root" },
        },
        {
          _id: "6458ae695175287050a4cfe4",
          title: { en: "Red Yeast Rice Extract" },
          subtitle: { en: "4% Monacolin K; Monascus Purpureus; Monascussp" },
        },
        {
          _id: "6458ae695175287050a4cf6c",
          title: { en: "Reishi Extract" },
          subtitle: {
            en: "40% Polysaccharides; 5-6:1; Ganoderma Lucidum; Fruit Body",
          },
        },
        {
          _id: "6458ae695175287050a4cea8",
          title: { en: "Rhodiola Rosea Extract" },
          subtitle: { en: "3% Rosavins, 1% Salidroside; Rhodiola Rosea; Root" },
        },
        {
          _id: "6458ae695175287050a4ceac",
          title: { en: "Rhodiola Rosea Extract" },
          subtitle: { en: "10:1; Rhodiola Rosea; Root" },
        },
        {
          _id: "6458ae695175287050a4ceb0",
          title: { en: "Rhubarb Extract" },
          subtitle: { en: "5:1; Rheum Palmatum; Root" },
        },
        {
          _id: "6458ae695175287050a4ceb4",
          title: { en: "Ribwort Extract" },
          subtitle: { en: "10:1; Plantago lanceolata; Herb" },
        },
        {
          _id: "6458ae695175287050a4ceb6",
          title: { en: "Rosehip Extract" },
          subtitle: { en: "50% Vitamin C; Rosa canina L.; Fruit" },
        },
        {
          _id: "6458ae695175287050a4ceb8",
          title: { en: "Rosehip Extract" },
          subtitle: { en: "50% Vitamin C; Rosa Canina; Fruit" },
        },
        {
          _id: "6458ae695175287050a4cebc",
          title: { en: "Rosemary Extract" },
          subtitle: { en: "5% Rosmarinic acid; Rosmarinus Officinalis L.; Leaf" },
        },
        {
          _id: "645cf5e1329034f1aee8c7ad",
          title: { en: "Rosemary Extract" },
          subtitle: { en: "2% Rosmarinic acid; Rosmarinus officinalis L.; Leaf" },
        },
        {
          _id: "6458ae695175287050a4cc89",
          title: { en: "S-Adenosylmethionine (SAMe) Powder" },
          subtitle: { en: "" },
        },
        {
          _id: "6458ae695175287050a4cebe",
          title: { en: "Saffron Extract" },
          subtitle: { en: "3% Safranal; Crocus sativus L.; Flower" },
        },
        {
          _id: "6458ae695175287050a4cec0",
          title: { en: "Saffron Extract" },
          subtitle: { en: "4:1; Crocus Sativus L.; Saffronstigmas" },
        },
        {
          _id: "6458ae695175287050a4cec4",
          title: { en: "Sage Extract" },
          subtitle: { en: "10:1; Salvia Officinalis; Leaf" },
        },
        {
          _id: "6458ae695175287050a4cec2",
          title: { en: "Sage Extract" },
          subtitle: { en: "2% Rosmarinic acid; 60:1; Salvia Officinalis; Herb" },
        },
        {
          _id: "6458ae695175287050a4cec8",
          title: { en: "Saw Palmetto Extract" },
          subtitle: { en: "10:1; Serenoa Repens; Fruit" },
        },
        {
          _id: "645cf5e1329034f1aee8c7b5",
          title: { en: "Saw Palmetto Extract" },
          subtitle: { en: "5% Phytosterols; Serenoa Repens; Fruit" },
        },
        {
          _id: "6458ae695175287050a4ceca",
          title: { en: "Schisandra Extract (UV)" },
          subtitle: { en: "10% Schisandrin; Schisandra Chinensis; Fruit" },
        },
        {
          _id: "6458ae695175287050a4cecc",
          title: { en: "Shatavari Extract" },
          subtitle: { en: "20% Saponins; 10:1; Asparagus Racemosus; Root" },
        },
        {
          _id: "6458ae695175287050a4cf74",
          title: { en: "Shiitake Extract" },
          subtitle: { en: "30% Polysaccharides; Lentinula edodes; Fruit" },
        },
        {
          _id: "6458ae695175287050a4cece",
          title: { en: "Slippery Elm Bark Extract" },
          subtitle: { en: "4:1; Ulmus pumila L.; Bark" },
        },
        {
          _id: "6458ae695175287050a4cf94",
          title: { en: "Sodium Butyrate Powder" },
          subtitle: { en: "" },
        },
        {
          _id: "6458ae695175287050a4cf96",
          title: { en: "Sodium Selenite Anhydate Powder" },
          subtitle: { en: "45% Selenium" },
        },
        {
          _id: "6458ae695175287050a4ced0",
          title: { en: "Sophora Japonica Extract" },
          subtitle: { en: "95% Rutin; 4-6:1; Sophora Japonica L.; Buds" },
        },
        {
          _id: "6458ae695175287050a4ced4",
          title: { en: "Sophora Japonica Extract" },
          subtitle: { en: "98% Quercetin; 15:1; Sophora Japonica L.; Buds" },
        },
        {
          _id: "6458ae695175287050a4ced2",
          title: { en: "Sophora Japonica Extract Granules" },
          subtitle: {
            en: "95% Quercetin; 15:1; Sophora Japonica L.; Flowder,Buds",
          },
        },
        {
          _id: "6458ae695175287050a4cee4",
          title: { en: "Spearmint Powder" },
          subtitle: { en: "Mentha spicata L.; Leaf" },
        },
        {
          _id: "6458ae695175287050a4cee6",
          title: { en: "Spinach Extract" },
          subtitle: { en: "10:1; Spinacia  oleracea L.; Herb" },
        },
        {
          _id: "6458ae695175287050a4ceea",
          title: { en: "St.John's Wort Extract" },
          subtitle: { en: "12:1; Hypericum perforatum L; Aerial part" },
        },
        {
          _id: "6458ae695175287050a4cee8",
          title: { en: "St.John's Wort Extract" },
          subtitle: { en: "10:1; Hypericum perforatum L; Aerial part" },
        },
        {
          _id: "645cf5e1329034f1aee8c7c5",
          title: { en: "St.John's Wort Extract" },
          subtitle: {
            en: "1% Hypericin; 8:1; Hypericum perforatum L; Herb,Flowers",
          },
        },
        {
          _id: "6458ae695175287050a4ceee",
          title: { en: "Strawberry Extract" },
          subtitle: { en: "10:1; Fragaria ananassa Duchesne; Fruit" },
        },
        {
          _id: "6458ae695175287050a4cef0",
          title: { en: "Suma Extract" },
          subtitle: { en: "4:1; Pfaffia paniculata; Root" },
        },
        {
          _id: "6458ae695175287050a4cef4",
          title: { en: "Sweet Potato Extract" },
          subtitle: { en: "10:1; Ipomoea batatas L. Lam.; Root" },
        },
        {
          _id: "6458ae695175287050a4cc8b",
          title: { en: "Tauroursodeoxycholic Acid (TUDCA) Powder" },
          subtitle: { en: "Tauroursodeoxycholic acid" },
        },
        {
          _id: "6458ae695175287050a4cef8",
          title: { en: "Thymus Extract" },
          subtitle: { en: "Thymus Vulgaris; Herb" },
        },
        {
          _id: "6458ae695175287050a4d020",
          title: { en: "Trans Pterostilbene Powder" },
          subtitle: { en: "98% Trans-Pterostilbene" },
        },
        {
          _id: "6458ae695175287050a4cf76",
          title: { en: "Tremella Fuciformis Extract" },
          subtitle: { en: "10% Polysaccharides; Tremella fuciformis Berk; Fruit" },
        },
        {
          _id: "6458ae695175287050a4cefc",
          title: { en: "Tribulus Terrestris Extract" },
          subtitle: { en: "40% Saponine; Tribulus terrestris L.; Stem,Leaf" },
        },
        {
          _id: "6458ae695175287050a4cefe",
          title: { en: "Tribulus Terrestris Extract" },
          subtitle: { en: "90% Saponins; Tribulus terrestris L.; Aerial part" },
        },
        {
          _id: "6458ae695175287050a4cf02",
          title: { en: "Triphala Extract" },
          subtitle: {
            en: "40% Tannins; 6:1; Terminalia chebula, Emblica Officinalis, Terminalia Belerica; Fruit",
          },
        },
        {
          _id: "6458ae695175287050a4cfbc",
          title: { en: "Tri-Sodium Citrate Dihydrate Powder" },
          subtitle: { en: "58% Sodium" },
        },
        {
          _id: "6458ae695175287050a4cf78",
          title: { en: "Turkey-Tail Extract" },
          subtitle: { en: "5:1; Trametes versicolor L. Lloyd; Mycelium" },
        },
        {
          _id: "6458ae695175287050a4cf08",
          title: { en: "Valerian Extract" },
          subtitle: { en: "10:1; Valeriana Officinalis; Root" },
        },
        {
          _id: "6458ae695175287050a4d022",
          title: { en: "Vitamin A - Palmitate 250.000 IU/g Powder" },
          subtitle: { en: "2% Vitamin A" },
        },
        {
          _id: "6458ae695175287050a4d024",
          title: { en: "Vitamin B1 - Thiamine HCL Powder" },
          subtitle: { en: "98% Vitamin B1" },
        },
        {
          _id: "6458ae695175287050a4d028",
          title: { en: "Vitamin B12 - Cyanocobalamin Powder" },
          subtitle: { en: "1% Vitamin B12" },
        },
        {
          _id: "645cf5e1329034f1aee8c7de",
          title: { en: "Vitamin B12 - Cyanocobalamin Powder" },
          subtitle: { en: "98% Vitamin B12" },
        },
        {
          _id: "6458ae695175287050a4d02a",
          title: { en: "Vitamin B12 - Hydroxycobalamin Acetate Powder" },
          subtitle: { en: "96% Vitamin B12" },
        },
        {
          _id: "645cf5e1329034f1aee8c7e1",
          title: { en: "Vitamin B12 - Methylcobalamine on Mannitol Powder" },
          subtitle: { en: "" },
        },
        {
          _id: "645cf5e1329034f1aee8c7e3",
          title: { en: "Vitamin B12 - Methylcobalamine Powder" },
          subtitle: { en: "98% Vitamin B12" },
        },
        {
          _id: "6458ae695175287050a4d02c",
          title: { en: "Vitamin B13 - Orotic Acid Powder" },
          subtitle: { en: "99% Vitamin B13" },
        },
        {
          _id: "6458ae695175287050a4d030",
          title: { en: "Vitamin B17 - Amygdalin Powder" },
          subtitle: { en: "98% Vitamin B17" },
        },
        {
          _id: "6458ae695175287050a4d044",
          title: { en: "Vitamin B3 - Nicotinamide (Niacin)" },
          subtitle: { en: "98% Vitamin B3" },
        },
        {
          _id: "645cf5e1329034f1aee8c7eb",
          title: { en: "Vitamin B3 - Inositol Hexanicotinate" },
          subtitle: { en: "98% Vitamin B3" },
        },
        {
          _id: "6458ae695175287050a4d032",
          title: { en: "Vitamin B5 - Calcium Panthothenate Powder" },
          subtitle: { en: "98% Vitamin B5, 8% Calcium" },
        },
        {
          _id: "6458ae695175287050a4d034",
          title: { en: "Vitamin B6 - Pyridoxine HCL Powder" },
          subtitle: { en: "98% Vitamin B6" },
        },
        {
          _id: "645cf5e1329034f1aee8c7f1",
          title: { en: "Vitamin B6 - Pyridoxal-5-Phosphate Powder" },
          subtitle: { en: "98% Vitamin B6" },
        },
        {
          _id: "6458ae695175287050a4d036",
          title: { en: "Vitamin B7 - D-Biotin Powder" },
          subtitle: { en: "97% Vitamin B7" },
        },
        {
          _id: "6458ae695175287050a4d038",
          title: { en: "Vitamin B9 - Folic Acid Powder" },
          subtitle: { en: "97% Vitamin B9" },
        },
        {
          _id: "6458ae695175287050a4d03a",
          title: { en: "Vitamin C - Liposomal Powder" },
          subtitle: { en: "65% Vitamin C" },
        },
        {
          _id: "6458ae695175287050a4d03c",
          title: { en: "Vitamin C (Ascorbic Acid) Powder" },
          subtitle: { en: "99% Vitamin C" },
        },
        {
          _id: "6458ae695175287050a4d03e",
          title: { en: "Vitamin D3 Powder (microencapsulated)" },
          subtitle: { en: "100.000 IU/g" },
        },
        {
          _id: "645cf5e1329034f1aee8c7fa",
          title: { en: "RAWD3™ Powder (microencapsulated) " },
          subtitle: { en: "Vitamin D3 vegan 100.000 IU/g" },
        },
        {
          _id: "6458ae695175287050a4d040",
          title: { en: "Vitamin E Acetate Powder 50% Vitamin E" },
          subtitle: { en: "50% Vitamin E" },
        },
        {
          _id: "6458ae695175287050a4cf7c",
          title: { en: "Volvariella Extract" },
          subtitle: { en: "10:1; Volvariella Volvacea; Fruit" },
        },
        {
          _id: "6458ae695175287050a4cf16",
          title: { en: "Watercress Extract" },
          subtitle: { en: "4:1; Nasturtium officinale P.E.; Herb" },
        },
        {
          _id: "6458ae695175287050a4cf40",
          title: { en: "Wheat Germ Extract" },
          subtitle: { en: "Triticum aestivum L.; Bark" },
        },
        {
          _id: "6458ae695175287050a4cffe",
          title: { en: "Whey Protein Isolate Powder" },
          subtitle: { en: "90% Protein" },
        },
        {
          _id: "6458ae695175287050a4cf1c",
          title: { en: "White Kidney Bean Extract" },
          subtitle: { en: "10:1; Phaseolus Vulgaris L.; Seed" },
        },
        {
          _id: "6458ae695175287050a4cf1e",
          title: { en: "White Mulberry Extract" },
          subtitle: { en: "10:1; Morus Alba L.; Leaf" },
        },
        {
          _id: "6458ae695175287050a4cf20",
          title: { en: "White Tea Extract" },
          subtitle: { en: "4:1; Camellia sinensis; Plant" },
        },
        {
          _id: "6458ae695175287050a4cf22",
          title: { en: "White Willow Extract" },
          subtitle: { en: "15% Salicin; Salix alba L.; Bark" },
        },
        {
          _id: "6458ae695175287050a4cf24",
          title: { en: "White Willow Extract" },
          subtitle: { en: "10% Salicin; Salix Alba L.; Bark" },
        },
        {
          _id: "6458ae695175287050a4cf26",
          title: { en: "Wild Yam Extract" },
          subtitle: { en: "20% Diosgenin; Dioscorea opposita Thunb; Rhizome" },
        },
        {
          _id: "6458ae695175287050a4cf28",
          title: { en: "Yarrow Extract" },
          subtitle: { en: "10:1; Achillea millefolium L.; Herb" },
        },
        {
          _id: "6458ae695175287050a4cf2a",
          title: { en: "Yellow Dock Extract" },
          subtitle: { en: "10:1; Rumex Crispus L.; Root" },
        },
        {
          _id: "6458ae695175287050a4cfc0",
          title: { en: "Zinc Bisglycinate Powder" },
          subtitle: { en: "29% Zinc" },
        },
        {
          _id: "645cf5e1329034f1aee8c80a",
          title: { en: "Zinc Bisglycinate Powder" },
          subtitle: { en: "28% Zinc" },
        },
        {
          _id: "645cf5e1329034f1aee8c80c",
          title: { en: "Zinc Bisglycinate Powder" },
          subtitle: { en: "29% Zinc, 12.5% Nitrogen" },
        },
        {
          _id: "645cf5e1329034f1aee8c80e",
          title: { en: "Zinc Bisglycinate Powder" },
          subtitle: { en: "20% Zinc" },
        },
        {
          _id: "6458ae695175287050a4cfc2",
          title: { en: "Zinc Citrate Dihydrate Powder" },
          subtitle: { en: "33% Zinc" },
        },
        {
          _id: "6458ae695175287050a4cfc4",
          title: { en: "Zinc Oxide Powder" },
          subtitle: { en: "80% Zinc" },
        },
        {
          _id: "6458ae695175287050a4cfc6",
          title: { en: "Zinc Picolinate Powder" },
          subtitle: { en: "21% Zinc" },
        },
        {
          _id: "645cf5e1329034f1aee8c814",
          title: { en: "Sodium Hyaluronate 500-700 KdA" },
          subtitle: { en: "95% Sodium Hyaluronate, 44% Glucuronic acid" },
        },
        {
          _id: "645cf5e1329034f1aee8c816",
          title: { en: "Bovine Collagen peptides" },
          subtitle: { en: "90% Protein" },
        },
        {
          _id: "645cf5e1329034f1aee8c818",
          title: { en: "Peppermint Extract" },
          subtitle: { en: "4:1; Mentha ×piperita; Whole Herb" },
        },
        {
          _id: "646499039399c654f1361058",
          title: { en: "Milk Thistle Extract" },
          subtitle: {
            en: "80% Silymarin, 30% Silybin &Isosilybin; Silybum marianum L. Gaertn; Seed",
          },
        },
        {
          _id: "646499039399c654f136105a",
          title: { en: "Coenzym Q10 Granular" },
          subtitle: { en: "98% Ubiquinone" },
        },
        {
          _id: "646499039399c654f136105c",
          title: { en: "Vitamin B12 - Adenosylcobalamine Powder" },
          subtitle: { en: "98% Vitamin B12" },
        },
        {
          _id: "646c97d8a7a139f2b2c2b5e0",
          title: { en: "Vegan Vitamin D3 5000iu/G Cholecalciferol" },
          subtitle: { en: "" },
        },
        {
          _id: "6475bc6d6bf4a13fd538eb5d",
          title: { en: "Organic Acai Powder" },
          subtitle: { en: "3-5:1; Euterpe Oleracea; Fruit" },
        },
        {
          _id: "6475bc6d6bf4a13fd538eb5f",
          title: { en: "Organic Acerola Powder" },
          subtitle: { en: "17% Vitamin C; 12-15:1; Malpighia glabra L.; Fruit" },
        },
        {
          _id: "6475bc6d6bf4a13fd538eb61",
          title: { en: "Organic Almond Protein Powder" },
          subtitle: { en: "45% Protein; Seed" },
        },
        {
          _id: "6475bc6d6bf4a13fd538eb63",
          title: { en: "Organic Amla Powder" },
          subtitle: { en: "30% Polyphenols; Emblica Officinalis; Fruit" },
        },
        {
          _id: "6475bc6d6bf4a13fd538eb66",
          title: { en: "Organic Artichoke Extract" },
          subtitle: { en: "3% Cynarin; 10-20:1; Cynara Scolymus L.; Leaf" },
        },
        {
          _id: "6475bc6d6bf4a13fd538eb68",
          title: { en: "Organic Ashwagandha Extract" },
          subtitle: { en: "5% Withanolides; 25:1; Withania somnifera; Root" },
        },
        {
          _id: "6475bc6d6bf4a13fd538eb6a",
          title: { en: "Organic Ashwagandha Powder" },
          subtitle: { en: "0.1% Withanolides; Withania somnifera; Root" },
        },
        {
          _id: "6475bc6d6bf4a13fd538eb6c",
          title: { en: "Organic Astragalus powder" },
          subtitle: {
            en: "50% Polysaccharides; 10:1; Astragalus membranaceus; Root",
          },
        },
        {
          _id: "6475bc6d6bf4a13fd538eb6e",
          title: { en: "Organic Bacopa Brahmi Extract" },
          subtitle: { en: "20% Bacosides; Bacopa monnieri L. Wettst.; Plant" },
        },
        {
          _id: "6475bc6d6bf4a13fd538eb70",
          title: { en: "Organic Bamboo Extract" },
          subtitle: { en: "75% Silica; Lophatherum gracile Brongn; Sprout" },
        },
        {
          _id: "6475bc6d6bf4a13fd538eb72",
          title: { en: "Organic Bamboo Extract" },
          subtitle: { en: "30% Silica; Bambusoideae; Plant" },
        },
        {
          _id: "6475bc6d6bf4a13fd538eb74",
          title: { en: "Organic Baobab Fruit Powder" },
          subtitle: { en: "Adansonia Digitata L.; Fruit" },
        },
        {
          _id: "6475bc6d6bf4a13fd538eb76",
          title: { en: "Organic Barley Grass Powder" },
          subtitle: { en: "Hordeum Vulgare; Halm" },
        },
        {
          _id: "6475bc6d6bf4a13fd538eb78",
          title: { en: "Organic Bilberry Powder" },
          subtitle: { en: "6-8:1; Vaccinium Myrtillus; Fruit" },
        },
        {
          _id: "6475bc6d6bf4a13fd538eb7a",
          title: { en: "Organic Black Aronia Extract" },
          subtitle: { en: "4:1; Rosaceae Photinia Melanocarpa; Fruit" },
        },
        {
          _id: "6475bc6d6bf4a13fd538eb7c",
          title: { en: "Organic Black Cumin Extract" },
          subtitle: { en: "2-3:1; Nigella sativa; Seed" },
        },
        {
          _id: "6475bc6d6bf4a13fd538eb7e",
          title: { en: "Organic Black Maca Powder" },
          subtitle: { en: "Lepidium Meyenii Walp; Root" },
        },
        {
          _id: "6475bc6d6bf4a13fd538eb80",
          title: { en: "Organic Black Pepper Powder" },
          subtitle: { en: "5% Piperine; Piper Nigrum L.; Fruit" },
        },
        {
          _id: "6475bc6d6bf4a13fd538eb82",
          title: { en: "Organic Black Pepper Extract" },
          subtitle: { en: "95% Piperine; Piper Nigrum L.; Fruit" },
        },
        {
          _id: "6475bc6d6bf4a13fd538eb84",
          title: { en: "Organic Brahmi Powder" },
          subtitle: { en: "Bacopa Monnieri; Leaf" },
        },
        {
          _id: "6475bc6d6bf4a13fd538eb86",
          title: { en: "Organic Broccoli Extract" },
          subtitle: { en: "4:1; Brassica Oleracea Var. Italica; Floral Bud" },
        },
        {
          _id: "6475bc6d6bf4a13fd538eb88",
          title: { en: "Organic Burdock Extract" },
          subtitle: { en: "5:1; Arctium Lappa L.; Root" },
        },
        {
          _id: "6475bc6d6bf4a13fd538eb8a",
          title: { en: "Organic Chicory Extract" },
          subtitle: { en: "20% Inulin; Cichorium intybus L.; Root" },
        },
        {
          _id: "6475bc6d6bf4a13fd538eb8c",
          title: { en: "Organic Chlorella Powder" },
          subtitle: { en: "Chlorella vulgaris ext.; Plant" },
        },
        {
          _id: "6475bc6d6bf4a13fd538eb8e",
          title: { en: "Organic Cinnamon Powder" },
          subtitle: { en: "Cinnamomum verum J.Presl; Bark" },
        },
        {
          _id: "6475bc6d6bf4a13fd538eb90",
          title: { en: "Organic Cinnamon malted Powder" },
          subtitle: { en: "Cinnamomum verum J.Presl; Bark" },
        },
        {
          _id: "6475bc6d6bf4a13fd538eb92",
          title: { en: "Organic Coconut Milk Powder" },
          subtitle: { en: "" },
        },
        {
          _id: "6475bc6d6bf4a13fd538eb94",
          title: { en: "Organic Coprinus Powder" },
          subtitle: { en: "Coprinus Comatus; Fruit Body" },
        },
        {
          _id: "6475bc6d6bf4a13fd538eb97",
          title: { en: "Organic Curcuma (Turmeric) Extract" },
          subtitle: { en: "95% Curcuminoides; 50:1; Curcuma longa; Rhizomes" },
        },
        {
          _id: "6475bc6d6bf4a13fd538eb99",
          title: { en: "Organic Curcuma (Turmeric) Powder" },
          subtitle: { en: "5% Curcuminoides; Curcuma longa; Rhizomes" },
        },
        {
          _id: "6475bc6d6bf4a13fd538eb9b",
          title: { en: "Organic Fenugreek Extract" },
          subtitle: { en: "Trigonella Foenum Graecum L.; Plant" },
        },
        {
          _id: "6475bc6d6bf4a13fd538eb9d",
          title: { en: "Organic Fireweed Extract" },
          subtitle: {
            en: "15% Polyphenols; Onagraceae Epilobium angustifolium L.; Aerial part",
          },
        },
        {
          _id: "6475bc6d6bf4a13fd538eb9f",
          title: { en: "Organic Ginger Powder" },
          subtitle: { en: "Zingiber officinale; Root" },
        },
        {
          _id: "6475bc6d6bf4a13fd538eba1",
          title: { en: "Organic Lemon Powder" },
          subtitle: { en: "Citrus x Limon; Fruit" },
        },
        {
          _id: "6475bc6d6bf4a13fd538eba3",
          title: { en: "Organic Lemon Extract" },
          subtitle: { en: "3-5:1; Citrus x Limon; Fruit" },
        },
        {
          _id: "6475bc6d6bf4a13fd538eba5",
          title: { en: "Organic Licorice Powder" },
          subtitle: { en: "Glycyrrhiza Glabra; Plant" },
        },
        {
          _id: "6475bc6d6bf4a13fd538eba7",
          title: { en: "Organic Lucuma Powder" },
          subtitle: { en: "Pouteria Lucuma; Fruit" },
        },
        {
          _id: "6475bc6d6bf4a13fd538eba9",
          title: { en: "Organic Maca Extract" },
          subtitle: { en: "4:1; Lepidium meyenii Walp; Root" },
        },
        {
          _id: "6475bc6d6bf4a13fd538ebab",
          title: { en: "Organic Maca Powder" },
          subtitle: { en: "Lepidium meyenii Walp; Root" },
        },
        {
          _id: "6475bc6d6bf4a13fd538ebad",
          title: { en: "Organic Milk Thistle Powder" },
          subtitle: { en: "Silybum Marianum L. Gaertn; Seed" },
        },
        {
          _id: "6475bc6d6bf4a13fd538ebaf",
          title: { en: "Organic Milk Thistle Extract" },
          subtitle: {
            en: "50% Silymarin; 15-20:1; Compositae Silybum marianum (L.) Gaertner; Dried fruit",
          },
        },
        {
          _id: "6475bc6d6bf4a13fd538ebb1",
          title: { en: "Organic Propolis Extract" },
          subtitle: { en: "" },
        },
        {
          _id: "6475bc6d6bf4a13fd538ebb3",
          title: { en: "Organic Rhodiola Extract" },
          subtitle: { en: "10:1; Rhodiola Rosea; Root" },
        },
        {
          _id: "6475bc6d6bf4a13fd538ebb5",
          title: { en: "Organic Rosehip Powder" },
          subtitle: { en: "Rosa canina L.; Fruit" },
        },
        {
          _id: "6475bc6d6bf4a13fd538ebb7",
          title: { en: "Organic Shatavari Powder" },
          subtitle: { en: "Asparagus Racemosus; Root" },
        },
        {
          _id: "6475bc6d6bf4a13fd538ebb9",
          title: { en: "Organic Spinach Powder" },
          subtitle: { en: "Spinacia Oleracea; Fruit" },
        },
        {
          _id: "6475bc6d6bf4a13fd538ebbb",
          title: { en: "Omega 3 Powder with DHA from Algae" },
          subtitle: { en: "20% DHA" },
        },
        {
          _id: "6475bc6d6bf4a13fd538ebbd",
          title: { en: "Organic Astaxanthin powder" },
          subtitle: { en: "5% Astaxanthin; Haematococcus pluvialis; Fruit" },
        },
        {
          _id: "6475bc6d6bf4a13fd538ebbf",
          title: { en: "Pine Pollen Powder" },
          subtitle: { en: "Pinus Massoniana Lamb L.; Pollen" },
        },
        {
          _id: "6475bc6d6bf4a13fd538ebc1",
          title: { en: "Shark Cartilage" },
          subtitle: { en: "Shark Bone" },
        },
        {
          _id: "6475bc6d6bf4a13fd538ebc3",
          title: { en: "Collagen Hydrolyzate Bovine Type 1 & 3" },
          subtitle: { en: "Beef Skin,Cow Bone" },
        },
        {
          _id: "6475bc6d6bf4a13fd538ebc5",
          title: { en: "Royal Jelly Powder" },
          subtitle: { en: "35% Protein" },
        },
        {
          _id: "6475f63e61206c77f480886c",
          title: { en: "VITAMIN K2 (MK-7)" },
          subtitle: { en: "1.3% in Calcium Hydrogen Phosphate(DCP)" },
        },
        {
          _id: "6478a44a1b4bd6dab6b078e4",
          title: { en: "Xanthan Gum Mesh 80" },
          subtitle: { en: "" },
        },
        {
          _id: "6478a6a7e7f3bda10d25476f",
          title: { en: "Xanthan Gum Mesh 200" },
          subtitle: { en: "" },
        },
        {
          _id: "6478b37a3db2bd4d79dfec18",
          title: { en: "Glycine" },
          subtitle: { en: "98.5% Glycine" },
        },
        {
          _id: "647a033ad65c45fa8ad8b022",
          title: { en: "Magnesium Carbonate heavy" },
          subtitle: { en: "25% Magnesium" },
        },
        {
          _id: "647a05b6d65c45fa8ad8b02b",
          title: { en: "Tri-Magnesium Dicitrate Anhydrous" },
          subtitle: { en: "15% - 16,5% Magnesium" },
        },
        {
          _id: "647b39fbcf16c0670e1750c6",
          title: { en: "Aspartate" },
          subtitle: { en: "" },
        },
        {
          _id: "6483400b035cf428feb1f9b8",
          title: { en: "Organic Reishi Extract" },
          subtitle: {
            en: "2% Polysaccharide; 1:1; Ganoderma Lucidum; Fruit Body",
          },
        },
        {
          _id: "648455f369d3d8b472716821",
          title: { en: "Organic Reishi Extract" },
          subtitle: {
            en: "30% Polysaccharide; 8:1; Ganoderma Lucidum; Fruit Body",
          },
        },
        {
          _id: "648456c069d3d8b472716826",
          title: { en: "Organic Reishi Extract " },
          subtitle: {
            en: "20% Polysaccharide; 15:1; Ganoderma Lucidum; Fruit Body",
          },
        },
        {
          _id: "6484573069d3d8b47271682b",
          title: { en: "Organic Reishi DUAL Extract" },
          subtitle: {
            en: "25% Polysaccharide; 15:1; Ganoderma Lucidum; Fruit Body",
          },
        },
        {
          _id: "648457e5325cc9308bf3542a",
          title: { en: "Organic Maitake Extract " },
          subtitle: {
            en: "4% Polysaccharide, 30% Beta Glucan; 1:1; Grifola Frondosa; Fruit Body",
          },
        },
        {
          _id: "64845910325cc9308bf35431",
          title: { en: "Organic Maitake Extract" },
          subtitle: {
            en: "30% Polysaccharide, 25% Beta Glucan; 4:1; Grifola Frondosa; Fruit Body",
          },
        },
        {
          _id: "64845948325cc9308bf35438",
          title: { en: "Organic Maitake  Extract" },
          subtitle: {
            en: "25% Polysaccharide, 20% Beta Glucan; 8:1; Grifola Frondosa; Fruit Body",
          },
        },
        {
          _id: "6484597a325cc9308bf3543f",
          title: { en: "Organic Lion's Mane Extract" },
          subtitle: {
            en: "3% Polysaccharide, 25% Beta Glucan; 1:1; Hericium Erinaceus; Fruit",
          },
        },
        {
          _id: "648459c798fef54d0d4f7a33",
          title: { en: "Organic Lion's Mane Extract" },
          subtitle: {
            en: "30% Polysaccharide, 28% Beta Glucan; 4:1; Hericium Erinaceus; Fruit",
          },
        },
        {
          _id: "64845a0398fef54d0d4f7a3a",
          title: { en: "Organic Lion's Mane Extract" },
          subtitle: {
            en: "20% Polysaccharide, 18% Beta Glucan; 8:1; Hericium Erinaceus; Fruit",
          },
        },
        {
          _id: "64845a2e98fef54d0d4f7a41",
          title: { en: "Organic Lion's Mane DUAL Extract" },
          subtitle: {
            en: "20% Polysaccharide, 20% Beta Glucan, 2% Triterpenoid Saponins; 8:1; Hericium Erinaceus; Fruit",
          },
        },
        {
          _id: "64845b273c28f6644713e501",
          title: { en: "Organic Shiitake  Extract" },
          subtitle: {
            en: "3% Polysaccharide, 28% Beta Glucan; 1:1; Lentinula Edodes; Fruit",
          },
        },
        {
          _id: "64845b6c3c28f6644713e508",
          title: { en: "Organic Shiitake Extract" },
          subtitle: {
            en: "30% Polysaccharide, 25% Beta Glucan; 4:1; Lentinula Edodes; Fruit",
          },
        },
        {
          _id: "64845b993c28f6644713e50f",
          title: { en: "Organic Shiitake Extract" },
          subtitle: {
            en: "20% Polysaccharide, 15% Beta Glucan; 8:1; Lentinula Edodes; Fruit",
          },
        },
        {
          _id: "64845bc13c28f6644713e516",
          title: { en: "Organic Cordyceps Militaris Extract" },
          subtitle: {
            en: "3% Polysaccharide; 1:1; Cordyceps Militaris; Fruit Body",
          },
        },
        {
          _id: "64845bf13c28f6644713e51e",
          title: { en: "Organic Cordyceps Militaris Extract" },
          subtitle: {
            en: "25% Polysaccharide; 8:1; Cordyceps Militaris; Fruit Body",
          },
        },
        {
          _id: "64845c433c28f6644713e525",
          title: { en: "Organic Cordyceps Militaris DUAL Extract" },
          subtitle: {
            en: "30% Polysaccharide, 25% Beta Glucan; 1:1; Cordyceps Militaris; Fruit Body",
          },
        },
        {
          _id: "648729f17e77b39eb9daa2e7",
          title: { en: "Test" },
          subtitle: { en: "" },
        },
        {
          _id: "6489a4e0482ced78dde91bea",
          title: { en: "Vitamin K2 (MK-7) powder 2,000 ppm/g" },
          subtitle: {
            en: "0.2% Vitamin K2 (MK-7), 71% Starch, 14% Soybean oil, 10% Sodium casein, 0.5% Ascorbyl palmitate, 2% Starch sodium octenylsuccinate, 1% Glycerol fatty acid ester; Bacillus subtilis Natto; Soybean",
          },
        },
        {
          _id: "6492b2f54213d181454b1c9a",
          title: { en: "Garcinia Cambogia Extract" },
          subtitle: { en: "60% HCA; 5:1; Garcinia cambogia; Fruit" },
        },
        {
          _id: "6492fad3be104a98a4d6f414",
          title: { en: "Organic Chaga powder" },
          subtitle: {
            en: "3% Polysaccharide, 8% Beta-Glucan; 1:1; Inonotus Obliquus; Fruit Body",
          },
        },
        {
          _id: "6493017c6ec293da6f68fc22",
          title: { en: "Organic Chaga Extract" },
          subtitle: {
            en: "10% Polysaccharide, 5% Glucans; 4:1; Inonotus Obliquus; Fruit Body",
          },
        },
        {
          _id: "649303d46ec293da6f68fc2e",
          title: { en: "Organic Chaga Extract" },
          subtitle: {
            en: "15% Polysaccharide, 12% Glucans; 8:1; Inonotus Obliquus; Fruit Body",
          },
        },
        {
          _id: "649305a06ec293da6f68fc3d",
          title: { en: "Organic Chaga Dual Extract" },
          subtitle: {
            en: "15% Polysaccharide, 12% Glucans, 0.5% Betulin; 8:1; Inonotus Obliquus; Fruit Body",
          },
        },
        {
          _id: "649307a16ec293da6f68fc49",
          title: { en: "Organic Turkey Tail Extract " },
          subtitle: {
            en: "5% Polysaccharide, 48% Beta-Glucan; 1:1; Trametes Versicolor; Fruit Body",
          },
        },
        {
          _id: "649309886ec293da6f68fc55",
          title: { en: "Organic Turkey Tail Extract " },
          subtitle: {
            en: "40% Polysaccharide, 20% Glucans; 6:1; Trametes Versicolor; Fruit Body",
          },
        },
        {
          _id: "64930af66ec293da6f68fc60",
          title: { en: "Organic Turkey Tail Extract" },
          subtitle: {
            en: "40% Polysaccharide, 40% Glucans; 12:1; Trametes Versicolor; Fruit Body",
          },
        },
        {
          _id: "64943732d67222393a8977ee",
          title: { en: "Red Yeast Rice Extract" },
          subtitle: { en: "1% Monacolin K; Monascus Purpureus; Monascussp" },
        },
        {
          _id: "649443b2d67222393a8977fd",
          title: { en: "Methyl Sulfonyl Methane (MSM)" },
          subtitle: { en: "40-60 mesh, 0.5% Silicon Dioxide" },
        },
        {
          _id: "64958f54ab4105b14afe344b",
          title: { en: "Nattokinase 15.000 FU/g" },
          subtitle: {
            en: "40% Soy Protein, 22% Microcrystalline Cellulose, 6% Nattokinase; Seed",
          },
        },
        {
          _id: "649afe445e8cac71536fdc41",
          title: { en: "Soy Protein Isolate" },
          subtitle: { en: "90% Dry basis protein" },
        },
        {
          _id: "649b00205e8cac71536fdc48",
          title: { en: "Caffeine Anhydrous Powder" },
          subtitle: { en: "" },
        },
        {
          _id: "649b01e05e8cac71536fdc4f",
          title: { en: "Sucralose Powder (E955)" },
          subtitle: { en: "" },
        },
        {
          _id: "649b037f5e8cac71536fdc58",
          title: { en: "L(+)- Choline Bitartrate" },
          subtitle: { en: "40.31% Choline" },
        },
        {
          _id: "649d82c309e41535d2be627b",
          title: { en: "Ferrous bisglycinate Powder (Light yellow powder)" },
          subtitle: { en: "20% Ferrous" },
        },
        {
          _id: "649ee09264818beb7fe51ee0",
          title: { en: "D-Glucosamine Sulphate Potassium Chloride 30 Mesh" },
          subtitle: { en: "98% Glucosamine" },
        },
        {
          _id: "649ee35564818beb7fe51ef1",
          title: { en: "Betaine Hydrochloride" },
          subtitle: { en: "98% Betaine" },
        },
        {
          _id: "649ee61064818beb7fe51efc",
          title: { en: "Boswellia Extract" },
          subtitle: {
            en: "65% Boswellic Acid; 6-10:1; Boswellia Serrata; Bark/Gum resin",
          },
        },
        {
          _id: "649ee67164818beb7fe51f05",
          title: { en: "Boswellia Extract" },
          subtitle: { en: "85% Boswellic Acid; Boswellia Serrata; Resin (Gum)" },
        },
        {
          _id: "649ee6a064818beb7fe51f0e",
          title: { en: "Ashwagandha Extract" },
          subtitle: { en: "5% Withanolide; 10:1; Withania Somnifera; Root" },
        },
        {
          _id: "649ee6d764818beb7fe51f17",
          title: { en: "Ashwagandha Extract" },
          subtitle: { en: "10% Withanolide; 25:1; Withania Somnifera; Root" },
        },
        {
          _id: "649ee70964818beb7fe51f20",
          title: { en: "Ashwagandha Extract" },
          subtitle: { en: "5:1; Withania Somnifera; Plant" },
        },
        {
          _id: "649ee73664818beb7fe51f29",
          title: { en: "Psyllium Husk (95%) Powder" },
          subtitle: { en: "Plantago Ovata L.; Husk" },
        },
        {
          _id: "649ee75464818beb7fe51f32",
          title: { en: "Psyllium Husk (99%) Powder" },
          subtitle: { en: "Plantago Ovata L.; Husk" },
        },
        {
          _id: "649ee77a64818beb7fe51f3b",
          title: { en: "Blueberry Extract" },
          subtitle: {
            en: "10% Anthocyanidin; 10:1; Vaccinium Myrtillus L.; Berry",
          },
        },
        {
          _id: "649ee79b64818beb7fe51f44",
          title: { en: "Cacao Extract" },
          subtitle: { en: "50% Cacao Alkaloids; Theobroma Cacao; Seed" },
        },
        {
          _id: "649ee7c764818beb7fe51f4d",
          title: { en: "Camu Camu Powder" },
          subtitle: { en: "25% Vitamin C; Myrciaria dubia; Fruit" },
        },
        {
          _id: "649ee7e864818beb7fe51f56",
          title: { en: "Camu Camu Extract - added" },
          subtitle: { en: "50% Vitamin C; Myrciaria dubia; Fruit" },
        },
        {
          _id: "649ee80e64818beb7fe51f5f",
          title: { en: "Camu Camu Extract - natural" },
          subtitle: { en: "25% Vitamin C; Myrciaria dubia; Fruit" },
        },
        {
          _id: "649ee83b64818beb7fe51f68",
          title: { en: "Bromelain 600 GDU/g" },
          subtitle: { en: "Ananas Comosus" },
        },
        {
          _id: "649ee85b64818beb7fe51f71",
          title: { en: "Bromelain 2,500 GDU/g" },
          subtitle: { en: "Ananas Comosus" },
        },
        {
          _id: "649ee95464818beb7fe51f81",
          title: { en: "Curcuma (Turmeric) Extract" },
          subtitle: { en: "95% Curcuminoids; Curcuma Longa; Root" },
        },
        {
          _id: "649ee97164818beb7fe51f8a",
          title: { en: "Curcuma (Turmeric) Extract Granules" },
          subtitle: { en: "95% Curcuminoide; Curcuma Longa; Root" },
        },
        {
          _id: "649ee9c364818beb7fe51f99",
          title: { en: "Marigold Extract" },
          subtitle: { en: "10% Lutein, 2% Zeaxanthin; Tagetes Erecta; Petals" },
        },
        {
          _id: "649ee9d764818beb7fe51fa2",
          title: { en: "Marigold Extract" },
          subtitle: { en: "10% Lutein, 2% Zeaxanthin; Tagetes Erecta; Petals" },
        },
        {
          _id: "649ee9fe64818beb7fe51fab",
          title: { en: "Guarana Extract" },
          subtitle: {
            en: "22% Caffeine; Sapindaceae Paullinia cupana Kunth; Seed",
          },
        },
        {
          _id: "649eea1c64818beb7fe51fb4",
          title: { en: "Guarana Extract" },
          subtitle: {
            en: "10% Caffeine; Sapindaceae Paullinia cupana Kunth; Fruit",
          },
        },
        {
          _id: "649eea3f64818beb7fe51fbd",
          title: { en: "Artichoke Extract" },
          subtitle: { en: "2% Cynarin; Cynara scolymus L.; Leaf" },
        },
        {
          _id: "649eea5c64818beb7fe51fc6",
          title: { en: "Artichoke Extract" },
          subtitle: { en: "5% Cynarin; 15-30:1; Cynara scolymus L.; Leaf" },
        },
        {
          _id: "649eea8264818beb7fe51fcf",
          title: { en: "Organic Artichoke Extract" },
          subtitle: { en: "3% Cynarin; 10-20:1; Cynara Scolymus L.; Leaf" },
        },
        {
          _id: "649eeac5afc39a9d236201f1",
          title: { en: "Maca Extract " },
          subtitle: { en: "0,6% Macaenes; 10:1; Lepidium meyenii Walp; Root" },
        },
        {
          _id: "649eeb0bafc39a9d23620200",
          title: { en: "Maca Extract" },
          subtitle: { en: "10:1; Lepidium meyenii Walp; Root" },
        },
        {
          _id: "649eeb26afc39a9d23620209",
          title: { en: "Maca Extract" },
          subtitle: { en: "20:1; Lepidium meyenii Walp; Root" },
        },
        {
          _id: "649eeb42afc39a9d23620212",
          title: { en: "Black Maca Extract" },
          subtitle: { en: "10:1; Lepidium meyenii Walp; Root" },
        },
        {
          _id: "649eeb5dafc39a9d2362021b",
          title: { en: "Red Maca Extract" },
          subtitle: { en: "10:1; Lepidium meyenii Walp; Root" },
        },
        {
          _id: "64a2d771546b742851561d47",
          title: { en: "Broccoli Extract 10% Glucoraphanin (HPLC)" },
          subtitle: {
            en: "10% Glucoraphanin; Brassica oleracea L. var. botrytis L.; Seed",
          },
        },
        {
          _id: "64a2ecdf546b742851561d65",
          title: { en: "Brown rice protein 600 mesh" },
          subtitle: { en: "90% Protein; Oryza sativa; Seed" },
        },
        {
          _id: "64a2f36a17bdd4b7e7967019",
          title: { en: "Orange flavoured psyllium husk powder" },
          subtitle: { en: "Plantago Ovata L.; Husk" },
        },
        {
          _id: "64a2f9f747aceb71ef9714b0",
          title: { en: "Chitosan (Acid-soluble) " },
          subtitle: { en: "Pleurotus ostreatus; Mushroom" },
        },
        {
          _id: "64a6da282c7cc210204e8366",
          title: { en: "Chitosan Oligosaccharide (Water-soluble)" },
          subtitle: { en: "Aspergillus Niger; Mushroom" },
        },
        {
          _id: "64a6dea62c7cc210204e8394",
          title: { en: "Chitosan extract" },
          subtitle: { en: "15% Glucans, 2% Protein; Agaricus Bisporus; Stem" },
        },
        {
          _id: "64a8428f1f4a7b2692c11759",
          title: { en: "Gamma-Aminobutyric acid (GABA)" },
          subtitle: { en: "" },
        },
        {
          _id: "64a851f2689132609aeea112",
          title: { en: "Creatinol-O-Phosphate (COP)" },
          subtitle: { en: "" },
        },
        {
          _id: "64abc7978c6de877b816ed5b",
          title: { en: "L-Tyrosine Instant Powder" },
          subtitle: { en: "99% L-Tyrosine" },
        },
        {
          _id: "64abf28a8c6de877b816ed73",
          title: { en: "Spirulina algae powder" },
          subtitle: { en: "60% Protein; Arthrospira platensis" },
        },
        {
          _id: "64ac0d185c9bb6179786e03e",
          title: { en: "Lactase 20,000 ALU/g. Powder" },
          subtitle: { en: "" },
        },
        {
          _id: "64ad2b1800f4aea74ce9b485",
          title: { en: "BCAA 4:1:1 Powder (Instant)" },
          subtitle: {
            en: "60% L-Leucine, 15% L-Isoleucine, 15% L-Valine, 0.5% Sunflower Lecithin",
          },
        },
        {
          _id: "64ad2cae83857a2148025639",
          title: { en: "BCAA 2:1:1(Instant)" },
          subtitle: { en: "" },
        },
        {
          _id: "64ad2cd583857a214802564c",
          title: { en: "L-Leucine Instant" },
          subtitle: { en: "95% L-Leucine, 0.5% Sunflower Lecithin" },
        },
        {
          _id: "64ad2d0083857a2148025667",
          title: { en: "L-Isoleucine Instant" },
          subtitle: { en: "95% L-Isoleucine" },
        },
        {
          _id: "64ad2d2383857a214802567a",
          title: { en: "L-Valine Instant" },
          subtitle: { en: "95% L-Valine, 0.5% Lecithin" },
        },
        {
          _id: "64b524aaafd3f3d8e133ba03",
          title: { en: "Erythritol" },
          subtitle: {
            en: "99.5% Erythritol, 0.1% Ribitol and Glycerol, 0.3% Reducing sugars; -; -",
          },
        },
        {
          _id: "64b53341b8fda4ae3f76c3d8",
          title: { en: "Artichoke Extract" },
          subtitle: { en: "2.5% Cynarin; Cynara scolymus L.; Leaf" },
        },
        {
          _id: "64b94f82177010919ae58986",
          title: { en: "St.John's Wort Extract" },
          subtitle: {
            en: "0.3% Hypericin; 8:1; Hypericum perforatum L.; Flowers & Leaves",
          },
        },
        {
          _id: "64ba6bcf7efb400489ba9565",
          title: { en: "Nattokinase 5,000 FU/g" },
          subtitle: {
            en: "40% Soy Protein, 26% Microcrystalline Cellulose, 26% Dietary fiber, 3% Nattokinase; Bacillus subtilis Natto; Seed",
          },
        },
        {
          _id: "64ba7d954ca517f3c2c675ee",
          title: { en: "Nattokinase 10,000 FU/g" },
          subtitle: {
            en: "40% Soy Protein, 22% Microcrystalline Cellulose, 22% Resistant dextrin, 6% Nattokinase; Bacillus subtilis Natto; Seed",
          },
        },
        {
          _id: "64bfa50c7c128152a34be5d6",
          title: { en: "Glucosamine Hydrochloride" },
          subtitle: { en: "" },
        },
        {
          _id: "64c0cb9b20a6832a33230947",
          title: { en: "Pea Protein Isolate" },
          subtitle: { en: "80% Protein; Pisum sativum Linn; Seed" },
        },
        {
          _id: "64c3915e7f87c9e84a6264f3",
          title: { en: "Methyl Sulfonyl Methane (MSM)" },
          subtitle: { en: "60-80 mesh" },
        },
        {
          _id: "64c77fe1854f95142e0e4b85",
          title: { en: "Citric Acid Monohydrate" },
          subtitle: { en: "99% Citric acid" },
        },
        {
          _id: "64c8d297ff2387201dd63d91",
          title: { en: "Taurine" },
          subtitle: { en: "0.5% Food grade Anti-caking agent" },
        },
        {
          _id: "64ca381c8585ef3c04188b3d",
          title: { en: "Sodium Hyaluronate 500-700 Kda" },
          subtitle: { en: "95% Natrium Hyaluronat, 46% Glucuronic acid" },
        },
        {
          _id: "64ca396d8585ef3c04188b52",
          title: {
            en: "Sodium Hyaluronate 800-1500 KdA (Bulk density 500-600 kg/m3)",
          },
          subtitle: { en: "95% Sodium Hyaluronate, 46% Glucuronic acid" },
        },
        {
          _id: "64ca39908585ef3c04188b67",
          title: {
            en: "Sodium Hyaluronate 800-1500 KdA  (Bulk density >700 kg/m3)",
          },
          subtitle: { en: "95% Sodium Hyaluronate, 44% Glucuronic acid" },
        },
        {
          _id: "64cb826d233729af892a173f",
          title: { en: "Inulin" },
          subtitle: {
            en: "90% Inulin, 10% Fructose+Glucose+Sucrose; Helianthus tuberosus L; Root",
          },
        },
        {
          _id: "64cb8718e53263f1699cf6f1",
          title: { en: "Inulin from Chicory" },
          subtitle: {
            en: "90% Inulin, 11% Fructose+Glucose+Sucrose; Cichorium intybus L.; Root",
          },
        },
        {
          _id: "64d2937ef58de7daff68bf8e",
          title: { en: "Vitamin D3 500,000 IU/g powder" },
          subtitle: { en: "" },
        },
        {
          _id: "64d296d5f58de7daff68bfb3",
          title: { en: "Vitamin D3 1,000,000 IU/g oil (Non-Vegan)" },
          subtitle: { en: "in Sunflower Seed Oil, 90% Vitamin D3" },
        },
        {
          _id: "64d294e96a568a4a6f62dd12",
          title: { en: "MCT Oil Powder" },
          subtitle: { en: "50% Caprylic acid (in fat), 35% Capric acid (in fat)" },
        },
        {
          _id: "64d2991ef58de7daff68bfcb",
          title: { en: "Vitamin E powder natural 700 IU/g" },
          subtitle: { en: "50% DL-alpha-tocopheryl acetate" },
        },
        {
          _id: "64d298cc6a568a4a6f62dd25",
          title: { en: "Coconut Oil Powder" },
          subtitle: { en: "" },
        },
        {
          _id: "64d35d56ce3d3ff10a891cb8",
          title: { en: "Microcrystalline Cellulose (MCC) Powder" },
          subtitle: { en: "MCC 101 " },
        },
        {
          _id: "64d35d97e8d08302b018beaf",
          title: { en: "Di-Calcium Phosphate Powder" },
          subtitle: { en: "70% Calcium" },
        },
        {
          _id: "64d4e4a9ac6b33459f8429e7",
          title: { en: "Vitamin E powder natural" },
          subtitle: { en: "30% Mixed tocopheryl" },
        },
        {
          _id: "64d4e5ecac6b33459f842a12",
          title: { en: "Vitamin A Acetate Powder 325,000 IU/g" },
          subtitle: { en: "90% Vitamin A" },
        },
        {
          _id: "64d4e712ac6b33459f842a34",
          title: { en: "Vitamin A Acetate Powder 500,000 IU/g" },
          subtitle: { en: "95% Vitamin A" },
        },
        {
          _id: "64d4e7b3ac6b33459f842a4e",
          title: { en: "Vitamin A Acetate Oil 1,000,000 IU/g" },
          subtitle: { en: "99% Vitamin A" },
        },
        {
          _id: "64d4efe633e50775e970ffb3",
          title: { en: "Fish Collagen peptides" },
          subtitle: { en: "90% Protein" },
        },
        {
          _id: "64d4fab02922bff2cd173d92",
          title: { en: "Astaxanthin powder" },
          subtitle: { en: "2% Astaxanthin; Haematoccocus Pluvialis; Microalgae" },
        },
        {
          _id: "64d4fc1d2922bff2cd173dae",
          title: { en: "DHA fish oil powder" },
          subtitle: { en: "15% Docosahexaenoic Acid, 1.5% Eicosapentaenoic Acid" },
        },
        {
          _id: "64d54071fc77a6134f4d01c2",
          title: { en: "DHA fish oil powder" },
          subtitle: { en: "10% " },
        },
        {
          _id: "64d5416bfc77a6134f4d01e1",
          title: { en: "Beta-Carotene Oil Suspension 30%" },
          subtitle: { en: "Suspension 30%" },
        },
        {
          _id: "64d5436bfc77a6134f4d01f9",
          title: { en: "Beta-Carotene powder" },
          subtitle: { en: "10% (not natural)" },
        },
        {
          _id: "64d544dbfc77a6134f4d0211",
          title: { en: "Beta-Carotene powder" },
          subtitle: { en: "1% (not natural)" },
        },
        {
          _id: "64d54627fc77a6134f4d0230",
          title: { en: "Vitamin A Palmitate powder 500,000IU/g" },
          subtitle: { en: "95% Vitamin A" },
        },
        {
          _id: "64db2f76ac73685ca48db129",
          title: { en: "Magnesium Stearate" },
          subtitle: { en: "4% Magnesium, 40% Stearic acid" },
        },
        {
          _id: "64db31f6ac73685ca48db150",
          title: { en: "Silicified Microcrystalline Cellulose" },
          subtitle: { en: "" },
        },
        {
          _id: "64db33c8ac73685ca48db172",
          title: { en: "Talc Powder" },
          subtitle: { en: "18% Magnesium" },
        },
        {
          _id: "64dc817d90a39d7776fb736a",
          title: { en: "Bamboo Extract" },
          subtitle: { en: "75% Silica(UV)" },
        },
        {
          _id: "64dc88c090a39d7776fb7395",
          title: { en: "L-Lysine HCL Powder" },
          subtitle: { en: "12% Mesh" },
        },
        {
          _id: "64df80fda7989d565eaecf52",
          title: { en: "Boswellia Extract Granules" },
          subtitle: { en: "85% Boswellic Acid; 10:1; Boswellia Serrata; Resin" },
        },
        {
          _id: "64e347f701f1c3edf6b003d7",
          title: { en: "Magnesium Bisglycinate Powder 10-12.5%" },
          subtitle: { en: "" },
        },
        {
          _id: "64e5ed893f34133595402482",
          title: { en: "Magnesium citrate buffered" },
          subtitle: { en: "30% Magnesium" },
        },
        {
          _id: "64f04c3e0a9cfc9bbd472407",
          title: { en: "Hydrolyzed Elastin (source marine fish)" },
          subtitle: { en: "75% Protein" },
        },
        {
          _id: "64f83f80f11d1a621f05af82",
          title: { en: "Sango Mineral Powder 2:1 " },
          subtitle: { en: "(20% Calcium / 10% Magnesium)" },
        },
        {
          _id: "64f85014f09c61641c9b3d51",
          title: { en: "Green Tea Extract" },
          subtitle: { en: "98% L-Theanine; Camellia Sinensis; Leaf" },
        },
        {
          _id: "64fb089a342fec6cc1802edd",
          title: { en: "Clear Whey Protein Isolate Powder" },
          subtitle: { en: "91% Protein Isolate" },
        },
        {
          _id: "6501856f6ced27c933a68b62",
          title: { en: " EAA instant" },
          subtitle: { en: "" },
        },
        {
          _id: "6501c6947e221a22d8da0339",
          title: { en: "Grape Seed Extract" },
          subtitle: { en: "95% OPC; Vitis vinifera L.; Seed" },
        },
        {
          _id: "6503109293eb7612be4681b0",
          title: { en: "L-Arginine HCL Powder (vegan)" },
          subtitle: { en: "83% L-Arginine" },
        },
        {
          _id: "650d6ea0ce40dfc7c1f57721",
          title: { en: "Sophora Japonica Extract Granules" },
          subtitle: { en: "95% Rutin; Sophora Japonica L.; Flowder,Buds" },
        },
        {
          _id: "651d358bbf0b54a287e08a92",
          title: { en: "Boswellia Extract" },
          subtitle: { en: "65% Boswellic Acid; Boswellia Serrata; Resin" },
        },
        {
          _id: "6526524b3f438ad94670bd1e",
          title: {
            en: "D-Glucosamine Sulphate Potassium Chloride 30 Mesh (VEGAN)",
          },
          subtitle: { en: "98% Glucosamine" },
        },
        {
          _id: "65269b5b35aaab2d5cfe58a9",
          title: { en: "L(+)- Choline Bitartrate coated" },
          subtitle: { en: "39.9% Choline, 0.8% Silicon Dioxide" },
        },
        {
          _id: "652e41f0e0dbe5950a075554",
          title: { en: "Lipase" },
          subtitle: { en: "100,000U/g Powder Aspergillus niger" },
        },
        {
          _id: "652e44ace0dbe5950a07556c",
          title: { en: "Lipase" },
          subtitle: { en: "100,000U/g Powder Rhizopus sp." },
        },
        {
          _id: "652e4517e0dbe5950a075583",
          title: { en: "Protease" },
          subtitle: { en: "100,000SAPU/g Powder" },
        },
        {
          _id: "652e4793e0dbe5950a07559a",
          title: { en: "Lactase (Beta-galactosidase)" },
          subtitle: { en: "100,000 ALU/g Powder. Aspergillus oryzae" },
        },
        {
          _id: "652e48fde0dbe5950a0755b1",
          title: { en: "Alpha-galactosidase" },
          subtitle: { en: "30,000 GalU/g" },
        },
        {
          _id: "653a2fa9e534825c2aaf2784",
          title: { en: "L-Citrulline DL-Malate 2:1 Powder" },
          subtitle: { en: "65% L-Citrulline, 30% DL-Malic acid; 2:1" },
        },
        {
          _id: "653a442da51ccf515c782aca",
          title: { en: "Coenzym Q10 Powder" },
          subtitle: { en: "98% Ubiquinone" },
        },
        {
          _id: "653a466a2d4c99b4b50d1e29",
          title: { en: "Echinacea Extract" },
          subtitle: { en: "4% Polyphenole; 5:1; Echinacea Purpure; Aerial part" },
        },
        {
          _id: "653f7c10c161e13d85817da0",
          title: { en: "Cinnamon Extract" },
          subtitle: { en: "5:1; Cinnamomum cassia Presl.; Bark" },
        },
        {
          _id: "653f7e32c161e13d85817ddb",
          title: { en: "Ginger extract" },
          subtitle: { en: "20% Gingerols; Zingiber officinale; Stem (Rhizome)" },
        },
        {
          _id: "65439c363fc76974152103cb",
          title: { en: "Microcrystalline Cellulose (MCC) Powder" },
          subtitle: { en: "MCC 101 " },
        },
        {
          _id: "65439c4f3fc76974152103f6",
          title: { en: "Microcrystalline Cellulose (MCC) Powder" },
          subtitle: { en: "MCC 102" },
        },
        {
          _id: "6543b622f790756cfa7e6bb1",
          title: { en: "Cinnamon Extract" },
          subtitle: { en: "5:1; Cinnamomum verum; Bark" },
        },
        {
          _id: "654a4b654302ba8cfbdb818d",
          title: { en: "Magnesium Taurate Powder" },
          subtitle: { en: "8% Magnesium" },
        },
        {
          _id: "65524e2643ec3df400476fed",
          title: { en: "Stevia Extract (60% Rebaudioside A)" },
          subtitle: { en: "60% Rebaudioside A; Stevia rebaudiana Bertoni; Leaf" },
        },
        {
          _id: "6555e5432ea389c778216607",
          title: { en: "Beetroot Extract" },
          subtitle: { en: "5:1; Beta vulgaris L.; Root" },
        },
        {
          _id: "655e6e5feec5eadc43239b81",
          title: { en: "L-Cysteine HCL Monohydrate" },
          subtitle: { en: "" },
        },
        {
          _id: "6564917ed569a6a75500e55c",
          title: { en: "Passionflower Extract" },
          subtitle: { en: "2% Total flavones(UV)" },
        },
        {
          _id: "658d908919c1dbbe1d41cbfa",
          title: { en: "Phosphatidylserine (soybean)" },
          subtitle: { en: "" },
        },
        {
          _id: "65952a115134a32e3f266ddb",
          title: { en: "Conventional Hemp Protein Powder" },
          subtitle: { en: "70% Protein; Total THC <3 ppm.; Seed" },
        },
        {
          _id: "65968aa44d335318c1f4cd2e",
          title: { en: "Acerola Extract - added" },
          subtitle: { en: "25% Vitamin C; Malpighia glabra L.; Fruit" },
        },
        {
          _id: "65968add4d335318c1f4cd55",
          title: { en: "Camu Camu Powder" },
          subtitle: { en: "25% Vitamin C; Myrciaria dubia; Fruit" },
        },
        {
          _id: "6598065df67b0d3af2eb3783",
          title: { en: "Rice protein" },
          subtitle: { en: "80% Protein; Oryza Sativa (subsp. japonica); Seed" },
        },
        {
          _id: "6598084b64d4831d0f7bcb92",
          title: { en: "Magnesium Carbonate Granular (DC Grade)" },
          subtitle: { en: "40% Magnesium oxide" },
        },
        {
          _id: "659809d54d162d70abb11238",
          title: { en: "Curry leaf extract" },
          subtitle: { en: "3% Ferrous; 10:1; Murraya koenigii L; Leaf" },
        },
        {
          _id: "659e7957a42b2b1d6d739793",
          title: { en: "Vitamin K2 (MK-7)" },
          subtitle: { en: "1% Medium chain triglycerides (in MCT Oil)" },
        },
        {
          _id: "659e7dad2f172e8949290f25",
          title: { en: "Saw Palmetto Extract" },
          subtitle: { en: "85% Fatty acids; Serenoa Repens; Fruit" },
        },
        {
          _id: "659e7e82880006494f782df4",
          title: { en: "Dandelion Extract" },
          subtitle: { en: "5% Flavonoids; Taraxacum officinale; Herb" },
        },
        {
          _id: "659fd6a276db88cc62565e16",
          title: { en: "Biological Calcium Carbonate" },
          subtitle: { en: "98% Calcium carbonate; source: Oyster shell" },
        },
        {
          _id: "65a558ded6c3012466cbca35",
          title: { en: "Rice flakes pure (Gluten free)" },
          subtitle: { en: "Seed" },
        },
        {
          _id: "65a560793d5881a441567460",
          title: { en: "Methyl Sulfonyl Methane (MSM)" },
          subtitle: { en: "60-80 mesh, 0.5% Silicon Dioxide" },
        },
        {
          _id: "65a6b26a5f6b01592b0cfad4",
          title: { en: "Premix Day  (49EAA)" },
          subtitle: { en: "" },
        },
        {
          _id: "65a6b61f5f6b01592b0cfaec",
          title: { en: " 47EAA" },
          subtitle: { en: "Premix (Night)" },
        },
        {
          _id: "65a6c7fa0e711d042cc9725f",
          title: { en: "Olive leaf Extract" },
          subtitle: { en: "20% Oleuropein; Olea europaea; Leaf" },
        },
        {
          _id: "65aa2d8f189b0a87a85479c4",
          title: { en: "CLEARPEA™" },
          subtitle: {
            en: "Pea Protein Peptides 85% Protein, 80% Peptides; Pisum sativum Linn; Seed",
          },
        },
        {
          _id: "65b373ab8da2a834ced88233",
          title: { en: "Bromelain 1,800 GDU/g Powder" },
          subtitle: { en: "Ananas Comosus" },
        },
        {
          _id: "65b784ca9d4658bd3ede5c1c",
          title: { en: "Tri-Calcium citrate" },
          subtitle: { en: "20% Calcium" },
        },
        {
          _id: "65bbe61c41948295013dee5a",
          title: { en: "D-Mannose" },
          subtitle: { en: "" },
        },
        {
          _id: "65c348d71d349c355758955f",
          title: { en: "Green Tea Extract" },
          subtitle: { en: "5% Caffeine; Camellia sinensis O. Ktze.; Leaf" },
        },
        {
          _id: "65c397451d349c3557589584",
          title: { en: "Marigold Extract" },
          subtitle: {
            en: "20% Lutein, 10% Zeaxanthin; Tagetes Erecta L.; Flower",
          },
        },
        {
          _id: "65c3aca93016a19eee8f793b",
          title: { en: "Green Tea Extract" },
          subtitle: {
            en: "50% Polyphenoles, 15% EGCG, 1% Caffeine; Camellia Sinensis O.Ktze.; Leaf",
          },
        },
        {
          _id: "65c3af9119345a213d00bebb",
          title: { en: "RAWD3™ in MCT Oil from coconut (vegan)" },
          subtitle: { en: "Vitamin D3 1,000,000 IU/g" },
        },
        {
          _id: "65c9f02b6ae6489e7b0b8083",
          title: { en: "Griffonia Extract" },
          subtitle: { en: "20% 5-HTP; Griffonia simplicifolia; Seed" },
        },
        {
          _id: "65c9f5f4582d17ed4e2df711",
          title: { en: "Green Tea Extract" },
          subtitle: {
            en: "50% Polyphenoles, 15% EGCG, 12% Caffeine; Camellia Sinensis O.Ktze.; Leaf",
          },
        },
        {
          _id: "65cb244cb5dd0ad4a4eaa7bc",
          title: { en: "Organic KSM-66 Ashwagandha Root Extract" },
          subtitle: { en: "Withania somnifera; Root" },
        },
        {
          _id: "65cf48172bdf438602a19227",
          title: { en: "Bitter Orange Extract" },
          subtitle: { en: "4:1; Citrus Aurantium; Fruit" },
        },
        {
          _id: "65cf666d9b7b8a5b8e33f468",
          title: { en: "Nettle powder" },
          subtitle: { en: "Urtica dioica L.; Leaf" },
        },
        {
          _id: "65d330ef4b648884f445e97b",
          title: { en: "Copper gluconate" },
          subtitle: { en: "13% Copper" },
        },
        {
          _id: "65d361dc36d6cf6b6bf57e6a",
          title: { en: "Kelp Extract" },
          subtitle: { en: "0.1% Iodine; Laminaria japonica A resch; Whole Herb" },
        },
        {
          _id: "65d3633636d6cf6b6bf57e8c",
          title: { en: "Sophora Japonica Extract" },
          subtitle: { en: "95% Rutin; Sophora Japonica L.; Buds (Flower)" },
        },
        {
          _id: "65d364ae36d6cf6b6bf57ec6",
          title: { en: "Millet seed extract" },
          subtitle: { en: "3:1; Panicum miliaceum; Seed" },
        },
        {
          _id: "65d3693a803606a5c15248b6",
          title: { en: "Ginkgo extract" },
          subtitle: { en: "10:1; Ginkgo Biloba L.; Leaf" },
        },
        {
          _id: "65d36a47803606a5c15248d2",
          title: { en: "Muira Puama extract" },
          subtitle: { en: "4:1; Ptychopetalum olacoides Benth.; Bark" },
        },
        {
          _id: "65d5fad56e0f7d669c23f2ac",
          title: { en: "Inulin" },
          subtitle: { en: "100% Inulin; Chicory; Root" },
        },
        {
          _id: "65d6085731f3c218397f66e2",
          title: { en: "Rice flour (Gluten free)" },
          subtitle: { en: "100% Rice flour; Seed" },
        },
        {
          _id: "65d62aee4bee35bbffc2d07f",
          title: { en: "Whole grain Oat flour" },
          subtitle: { en: "100% Oat flour; Seed" },
        },
        {
          _id: "65d7435fb625118e7a1d1db5",
          title: { en: "Para-Aminobenzoic Acid (PABA)" },
          subtitle: { en: "" },
        },
        {
          _id: "65d75018b16ce1dbcfd4741f",
          title: { en: "Theacrine" },
          subtitle: { en: "60% Theacrine; less bitter; Camellia Kucha; Leaf" },
        },
        {
          _id: "65d75368b16ce1dbcfd47460",
          title: { en: "Theacrine" },
          subtitle: { en: "60% Theacrine; Camellia Kucha; Leaf" },
        },
        {
          _id: "65d75881b16ce1dbcfd47484",
          title: { en: "MCT Oil (coconut based)" },
          subtitle: { en: "60% Caprylic acid (in fat), 40% Capric acid (in fat)" },
        },
        {
          _id: "65d75fa120344666b25afb14",
          title: { en: "Grapefruit extract" },
          subtitle: { en: "45% Naringin; Citrus paradisi Macf.; Fruit" },
        },
        {
          _id: "65d7663ec8753a34e0f01e19",
          title: { en: "Golden millet extract" },
          subtitle: { en: "3:1; Setaria italica (L.); Fruit" },
        },
        {
          _id: "65d767b4c8753a34e0f01e39",
          title: { en: "Acerola Extract - added" },
          subtitle: { en: "25% Vitamin C; Cerasus Valgaris Mill; Berry" },
        },
        {
          _id: "65d76895c8753a34e0f01e65",
          title: { en: "Kelp Extract" },
          subtitle: { en: "4:1; Laminaria japonica Aresch; Leaf" },
        },
        {
          _id: "65d76944c8753a34e0f01e87",
          title: { en: "Grapefruit seed extract" },
          subtitle: { en: "45% Bioflavonoids; Citrus paradisi Macf.; Seed" },
        },
        {
          _id: "65d87bd881653a9463f52bb2",
          title: { en: "Green Tea Extract" },
          subtitle: {
            en: "95% Polyphenoles, 45% EGCG, 3% Caffeine; Camellia Sinensis (L.) o. Ktze.; Leaf",
          },
        },
        {
          _id: "65d87d0e81653a9463f52bd2",
          title: { en: "Zinc Gluconate Powder" },
          subtitle: { en: "12% Zinc" },
        },
        {
          _id: "65d87f9781653a9463f52bf1",
          title: { en: "Manganese Gluconate Powder" },
          subtitle: { en: "11.3% Manganese" },
        },
        {
          _id: "65dca69f0141209449d73c3c",
          title: { en: "Boric acid" },
          subtitle: { en: "" },
        },
        {
          _id: "65dddbed5d71d1b8c7b83b7a",
          title: { en: "Red Yeast Rice Extract" },
          subtitle: { en: "1.6% Monacolin K; Monascus Purpureus; Monascussp" },
        },
        {
          _id: "65ddde2430e4913157c54897",
          title: { en: "Sage Extract" },
          subtitle: { en: "4:1; Salvia Officinalis; Leaf" },
        },
        {
          _id: "65dde0eb30e4913157c548b9",
          title: { en: "Ox bile Extract" },
          subtitle: { en: "45% Cholic acid; 4:1" },
        },
        {
          _id: "65ddeb499ae7e4ea20c2acf0",
          title: { en: "Organic Chaga Extract" },
          subtitle: { en: "30% Beta Glucan; Inonotus Obliquus; Fruit Body" },
        },
        {
          _id: "65deeb921f3801c586a66b8f",
          title: { en: "AstraGin" },
          subtitle: {
            en: "1.5% Total saponin; Panax notoginseng extract (50:1). Astragalus membranaceus extract (10:1); Root",
          },
        },
        {
          _id: "65e07da123eca6e4fa1728bd",
          title: { en: "Parsley Extract" },
          subtitle: { en: "" },
        },
        {
          _id: "65e08e3817f7b985ba6c61a2",
          title: { en: "Parsley Extract" },
          subtitle: { en: "10% Apigenin; Petroselinum crispum; Whole herb" },
        },
        {
          _id: "65e091f617f7b985ba6c61d1",
          title: { en: "Calcium Citrate Tetrahydrate" },
          subtitle: { en: "20% Calcium" },
        },
        {
          _id: "65e18e468babe0c717a20c51",
          title: { en: "Sophora Japonica Extract (Quercetin dihydrate powder)" },
          subtitle: { en: "95% Quercetin; Sophora Japonica L.; Flowder" },
        },
        {
          _id: "65e1b8578babe0c717a20cae",
          title: { en: "Potato starch" },
          subtitle: { en: "" },
        },
        {
          _id: "65e1ba4a4af8de82631e57e5",
          title: { en: "Silicon Dioxide" },
          subtitle: { en: "100% Silicon Dioxide" },
        },
        {
          _id: "65e1c1082cc9bbe2952b3050",
          title: { en: "Dextrin" },
          subtitle: { en: "" },
        },
        {
          _id: "65e1c3352cc9bbe2952b307b",
          title: { en: "Citicoline (CDP Choline)" },
          subtitle: { en: "" },
        },
        {
          _id: "65e72a6dc17f7acf98ee41f1",
          title: { en: "Deer Root Extract" },
          subtitle: { en: "90% Ecdysone; Rhaponticum carthamoides; Root" },
        },
        {
          _id: "65e9b4238c055573f19c1af7",
          title: { en: "St.John's Wort Extract" },
          subtitle: {
            en: "0.3% Hypericin; 10:1; Hypericum perforatum L.; Herb with flowers",
          },
        },
        {
          _id: "65eae99b461c9b4ae23ce8d8",
          title: { en: "Crystalline Fructose" },
          subtitle: { en: "" },
        },
        {
          _id: "65ec412132df785154c3da4c",
          title: { en: "Rosehip Extract" },
          subtitle: { en: "45% Vitamin C; Rosa canina L.; Fruit" },
        },
        {
          _id: "65f2c39804b05402cde14b37",
          title: { en: "Sea Buckthorn Extract" },
          subtitle: { en: "25% Vitamin C; Hippophae rhamnoides L.; Fruit" },
        },
        {
          _id: "65f858af9254f0d46e14e77a",
          title: { en: "Green Tea Extract" },
          subtitle: { en: "70% L-Theanine; Camellia Sinensis; Leaf" },
        },
        {
          _id: "65f85a469254f0d46e14e7cc",
          title: { en: "Green Tea Extract" },
          subtitle: { en: "30% L-Theanine; Camellia Sinensis; Leaf" },
        },
        {
          _id: "65fc04117c8d0e97e1342b29",
          title: { en: "Schisandra Extract (HPLC)" },
          subtitle: { en: "10% Schisandrin; Schisandra Chinensis; Fruit" },
        },
        {
          _id: "66014bac8bd8047e5d94e36d",
          title: { en: "GlycOmega™" },
          subtitle: { en: "Greenshell Mussel Powder" },
        },
        {
          _id: "660fc92ac9d434f3d1a83c55",
          title: {
            en: " HMB Calcium (Calcium Beta-Hydroxy-Beta-Methylbutyrate)",
          },
          subtitle: { en: "" },
        },
        {
          _id: "6617fbabbfbea953ed76bc49",
          title: { en: "Siberian Ginseng" },
          subtitle: { en: "10:1; Eleutherococus senticosus; Root" },
        },
        {
          _id: "6618008cd13d5984907e1506",
          title: { en: "Fennel Seed Extract" },
          subtitle: { en: "10:1; Foeniculum vulgare Mill; Seed" },
        },
        {
          _id: "661d3f0a8016c479c1d39480",
          title: { en: "Fennel seed powder" },
          subtitle: { en: "Foeniculum Vulgare Mill; Seed" },
        },
        {
          _id: "661e1bccb8fe066a853d8ba5",
          title: { en: "PureHMB" },
          subtitle: { en: "" },
        },
        {
          _id: "661e8f9f4d9b47af9a506839",
          title: { en: "Organic Curcuma (Turmeric) Powder" },
          subtitle: { en: "2.5% Curcumin; Curcuma longa; Rhizome" },
        },
        {
          _id: "661fc5055fa7bf177b6aec8a",
          title: { en: "Organic Curcuma (Turmeric) Extract" },
          subtitle: { en: "5% Curcuminoids; Curcuma longa; Rhizomes" },
        },
        {
          _id: "66210c2c7d54b0293ad5f954",
          title: { en: "Guarana Extract" },
          subtitle: { en: "22% Caffeine; Paullinia cupana Kunth; Fruit" },
        },
        {
          _id: "66222d5f7de0eba41bd90377",
          title: { en: "Pea Protein Peptides" },
          subtitle: { en: "85% Protein, 85% Peptides; Pisum sativum Linn; Seed" },
        },
        {
          _id: "662287d28a17ed722887edf8",
          title: { en: "Ashwagandha Extract" },
          subtitle: { en: "10:1; Withania Somnifera; Whole plant" },
        },
        {
          _id: "662640ebb7663f5696224fc5",
          title: { en: "Huperzine A" },
          subtitle: { en: "1%" },
        },
        {
          _id: "6627a7246062d919770a018e",
          title: { en: "Calcium Lactate Pentahydrate Granular" },
          subtitle: { en: "" },
        },
        {
          _id: "6627ad3e6062d919770a01c1",
          title: { en: "Calcium Lactate Pentahydrate Powder" },
          subtitle: { en: "" },
        },
        {
          _id: "6628d9f2aaa01797ce6e7f74",
          title: { en: "S-Acetyl-L-Glutathione" },
          subtitle: { en: "" },
        },
        {
          _id: "662a26dfd92c5a3402e57199",
          title: { en: "Apigenin" },
          subtitle: { en: "" },
        },
        {
          _id: "662ba78797abc3ac823797c3",
          title: { en: "Alpha Lipoic Acid granular" },
          subtitle: { en: "" },
        },
        {
          _id: "662baaf35b9f8793d3303d59",
          title: { en: "Cluster Dextrin ™" },
          subtitle: { en: "" },
        },
        {
          _id: "662f779c3c50b2b6e7c7962d",
          title: { en: "White Kidney Bean Extract" },
          subtitle: { en: "4:1; Phaseolus vulgaris L.; Seeds" },
        },
        {
          _id: "662f79f6a96760964bbf1e04",
          title: { en: "White Mulberry Extract" },
          subtitle: { en: "" },
        },
        {
          _id: "662f7abd42784a5a9b868333",
          title: { en: "White Tea Extract" },
          subtitle: { en: "" },
        },
        {
          _id: "662f7c5242784a5a9b868359",
          title: { en: "White Willow Bark Extract" },
          subtitle: { en: "10% Chlorophyllin; Medicago Sativa; Herb" },
        },
        {
          _id: "662fe147be1f0db169a07768",
          title: { en: "Psyllium Husk (95%) Powder" },
          subtitle: { en: "Plantago Ovata L.; Husk" },
        },
        {
          _id: "662fe3bfbc2b8aec8d5ffdd3",
          title: { en: "White Tea Powder Extract" },
          subtitle: { en: "Camellia sinensis O. Ktze.; Leaf" },
        },
        {
          _id: "662fe9ac5aa176c3056e6570",
          title: { en: "Organic Mushroom Extract" },
          subtitle: { en: "" },
        },
        {
          _id: "662fea925aa176c3056e658e",
          title: { en: "Organic Mushroom Powder" },
          subtitle: { en: "" },
        },
        {
          _id: "662feafc5aa176c3056e65ac",
          title: { en: "Organic Shiitake Powder" },
          subtitle: { en: "" },
        },
        {
          _id: "662feb945aa176c3056e65ca",
          title: { en: "Organic Shiitake Extract 4:1" },
          subtitle: { en: "" },
        },
        {
          _id: "662febe65aa176c3056e65e6",
          title: { en: "Organic Shiitake Extract 8:1" },
          subtitle: { en: "" },
        },
        {
          _id: "662fec2c5aa176c3056e6602",
          title: { en: "Shiitake Extract 30% Polysaccharides" },
          subtitle: { en: "" },
        },
        {
          _id: "663097a7241baba88f513f8a",
          title: { en: "Pea Protein Isolate 85%" },
          subtitle: { en: "85% Protein; Pisum sativum Linn; Seed" },
        },
        {
          _id: "6630b06c64922d399589259f",
          title: { en: "Guarana Seed Extract" },
          subtitle: { en: "" },
        },
        {
          _id: "6630b15b64922d39958925ed",
          title: { en: "Angelica Root Extract" },
          subtitle: { en: "" },
        },
        {
          _id: "6630b23b64922d399589260b",
          title: { en: "White Willow Bark Extract" },
          subtitle: { en: "" },
        },
        {
          _id: "6630b30664922d3995892627",
          title: { en: "Mulberry Leaf Extract" },
          subtitle: { en: "" },
        },
        {
          _id: "6630b3c164922d3995892645",
          title: { en: "White Kidney Bean Extract" },
          subtitle: { en: "10:1; Phaseolus vulgaris L.; Seeds" },
        },
        {
          _id: "6630b4c664922d3995892661",
          title: { en: "White Tea Extract" },
          subtitle: { en: "" },
        },
        {
          _id: "6630d84dedaf7a4d08ba3106",
          title: { en: "Zinc gluconate" },
          subtitle: { en: "" },
        },
        {
          _id: "6630d92b5b038b64e7fdc3ea",
          title: { en: "Chinese Angelica Extract" },
          subtitle: { en: "" },
        },
        {
          _id: "6630f169790467105d9cb114",
          title: { en: "Dong Guai P.E." },
          subtitle: { en: "" },
        },
        {
          _id: "6630f951790467105d9cb158",
          title: { en: "White Kidney Bean P.E." },
          subtitle: { en: "" },
        },
        {
          _id: "6633748573baba72e4bcc424",
          title: { en: "Mecobalamin Food Additive" },
          subtitle: { en: "" },
        },
        {
          _id: "6633777d8c5ad688931deb34",
          title: { en: "Mecobalamin Food Addative" },
          subtitle: { en: "" },
        },
        {
          _id: "6633984d988eac72b51e3807",
          title: { en: "White mulberry leaf extract" },
          subtitle: { en: "" },
        },
        {
          _id: "663399145031823020978264",
          title: { en: "White tea extract" },
          subtitle: { en: "" },
        },
        {
          _id: "66339aa85031823020978280",
          title: { en: "White Willow Bark P.E." },
          subtitle: { en: "" },
        },
        {
          _id: "6634ccd5acaddb2056553f6b",
          title: { en: "FOODSOLUTE® GERMSOL GOLD GRAINS SP" },
          subtitle: {
            en: "Wheat Germ Concentrate with 500 mg Spermidine; Triticum aestivum",
          },
        },
        {
          _id: "6634e53834a2d617a83b4f62",
          title: { en: "Zinc gluconate" },
          subtitle: { en: "" },
        },
        {
          _id: "6634e61434a2d617a83b4f83",
          title: { en: "Zinc Picolinate 20%" },
          subtitle: { en: "" },
        },
        {
          _id: "6634ea13a2be49725090c8d9",
          title: { en: "Magnesium Malate Anhydrous Powder" },
          subtitle: { en: "" },
        },
        {
          _id: "6634eb65a0efc93f0cbb87dc",
          title: { en: "Magnesium Citrate Anhydrous" },
          subtitle: { en: "" },
        },
        {
          _id: "6638ccc97be296c340bc904c",
          title: { en: "L-α-Glycerophosphorylchline(GPC)" },
          subtitle: { en: "" },
        },
        {
          _id: "6638e9afdd63aa14c9a9e239",
          title: { en: "Magnesium Oxide Granular" },
          subtitle: { en: "" },
        },
        {
          _id: "6639ffbdec95f672f1805683",
          title: { en: "Kudzu Extract" },
          subtitle: { en: "" },
        },
        {
          _id: "663a2b5c7a252d7dc2e6f51e",
          title: { en: "Kudzu root extract" },
          subtitle: { en: "10:1; Pueraria Lobata Radix; Root" },
        },
        {
          _id: "663b427d5755ea11991ee3e3",
          title: { en: "Ginkgo Extract" },
          subtitle: {
            en: "22% Total Flavone Glycosides, 5% Total Terpene Lactones, 0.05% Total Ginkgo Acid; 50:1; Ginkgo Biloba L.; Leaf",
          },
        },
        {
          _id: "664230ce78ff923741f16a12",
          title: { en: "CLEARPEA™ Green Apple Flavour" },
          subtitle: {
            en: "Pea Protein Peptides 85% Protein, 80% Peptides; Pisum sativum Linn; Seed",
          },
        },
        {
          _id: "6642378978ff923741f16a30",
          title: { en: "CLEARPEA™ Cherry Flavour" },
          subtitle: {
            en: "Pea Protein Peptides 85% Protein, 80% Peptides; Pisum sativum Linn; Seed",
          },
        },
        {
          _id: "664238be78ff923741f16a66",
          title: { en: "CLEARPEA™ Orange Flavour" },
          subtitle: {
            en: "Pea Protein Peptides 85% Protein, 80% Peptides; Pisum sativum Linn; Seed",
          },
        },
        {
          _id: "6642392f78ff923741f16a7d",
          title: { en: "CLEARPEA™ Peach IceTea Flavour" },
          subtitle: {
            en: "Pea Protein Peptides 85% Protein, 80% Peptides; Pisum sativum Linn; Seed",
          },
        },
        {
          _id: "6642395878ff923741f16a94",
          title: { en: "CLEARPEA™ Tropical Flavour" },
          subtitle: {
            en: "Pea Protein Peptides 85% Protein, 80% Peptides; Pisum sativum Linn; Seed",
          },
        },
        {
          _id: "664742cf410ac73c35cc2199",
          title: { en: "Green Tea Extract" },
          subtitle: { en: "40% L-Theanine; Camellia Sinensis; Leaf" },
        },
        {
          _id: "66474a31410ac73c35cc21bd",
          title: { en: "Magnesium Ascorbate" },
          subtitle: { en: "6.5% Magnesium" },
        },
        {
          _id: "66474f13410ac73c35cc2211",
          title: { en: "Magnesium Malate Powder" },
          subtitle: { en: "23% Magnesium, 60% Malates" },
        },
        {
          _id: "664f4cd480747d55e1ec36af",
          title: { en: "Astragalus powder" },
          subtitle: { en: "Astragalus membranaceus; Root" },
        },
        {
          _id: "6650877453c3f1e93033cb44",
          title: { en: "Dextrose Monohydrate Powder" },
          subtitle: { en: "" },
        },
        {
          _id: "66508f8f53c3f1e93033cb5e",
          title: { en: "Dextrose Anhydrous Powder" },
          subtitle: { en: "" },
        },
        {
          _id: "665091290e425fae80bdc7eb",
          title: { en: "Guar gum powder" },
          subtitle: { en: "3500 cps" },
        },
        {
          _id: "665093cb0e425fae80bdc808",
          title: { en: "Guar gum powder" },
          subtitle: { en: "5000 cps" },
        },
        {
          _id: "665094740e425fae80bdc82c",
          title: { en: "Horse Chestnut Extract" },
          subtitle: { en: "4:1; Aesculus hippocastanum; Seed" },
        },
        {
          _id: "665097630e425fae80bdc858",
          title: { en: "L-Norvaline" },
          subtitle: { en: "" },
        },
        {
          _id: "6650a0ac0e425fae80bdc8d3",
          title: { en: "Grape Seed Extract" },
          subtitle: { en: "70% OPC; Vitis vinifera L.; Seed" },
        },
        {
          _id: "66559a0490c6ed38708f24df",
          title: { en: "Broccoli extract" },
          subtitle: {
            en: "13% Glucoraphanin; Brassica oleracea L. var. botrytis L.; Seed",
          },
        },
        {
          _id: "66559ac390c6ed38708f2506",
          title: { en: "Broccoli extract" },
          subtitle: { en: "5% Glucoraphanin; Brassica oleracea italica; Seed" },
        },
        {
          _id: "66559c4390c6ed38708f254b",
          title: { en: "Broccoli extract" },
          subtitle: {
            en: "Microencapsulated 1% Sulforaphane; Brassica oleracea italica; Seed",
          },
        },
        {
          _id: "66559cbf90c6ed38708f2567",
          title: { en: "Broccoli extract" },
          subtitle: { en: "0.4% Sulforaphane; Brassica oleracea italica; Seed" },
        },
        {
          _id: "66559ce590c6ed38708f2583",
          title: { en: "Broccoli extract" },
          subtitle: { en: "0.1% Sulforaphane; Brassica oleracea italica; Seed" },
        },
        {
          _id: "6655c3e1d052e62968ffde72",
          title: { en: "Panax Ginseng Extract" },
          subtitle: { en: "5% Ginsenosides; Panax quinquefolius; Root" },
        },
        {
          _id: "6655c848d4ca450cfa13e8db",
          title: { en: "Mulberry Leaf Extract" },
          subtitle: { en: "1% 1-Deoxynojirimycin; Malpighia glabra L.; Leaf" },
        },
        {
          _id: "6655c98a012c6b4e715f6f20",
          title: { en: "Instant Black Tea Powder" },
          subtitle: {
            en: "5% Caffeine, 15% Polyphenols; Camellia Sinensis; Leaf",
          },
        },
        {
          _id: "6655cbc2012c6b4e715f6f56",
          title: { en: "Beta Carotene Powder (not natural)" },
          subtitle: { en: "1% Beta-Carotene" },
        },
        {
          _id: "6655d84e64c96ae2c61fad38",
          title: { en: "Grape Seed Extract" },
          subtitle: { en: "95% OPC; Vitis vinifera L.; Seed" },
        },
        {
          _id: "6655e3de64c96ae2c61fad5c",
          title: { en: "L-Citrulline Powder" },
          subtitle: { en: "99% L-Citrulline" },
        },
        {
          _id: "6656f013a79e4eedeaf6590e",
          title: { en: "Magnesium Citrate Nonahydrate Granular (DC grade)" },
          subtitle: { en: "15% Magnesium" },
        },
        {
          _id: "6656f1eda79e4eedeaf6594a",
          title: { en: "Tri-Magnesium Dicitrate Anhydrous Granular (DC grade)" },
          subtitle: { en: "15% - 16,5% Magnesium" },
        },
        {
          _id: "6657124362d4b6a04c383c6e",
          title: { en: "Chitosan (allergen: shellfish/crustaceans)" },
          subtitle: { en: "" },
        },
        {
          _id: "665714e762d4b6a04c383c9d",
          title: {
            en: "Chitosan High-Density (allergen: shellfish/crustaceans)",
          },
          subtitle: { en: "" },
        },
        {
          _id: "66571ed762d4b6a04c383ccc",
          title: { en: "Papain 100.000 USP-U/mg Powder" },
          subtitle: { en: "Fruit" },
        },
        {
          _id: "66574192205a3f974e304e63",
          title: { en: "Xylitol" },
          subtitle: { en: "" },
        },
        {
          _id: "66574b838942d295e28d55fd",
          title: { en: "Ashwagandha Extract" },
          subtitle: { en: "5% Withanolide; 25:1; Withania Somnifera; Root" },
        },
        {
          _id: "665d868145d5606e2bd9ff02",
          title: { en: "BCAA INSTANT Granular" },
          subtitle: { en: "" },
        },
        {
          _id: "665db45ca0b47229300162a0",
          title: { en: "L- Citrulline DL - Malate 2:1" },
          subtitle: {
            en: "62.5% ~ 74.2%% L-Citrulline 26.4% ~ 36.4% DL - Malic acid",
          },
        },
        {
          _id: "665ec7458349d1153c1f5429",
          title: { en: "L-Citrulline DL-Malate 2:1 Powder " },
          subtitle: { en: "65% L-Citrulline, 30% DL-Malic acid; 2:1" },
        },
        {
          _id: "665ecb50290687fbd3a3d51d",
          title: { en: "HMB Calcium Granular" },
          subtitle: { en: "Calcium ≤14%" },
        },
        {
          _id: "665eebee1ff29ae4aecb6f62",
          title: { en: "Shilajit Extract" },
          subtitle: {
            en: "50% Fulvic Acid, 12% Humic acid; 30:1; Asphaltum punjabianum",
          },
        },
        {
          _id: "666010860a8a653929f8c468",
          title: { en: "Magnesium Bisglycinate Anhydrous " },
          subtitle: { en: "12-14% Magnesium" },
        },
        {
          _id: "66602f7b7b66161ef61c1572",
          title: { en: "L-Methionine" },
          subtitle: { en: "" },
        },
        {
          _id: "666032e565e357e2e435f9f9",
          title: { en: "Apple cider vinegar Powder" },
          subtitle: { en: "6% Acetic Acid; Malus pumila Mill; Fruit" },
        },
        {
          _id: "66605377424a9a929e4e386e",
          title: { en: "Shilajit Extract" },
          subtitle: { en: "50% Fulvic Acid; Asphaltum punjabianum" },
        },
        {
          _id: "6662e357efb1b650fc87ec9d",
          title: { en: "Broccoli Powder" },
          subtitle: { en: "" },
        },
        {
          _id: "6662ebf4bc5fd9ff7a8277be",
          title: { en: "Broccoli Powder" },
          subtitle: { en: "" },
        },
        {
          _id: "6662ede1bc5fd9ff7a8277e7",
          title: { en: "Parsley root powder" },
          subtitle: { en: "" },
        },
        {
          _id: "6662ef0fbc5fd9ff7a827818",
          title: { en: "Spirulina algae Powder" },
          subtitle: { en: "" },
        },
        {
          _id: "66680fb3db1dbff9c9a8221c",
          title: { en: "Berberis Aristata Extract" },
          subtitle: { en: "" },
        },
        {
          _id: "666839fc892ba1ab28c8abeb",
          title: { en: "Berberine HCL" },
          subtitle: { en: "" },
        },
        {
          _id: "66683d88d1f3ed7d9fbef0ad",
          title: { en: "Dandelion Root Extract" },
          subtitle: { en: "5% Total flavones(UV)" },
        },
        {
          _id: "66684027d1f3ed7d9fbef0e8",
          title: { en: "Konjac Extract" },
          subtitle: { en: "95% Glucomannan(UV)" },
        },
        {
          _id: "6668413ed1f3ed7d9fbef111",
          title: { en: "Chaste Tree Extract" },
          subtitle: { en: "5:1; Vitex agnus-castus Linn.; Seed" },
        },
        {
          _id: "66684addd1f3ed7d9fbef13b",
          title: { en: "Algae ARA Powder" },
          subtitle: { en: "50% Fucoxanthin; Laminaria japonica; Seaweed" },
        },
        {
          _id: "66685c263fb38f6d4e98007a",
          title: { en: "L-Histidine HCL Monohydrate Powder" },
          subtitle: { en: "98.5% L-Histidine" },
        },
        {
          _id: "666c2f51fc5d29f34e523445",
          title: { en: "Dandelion Extract" },
          subtitle: { en: "5% Flavones; 20:1; Taraxacum officinale; Herb" },
        },
        {
          _id: "666c4017042d0eeaaf5ac66e",
          title: { en: "Artichoke Extract" },
          subtitle: { en: "2.5% Cynarin; 10-20:1; Cynara scolymus L.; Leaf" },
        },
        {
          _id: "666c44ea0fd17e508eafe897",
          title: { en: "Milk Thistle Extract" },
          subtitle: {
            en: "80% Silymarin; 20-25:1; Silybum marianum L. Gaertn; Seed",
          },
        },
        {
          _id: "666c46320fd17e508eafe8c3",
          title: { en: "Horseradish root Extract" },
          subtitle: { en: "5% Flavones; Raphanus sativus var. Sativus; Root" },
        },
        {
          _id: "666c493c0fd17e508eafe8f1",
          title: { en: "Sweet Tea Leaf Extract" },
          subtitle: { en: "70% Rubusoside; Rubus Suavissimus S. Lee; Leaf" },
        },
        {
          _id: "666c52f10fd17e508eafe92a",
          title: { en: "Garcinia Cambogia Extract" },
          subtitle: { en: "60% HCA; Garcinia cambogia; Fruit and rind" },
        },
        {
          _id: "666c53f30fd17e508eafe94f",
          title: { en: "Gymnema Extract" },
          subtitle: { en: "25% Gymnemic acid; Gymnema sylvestre; Leaf" },
        },
        {
          _id: "666c54f80fd17e508eafe975",
          title: { en: "Lemon Peel Extract" },
          subtitle: { en: "Citrus limon; Fruit peel" },
        },
        {
          _id: "666c568e0fd17e508eafe99a",
          title: { en: "Amla Extract" },
          subtitle: { en: "30% Polyphenols; Emblica officinalis; Fruit" },
        },
        {
          _id: "666c57d50fd17e508eafe9ca",
          title: { en: "Organic Garcinia Cambogia Extract" },
          subtitle: { en: "60% HCA; Garcinia cambogia; Fruit and rind" },
        },
        {
          _id: "666c58520fd17e508eafe9ee",
          title: { en: "Organic Gymnema Extract" },
          subtitle: { en: "25% Gymnemic acid; Gymnema sylvestre; Leaf" },
        },
        {
          _id: "666c58ae0fd17e508eafea12",
          title: { en: "Organic Lemon Peel Extract" },
          subtitle: { en: "Citrus limon; Fruit peel" },
        },
        {
          _id: "666c59250fd17e508eafea36",
          title: { en: "Organic Curcuma (Turmeric) Extract" },
          subtitle: { en: "95% Curcuminoides; Curcuma longa; Rhizomes" },
        },
        {
          _id: "6672f0132e84e44a9b2b1228",
          title: { en: "Organic Guava Extract" },
          subtitle: { en: "4% Zinc; Psidium guajava; Leaf" },
        },
        {
          _id: "6672f1170cdbfeadfeab1dab",
          title: { en: "Organic Curry leaf extract" },
          subtitle: { en: "3% Ferrous; 66:1; Murraya koenigii L; Leaf" },
        },
        {
          _id: "6672f55cb91f057ba9e8e543",
          title: { en: "Curcuma (Turmeric) Extract" },
          subtitle: { en: "95% Curcuminoids; 25:1; Curcuma Longa; Rhizome" },
        },
        {
          _id: "6672f607b91f057ba9e8e56b",
          title: { en: "Organic Black Pepper Extract" },
          subtitle: {
            en: "95% Piperine; 25:1; Piper Nigrum L.; Dried unripe berries",
          },
        },
        {
          _id: "667ac28489bb25b63dbc0b78",
          title: { en: "Biofolate®" },
          subtitle: {
            en: "Calcium L-5-methyltetrahydrofolate. 72% L-5-MTHF, 7% Calcium",
          },
        },
        {
          _id: "667e8bffd87bc748be41ff57",
          title: { en: "Lavender Extract" },
          subtitle: { en: "" },
        },
        {
          _id: "667e9eb630c48776a9ff1b54",
          title: { en: "Lavender Extract" },
          subtitle: { en: "4:1; Lavandula angustifolia; Herb" },
        },
        {
          _id: "6682916a1b0481b662677cdb",
          title: { en: "ANDROGRAPHIS PANICULATA EXTRACT 10%" },
          subtitle: { en: "10%" },
        },
        {
          _id: "66829613599ecfe73f68506f",
          title: { en: "Turmeric Oil" },
          subtitle: { en: "" },
        },
        {
          _id: "6683e082e19857d83cabdfac",
          title: { en: "Guanidinoacetic Acid (GAA)" },
          subtitle: { en: "" },
        },
        {
          _id: "6687ab34fe2d36374018a80e",
          title: { en: "Organic Black Pepper Extract" },
          subtitle: {
            en: "95% Piperine; 30:1; Piper Nigrum L.; Dried unripe berries",
          },
        },
        {
          _id: "6687fc54dc130f2419caf688",
          title: { en: "Garcinia Cambogia Extract" },
          subtitle: { en: "60% HCA; 3:1-3.5:1; Garcinia cambogia; Fruit rind" },
        },
        {
          _id: "668b9fcb5b3d86eb148846d3",
          title: { en: "Grape Seed Extract" },
          subtitle: { en: "75% OPC; Vitis vinifera L.; Seed" },
        },
        {
          _id: "668be5404b95c8b9f1347a97",
          title: { en: "Vitamin K2 (MK-7) oil" },
          subtitle: { en: "Bacillus subtilis Natto; Soybean oil" },
        },
        {
          _id: "668cf4c1e0f85c83ff335a1e",
          title: { en: "Galangal powder" },
          subtitle: { en: "Alpinia officinarum; Rhizome" },
        },
        {
          _id: "668cf6e1b4b4c4b7782d3e68",
          title: { en: "Galangal root extract" },
          subtitle: { en: "4:1; Alpinia officinarum Hance; Rhizome" },
        },
        {
          _id: "668cf7787f4080f877125a4d",
          title: { en: "Wheat Protein Peptide" },
          subtitle: { en: "" },
        },
        {
          _id: "668d2b611dc52739031d550e",
          title: { en: "Green Coffee Bean Extract 50%" },
          subtitle: { en: "" },
        },
        {
          _id: "668d2cc900e8188c8037be40",
          title: { en: "Green Tea Extract" },
          subtitle: {
            en: "60% Theanin; 20-25:1; Camellia Sinensis (L.) o. Ktze.; Leaf",
          },
        },
        {
          _id: "668e485105531cca012f6aa3",
          title: { en: "Terminalia chebula Extract" },
          subtitle: { en: "40% Tannins; 6:1; Terminalia chebula; Fruit" },
        },
        {
          _id: "668e4a1b063ac96fa6019fab",
          title: { en: "L-Arginine Hydrochloride" },
          subtitle: { en: "" },
        },
        {
          _id: "668e78c7cb14168255e10ba1",
          title: { en: "Crcuminu Extract" },
          subtitle: { en: "95%" },
        },
        {
          _id: "668e7adb13ff6e7602737149",
          title: { en: "Milk Thistle Extract" },
          subtitle: {
            en: "80% Silymarin, 40% Silybin &Isosilybin; Silybum marianum L. Gaertn; Seed",
          },
        },
        {
          _id: "668fc0af953ecea61a65afc7",
          title: { en: "Nettle Root Extract" },
          subtitle: { en: "10:1; Urtica L.; Root" },
        },
        {
          _id: "66913bf1496a2998bdaf9070",
          title: { en: "Organic Bamboo Extract" },
          subtitle: { en: "70% Silica; Bambusa arundinacea; Leaf" },
        },
        {
          _id: "6696a478d2e9cf612eabbecf",
          title: { en: "Fava Bean Protein" },
          subtitle: { en: "90% Protein; Vicia faba; Seed" },
        },
        {
          _id: "6696a99d435124d48a7a07d7",
          title: { en: "Coleus Extract" },
          subtitle: { en: "10% Forskohliin; Coleus forskohlii; Root" },
        },
        {
          _id: "6696aa5c435124d48a7a0804",
          title: { en: "Ginger Extract" },
          subtitle: { en: "5% Gingerols; Zingiber Officinale; Root" },
        },
        {
          _id: "6696aaa9435124d48a7a0830",
          title: { en: "Ginger Extract" },
          subtitle: { en: "30% Gingerols; Zingiber Officinale; Root" },
        },
        {
          _id: "6696abaa435124d48a7a0854",
          title: { en: "Lutein powder 10%" },
          subtitle: { en: "10% Lutein; Tagetes Erecta; Flower" },
        },
        {
          _id: "66990d6bfc1684712e7bc56e",
          title: { en: "Vitamin D3 1,000,000 IU/g oil (Non-Vegan)" },
          subtitle: { en: "in MCT Oil, 90% Vitamin D3" },
        },
        {
          _id: "669a3f3ac76a66018bfc11d3",
          title: { en: "Avocado soybean unsaponifiable (20-40 mesh)" },
          subtitle: {
            en: "30% Phytosterols; Persea americana Mill, Glycine max (L.) Merr.; Fruit",
          },
        },
        {
          _id: "669a424dfd074f652ceaa20a",
          title: { en: "Organic Cordyceps Sinensis Mycelium Extract" },
          subtitle: { en: "4:1; Cordyceps sinensis (berk.) sacc; Fruit Body" },
        },
        {
          _id: "669a453afd074f652ceaa22e",
          title: { en: "Organic Matcha Tea Powder" },
          subtitle: { en: "Camellia sinensis (L.) Kuntze; Leaf" },
        },
        {
          _id: "669a4820fd074f652ceaa253",
          title: { en: "Avocado soybean unsaponifiable" },
          subtitle: {
            en: "30% Phytosterols, 10% Tocopherol; 2:1; Persea americana Mill, Glycine max (L.) Merr.; Fruit",
          },
        },
        {
          _id: "669a53822cab584583ccc038",
          title: { en: "Fish Collagen granular" },
          subtitle: { en: "90% Protein" },
        },
        {
          _id: "669a552111bbaa65f541a382",
          title: { en: "Bovine Collagen granular" },
          subtitle: { en: "90% Protein" },
        },
        {
          _id: "669a59c6cdd3aa91f245bfff",
          title: { en: "Vitamin K2 (MK-7) powder 10,000 ppm/g" },
          subtitle: {
            en: "1% Vitamin K2 (MK-7); Bacillus subtilis Natto; Soybean",
          },
        },
        {
          _id: "669e2d039c6e7e1e822c0f4d",
          title: { en: "Avocado soybean unsaponifiable (80 mesh)" },
          subtitle: {
            en: "30% Phytosterols; Persea americana Mill, Glycine max (L.) Merr.; Fruit",
          },
        },
        {
          _id: "669e3d7f6ac6e1686474e4aa",
          title: { en: "Fava Bean Protein" },
          subtitle: { en: "85% Protein; Vicia faba; Seed" },
        },
        {
          _id: "669fbd1c4cf58112d42c7f92",
          title: {
            en: "Stevia Extract (95% Steviol Glycosides and 60% Rebaudioside A)",
          },
          subtitle: {
            en: "95% Steviol Glycosides, 60% Rebaudioside A; Stevia rebaudiana Bertoni; Leaf",
          },
        },
        {
          _id: "66a0bc20592ff90035fcb9e6",
          title: { en: "VITAMIN B1 Thiamine Hydrochloride" },
          subtitle: { en: "" },
        },
        {
          _id: "66a12305be0e3e2eaddea4dd",
          title: { en: "Chlorella Powder" },
          subtitle: { en: "Chlorella vulgaris ext.; Plant" },
        },
        {
          _id: "66a1241ee258ffca8addb911",
          title: { en: "Red Yeast Rice Extract" },
          subtitle: { en: "3% Monacolin K; Monascus Purpureus; Monascussp" },
        },
        {
          _id: "66a12497e258ffca8addb93d",
          title: { en: "Apple Pectin" },
          subtitle: {
            en: "50% Pectin, 65% Galacturonic acid; Malus pumila Mill.; Pericarp",
          },
        },
        {
          _id: "66a1261de258ffca8addb967",
          title: { en: "Black Pepper Extract" },
          subtitle: { en: "95% Piperine; Piper Nigrum L.; Fruit" },
        },
        {
          _id: "66a8a0c8f166b871891b6887",
          title: { en: "Nicotinamide ribose chloride" },
          subtitle: { en: "98% Nicotinamide ribose chloride" },
        },
        {
          _id: "66a8eff8f166b871891b68d8",
          title: { en: "D-Ribose" },
          subtitle: { en: "" },
        },
        {
          _id: "66a8fd1c9b0e61a6fa5656c0",
          title: { en: "D-Mannose granule" },
          subtitle: { en: "" },
        },
        {
          _id: "66a8fe399b0e61a6fa5656e4",
          title: { en: "D-Mannose tablet" },
          subtitle: { en: "" },
        },
        {
          _id: "66a903fc9b0e61a6fa56571b",
          title: { en: "Phytic acid" },
          subtitle: { en: "50% Phytic acid" },
        },
        {
          _id: "66a906289b0e61a6fa5657d6",
          title: { en: "Sodium phytate" },
          subtitle: { en: "75% Sodium phytate" },
        },
        {
          _id: "66aa322c1c232d8f83d8d816",
          title: { en: "Ashwagandha Extract" },
          subtitle: { en: "0.1% Withanolides; Withania Somnifera; Whole plant" },
        },
        {
          _id: "66b09a55d68c072860508c34",
          title: { en: "Mecobalamin " },
          subtitle: { en: "" },
        },
        {
          _id: "66b09fb6551637948711372d",
          title: { en: "Baical Skullcap Extract" },
          subtitle: { en: "" },
        },
        {
          _id: "66b0b6b356a2b432613653dc",
          title: { en: "Giant Knotweed Extract" },
          subtitle: { en: "50% Resveratrol; Polygonum cuspidatum; Root" },
        },
        {
          _id: "66b0b80a56a2b43261365416",
          title: { en: "Elderberry Extract" },
          subtitle: { en: "10:1; Sambucus australis; Fruit" },
        },
        {
          _id: "66b0c10a56a2b43261365464",
          title: { en: "Cat's Claw Extract" },
          subtitle: { en: "4:1; Uncaria tomentosa (Willd.) DC; Herb" },
        },
        {
          _id: "66b0cd2d56a2b43261365488",
          title: { en: "Baical Skullcap extract" },
          subtitle: { en: "90% Baicalin; Scutellaria baicalensis Georgi; Root" },
        },
        {
          _id: "66b22df3e100c151fc6127d2",
          title: { en: "Avocado soybean unsaponifiable (60 mesh)" },
          subtitle: {
            en: "30% Phytosterols; Persea americana Mill, Glycine max (L.) Merr.; Fruit",
          },
        },
        {
          _id: "66b24821cc3be992863634a2",
          title: { en: " Chondroitin sulfate sodium bovine" },
          subtitle: { en: "90% Protein" },
        },
        {
          _id: "66b25055806bc8e80a2c538d",
          title: { en: "Elderberry Extract" },
          subtitle: { en: "10:1; Sambucus nigra L.; Fruit" },
        },
        {
          _id: "66b25146cbdc2115d18e54b1",
          title: { en: "Giant Knotweed Extract" },
          subtitle: { en: "50% Resveratrol; Fallopia japonica; Root" },
        },
        {
          _id: "66b25374cbdc2115d18e54d5",
          title: { en: "Saffron Extract" },
          subtitle: { en: "4:1; Carthamus tinctorius L.; Flower" },
        },
        {
          _id: "66b3861905db023483c44ce3",
          title: { en: "Ashwagandha Extract" },
          subtitle: { en: "10% Withanolide; 5:1; Withania Somnifera; Root" },
        },
        {
          _id: "66ba1d8934cc604fece3a56f",
          title: { en: "Organic Moringa Powder" },
          subtitle: { en: "Moringa oleifera; Leaf" },
        },
        {
          _id: "66ba1f9fafbaa8329cb6b55d",
          title: { en: "Nettle extract" },
          subtitle: {
            en: "1% Beta-sitosterol; 10:1; Urtica dioica L.; Leaf, root",
          },
        },
        {
          _id: "66ba20cfafbaa8329cb6b584",
          title: { en: "Horse Chestnut Extract" },
          subtitle: {
            en: "20% Aescin; 10:1; Aesculus chinensis Bunge, Aesculus hippocastanum; Seed",
          },
        },
        {
          _id: "66ba23492a2a42ebd65af04a",
          title: { en: "Red Vine Extract" },
          subtitle: {
            en: "5% Flavonoids, 2% Tannins; 4:1-6:1; Vitis vinifera L.; Leaf",
          },
        },
        {
          _id: "66bc97bbe4c6d9c535bde9c1",
          title: { en: "D-Tagatose" },
          subtitle: { en: "" },
        },
        {
          _id: "66bc9b19253d98611181751e",
          title: { en: "Horse Chestnut Extract" },
          subtitle: { en: "20% Aescin; Aesculus chinensis Bunge; Seed" },
        },
        {
          _id: "66bc9c32253d986111817564",
          title: { en: "Nettle extract" },
          subtitle: {
            en: "1% Beta-sitosterol; 15:1; Urtica dioica L.; Leaf, root",
          },
        },
        {
          _id: "66bdebfb424f211681f47a79",
          title: { en: "Cordyceps Extract" },
          subtitle: {
            en: "30% Polysaccharide; Cordyceps sinensis (berk.) sacc; Mycelium",
          },
        },
        {
          _id: "66bf0c9c900b51f9a34bb404",
          title: { en: "Cordyceps Extract" },
          subtitle: { en: "10% Polysaccharide; Mycelium; Fruit Body" },
        },
        {
          _id: "66c34e7f913fc9a819395047",
          title: { en: "Shoden Ashwagandha Extract" },
          subtitle: {
            en: "35% Withanolide; 40:1; Withania Somnifera; Root, Leaf",
          },
        },
        {
          _id: "66c491914f1daf19e5d4829c",
          title: { en: "Green Coffee Bean Extract" },
          subtitle: {
            en: "50% Chlorogenic acid, 2% Caffeine; Coffee Arabica L.; Bean",
          },
        },
        {
          _id: "66c606c13a28fb20f96626b3",
          title: { en: "Ashwagandha Extract" },
          subtitle: {
            en: "10% Withanolide; 30:1; Withania Somnifera; Root, Aerial",
          },
        },
        {
          _id: "66c6079e3a28fb20f96626cf",
          title: { en: "Inositol DC 95% granular" },
          subtitle: { en: "" },
        },
        {
          _id: "66c86c0bef3426a0807f9427",
          title: {
            en: "Sodium Hyaluronate 800-1500 KdA  (Bulk density <400 kg/m3)",
          },
          subtitle: { en: "95% Sodium Hyaluronate, 44% Glucuronic acid" },
        },
        {
          _id: "66c86ffeef3426a0807f947a",
          title: {
            en: "Sodium Hyaluronate 1500-1800 KdA  (Bulk density >400 kg/m3)",
          },
          subtitle: { en: "95% Sodium Hyaluronate, 44% Glucuronic acid" },
        },
        {
          _id: "66c87240ef3426a0807f9498",
          title: { en: "Shilajit Extract" },
          subtitle: { en: "50% Fulvic Acid; Asphaltum punjabianum" },
        },
        {
          _id: "66c8730bef3426a0807f94c2",
          title: { en: "Licorice Extract" },
          subtitle: { en: "20% Glycyrrhizic Acid; Glycyrrhiza Glabra L.; Root" },
        },
        {
          _id: "66c8742bef3426a0807f94f4",
          title: { en: "Ashwagandha Extract" },
          subtitle: { en: "5% Withanolide; Withania Somnifera; Root, Aerial" },
        },
        {
          _id: "66c874ddef3426a0807f9514",
          title: { en: "Bacopa Extract" },
          subtitle: { en: "20% Bacosides; Bacopa monnieri L. Wettst.; Leaf" },
        },
        {
          _id: "66c87605ef3426a0807f9533",
          title: { en: "Banaba Leaf Extract" },
          subtitle: { en: "1% Corosolic Acid; Lagerstroemia Speciosa; Leaf" },
        },
        {
          _id: "66c877aeef3426a0807f9565",
          title: { en: "Bromelain 2,400 GDU/g" },
          subtitle: { en: "Ananas Comosus" },
        },
        {
          _id: "66c8796fef3426a0807f9587",
          title: { en: "Gymnema Extract" },
          subtitle: { en: "75% Gymnemic acid; Gymnema sylvestre; Leaf" },
        },
        {
          _id: "66c87a13ef3426a0807f95a5",
          title: { en: "Guggul Extract" },
          subtitle: { en: "2.5% Guggulsterone; Commiphora mukul; Gum" },
        },
        {
          _id: "66cf168406102c81cbc27137",
          title: { en: "Saw Palmetto Extract" },
          subtitle: { en: "25% Fatty acids; 30:1; Serenoa Repens; Fruit" },
        },
        {
          _id: "66cf248803fef80f006384e5",
          title: { en: "Brown rice protein 300 mesh" },
          subtitle: { en: "90% Protein; Oryza sativa; Seed" },
        },
        {
          _id: "66d5cd6d2bf62642dc34ba94",
          title: { en: "Green Tea Extract" },
          subtitle: {
            en: "20% L-Theanine; Camellia Sinensis (L.) o. Ktze.; Leaf",
          },
        },
        {
          _id: "66d7072023d2b85699e6086a",
          title: { en: "Magnesium Stearate" },
          subtitle: { en: "" },
        },
        {
          _id: "66d82134334c1f62d51e4e79",
          title: { en: "Magnesium Citrate Nonahydrate" },
          subtitle: { en: "" },
        },
        {
          _id: "66dec7a75579443b4ad54e05",
          title: { en: "Brown rice protein 300 mesh" },
          subtitle: { en: "85% Protein; Oryza sativa; Seed" },
        },
        {
          _id: "66e15472be6cd2f6f7e1fd28",
          title: { en: "Maca Extract" },
          subtitle: { en: "40:1; Lepidium meyenii Walp; Root" },
        },
        {
          _id: "66e40dfb7691aeda4dfa7804",
          title: { en: "Chamomile Extract" },
          subtitle: { en: "30% Apigenin; Matricaria chamomilla L.; Herb" },
        },
        {
          _id: "66e419ae7d864a612fe55047",
          title: { en: "Sodium Chloride" },
          subtitle: { en: "" },
        },
        {
          _id: "66e425559ac03838599c877f",
          title: { en: "Magnesium Lactate Anhydrous " },
          subtitle: { en: "11% Magnesium" },
        },
        {
          _id: "66e4416e9ac03838599c87e1",
          title: { en: "Chamomile Extract" },
          subtitle: { en: "90% Apigenin; Matricaria chamomilla L.; Herb" },
        },
        {
          _id: "66e98a6394a816ddfc64f02b",
          title: { en: "Artichoke Extract" },
          subtitle: { en: "5% Cynarin; 5:1; Cynara scolymus L.; Leaf" },
        },
        {
          _id: "66e993eef57937afbbb9a00c",
          title: { en: "Red Ginseng Extract" },
          subtitle: { en: "20:1; Panax ginseng C.A. Mey; Root with leaf" },
        },
        {
          _id: "66eaab12245cb2e2dfb52457",
          title: { en: "Fat-reduced cocoa powder" },
          subtitle: { en: "" },
        },
        {
          _id: "66ead80cdfdf3d8fd7abdee1",
          title: { en: "Hawthorn Leaf Extract" },
          subtitle: { en: "10:1; Crataegus Pinnatifida Bunge; Leaf" },
        },
        {
          _id: "66eae0bc17ecf2fdf31a9d68",
          title: { en: "Rice Protein Peptide" },
          subtitle: {
            en: "80% Protein, 70% Peptides; Oryza Sativa (subsp. japonica); Seed",
          },
        },
        {
          _id: "66eae2b717ecf2fdf31a9d84",
          title: { en: "Fish Collagen peptides 1000 Da" },
          subtitle: { en: "" },
        },
        {
          _id: "66f1307a7ca149026b0edc65",
          title: { en: "Kelp Extract 1% Iodine" },
          subtitle: { en: "1% Iodine; Laminaria japonica A resch; Leaf" },
        },
        {
          _id: "66f13618ac80dd3f0146cfc8",
          title: { en: "Fisetin" },
          subtitle: { en: "98% Fisetin" },
        },
        {
          _id: "66f18cbda3295feb91b759ee",
          title: { en: "Green Tea Extract" },
          subtitle: { en: "98% EGCG; Camellia Sinensis L.; Leaf" },
        },
        {
          _id: "66f18d90a3295feb91b75a02",
          title: { en: "Green Tea Extract" },
          subtitle: { en: "90% EGCG; Camellia Sinensis L.; Leaf" },
        },
        {
          _id: "66f2ab5b3fb63716c2337f4d",
          title: { en: "Magnesium Bisglycinate Powder" },
          subtitle: { en: "11% Magnesium" },
        },
        {
          _id: "66f3f132f7941c6885e4f13c",
          title: { en: "Shilajit Extract (Mumijo extract)" },
          subtitle: { en: "70% Fulvic Acid; Asphaltum punjabianum" },
        },
        {
          _id: "66f6875e2c96c358a5877077",
          title: { en: "Stevia Extract (98% Rebaudioside A)" },
          subtitle: { en: "98% Rebaudioside A; Stevia rebaudiana Bertoni; Leaf" },
        },
        {
          _id: "66f699522c96c358a58770cf",
          title: { en: "Magnesium glycerophosphate" },
          subtitle: { en: "" },
        },
        {
          _id: "66f69cb0f85a3dddbfc7f0af",
          title: { en: "Shilajit Extract" },
          subtitle: { en: "60% Fulvic Acid; Polygonatum odoratum (Mill.) Druce" },
        },
        {
          _id: "66fa7636a0723d7e353e9bab",
          title: { en: "Black tea extract powder " },
          subtitle: { en: "(30% polyphenols)" },
        },
        {
          _id: "66faa05ab4f7f04e91000527",
          title: { en: "Shilajit Extract" },
          subtitle: { en: "50% Fulvic Acid; 10:1; Mumio Shilajit; Mineral" },
        },
        {
          _id: "66faa2f8b4f7f04e91000558",
          title: { en: "Shilajit Extract" },
          subtitle: { en: "80% Fulvic Acid; 15:1; Mumio Shilajit; Mineral" },
        },
        {
          _id: "66ff8a3413ca001385b38c80",
          title: { en: "Pharmaquinone®5% MCT Oil, Vitamin K2 as MK-7" },
          subtitle: {
            en: "95% Medium chain triglycerides (MCT), 5% Menaquinone-7",
          },
        },
        {
          _id: "6700035695c5d7ae9436c920",
          title: { en: "Calcium Carbonate Heavy" },
          subtitle: { en: "" },
        },
        {
          _id: "6700045812aa313f58fc803d",
          title: { en: "Magnesium Hydroxide Powder" },
          subtitle: { en: "" },
        },
        {
          _id: "6707ebef7bb9441fbc8c288a",
          title: { en: "Organic Cranberry Extract" },
          subtitle: { en: "4:1; Vaccinium Macrocarpon L.; Fruit" },
        },
        {
          _id: "6707f1634dc0d3b6b8a6401c",
          title: { en: "Cistus Incanus Extract" },
          subtitle: { en: "10:1; Cistus ladanifer L.; Whole herb" },
        },
        {
          _id: "6707f2184dc0d3b6b8a64044",
          title: { en: "Grapefruit extract" },
          subtitle: { en: "10:1; Citrus paradisi Macf.; Fruit" },
        },
        {
          _id: "6707f2d44dc0d3b6b8a64064",
          title: { en: "Black Garlic Extract 1.2% S-allyl-cysteine (HPLC)" },
          subtitle: { en: "1.2% S-allyl-cysteine; Allium sativum L.; Bulb" },
        },
        {
          _id: "670d364382f95b5d747c79ac",
          title: { en: "Kelp Extract 0.5% Iodine (Titration)" },
          subtitle: { en: "0.5% Iodine; Laminaria digitate L.; Whole Herb" },
        },
        {
          _id: "670d37b8177d9eec6649f56d",
          title: { en: "Chasteberry Extract 0.5% Agnuside (HPLC)" },
          subtitle: { en: "0.5% Agnuside; 50:1; Vitex agnus-castus L.; Fruit" },
        },
        {
          _id: "670d3aff177d9eec6649f59e",
          title: { en: "Milk Thistle Extract 80% Silymarin (UV)" },
          subtitle: { en: "80% Silymarin; Silybum marianum L. Gaertn; Seed" },
        },
        {
          _id: "671254e1de8499799d2f77e8",
          title: { en: "Cordyceps Extract 40% Polysaccharides" },
          subtitle: {
            en: "40% Polysaccharide, 0.2% Adenosine, 10% Mannitol; Cordyceps sinensis; Mycelium",
          },
        },
        {
          _id: "67125f84f41801e6994555a8",
          title: { en: "Nettle Extract (ratio 4:1)" },
          subtitle: { en: "4:1; Urtica dioica L.; Root" },
        },
        {
          _id: "671276e1f41801e69945560b",
          title: { en: "Boswellia Extract 85% Boswellic Acid" },
          subtitle: {
            en: "85% Boswellic Acid; 10:1; Boswellia Serrata; Gum resin",
          },
        },
        {
          _id: "6718bd38959cd2cc359d97be",
          title: { en: "L-Arginine alpha-ketoglutarate 1:1 Powder" },
          subtitle: { en: " Alpha-Ketoglutarate; 1:1" },
        },
        {
          _id: "6718c012959cd2cc359d97ed",
          title: { en: "L-aspartic acid" },
          subtitle: { en: "" },
        },
        {
          _id: "6718c227959cd2cc359d9831",
          title: { en: "L-Citrulline DL-Malate 1:1 Powder" },
          subtitle: { en: "" },
        },
        {
          _id: "6718c548bdc4197d19a7127f",
          title: { en: "Beta-Sitosterol 90%" },
          subtitle: { en: "90% Beta-sitosterol" },
        },
        {
          _id: "671a1eee90b7b11b720b909e",
          title: { en: "VITAMIN K2 (MK-7) 1.0% " },
          subtitle: { en: "1.0% in Calcium Hydrogen Phosphate(DCP)" },
        },
        {
          _id: "671a213890b7b11b720b90c0",
          title: { en: "Organic Fenugreek Extract" },
          subtitle: { en: "4:1" },
        },
        {
          _id: "671f709e7017c10767ec9bb2",
          title: { en: "Organic Matcha Tea Powder" },
          subtitle: { en: "Camellia sinensis (L.) Kuntze; Leaf" },
        },
        {
          _id: "6720a473b692adf36c901936",
          title: { en: "Tri-Potassium Citrate Monohydrate" },
          subtitle: { en: "" },
        },
        {
          _id: "6721fc0587b49a326a6959c0",
          title: { en: "VITAMIN B1 Thiamine Mononitrate" },
          subtitle: { en: "" },
        },
        {
          _id: "6721fd3c87b49a326a6959f4",
          title: { en: "Vitamin B3 - Nicotinic acid" },
          subtitle: { en: "98% Vitamin B3" },
        },
        {
          _id: "6721fe0a87b49a326a695a18",
          title: { en: "D-Calcium pantothenate" },
          subtitle: { en: "" },
        },
        {
          _id: "6721fea787b49a326a695a40",
          title: { en: "VITAMIN K3" },
          subtitle: { en: "MNB96" },
        },
        {
          _id: "6721ff5487b49a326a695a5c",
          title: { en: "VITAMIN K3" },
          subtitle: { en: "MSB96" },
        },
        {
          _id: "672203247e5e1e0d8ca87775",
          title: { en: "Centaurium Erythraea Extract" },
          subtitle: { en: "4:1" },
        },
        {
          _id: "67235a1bb9476db6102f3b47",
          title: { en: "L-Glutamic Acid" },
          subtitle: { en: "" },
        },
        {
          _id: "6728900bc0ccef957896423f",
          title: { en: "Centaurium Erythraea Extract" },
          subtitle: { en: "10:1 TLC" },
        },
        {
          _id: "67289129c0ccef957896425f",
          title: { en: "Levisticum officinale extract" },
          subtitle: { en: " 10:1TLC" },
        },
        {
          _id: "6728a4bf305c66abd927b88d",
          title: { en: "Ceylon Cinnamon Extract" },
          subtitle: { en: "5:1; Cinnamomum verum; Bark" },
        },
        {
          _id: "6728a6e7305c66abd927b8ac",
          title: { en: "Cinnamon Extract" },
          subtitle: { en: "10:1TLC" },
        },
        {
          _id: "6728acc0ce5df9d3513e05bb",
          title: { en: "Sodium Acetate anhydrous" },
          subtitle: { en: "" },
        },
        {
          _id: "6728ad61ce5df9d3513e05df",
          title: { en: "Magnesium Acetate" },
          subtitle: { en: "" },
        },
        {
          _id: "6728ae4dce5df9d3513e0601",
          title: { en: "Ferrous Sulfate Heptahydrate" },
          subtitle: { en: "" },
        },
        {
          _id: "6728b063ce5df9d3513e0623",
          title: { en: "Magnesium chloride" },
          subtitle: { en: "" },
        },
        {
          _id: "6728b0f9ce5df9d3513e0643",
          title: { en: "Potassium Formate" },
          subtitle: { en: "75%" },
        },
        {
          _id: "6728b1c7ce5df9d3513e065e",
          title: { en: "Zinc Sulfate Heptahydrate" },
          subtitle: { en: "" },
        },
        {
          _id: "6728b245ce5df9d3513e067e",
          title: { en: "Potassium Bicarbonate" },
          subtitle: { en: "" },
        },
        {
          _id: "6728b414ce5df9d3513e069e",
          title: { en: "Dipotassium Phosphate" },
          subtitle: { en: "" },
        },
        {
          _id: "6728b4a1ce5df9d3513e06c0",
          title: { en: "Potassium Acetate" },
          subtitle: { en: "" },
        },
        {
          _id: "6728bee621461ca11af262a3",
          title: { en: "Sodium diacetate" },
          subtitle: { en: "" },
        },
        {
          _id: "6728ca5878fd9e4a6a522b36",
          title: { en: "Dicalcium Phosphate Anhydrous" },
          subtitle: { en: "" },
        },
        {
          _id: "6728cd0778fd9e4a6a522b6b",
          title: { en: "Lecithin" },
          subtitle: { en: "Food additive" },
        },
        {
          _id: "6728ce5a78fd9e4a6a522b8d",
          title: { en: "L-Lysine monohydrochloride" },
          subtitle: { en: "" },
        },
        {
          _id: "6728cef378fd9e4a6a522baf",
          title: { en: "Tribulus Terrestris Extract" },
          subtitle: { en: "60% Saponine; Tribulus terrestris L.; Stem,Leaf" },
        },
        {
          _id: "6728cf5e78fd9e4a6a522bd1",
          title: { en: "Tribulus Terrestris Extract" },
          subtitle: { en: "98% Saponins; Tribulus terrestris L.; Aerial part" },
        },
        {
          _id: "6729d9bbd6f6346f0a7635d9",
          title: { en: "Ceylon Cinnamon Extract" },
          subtitle: { en: "10:1; Cinnamomum verum; Bark" },
        },
        {
          _id: "672dd82ad07554883f77199d",
          title: { en: "Sophora Japonica Extract" },
          subtitle: { en: "20% Kaempferol" },
        },
        {
          _id: "672dd9b9d07554883f7719bf",
          title: { en: "Sophora Japonica Extract" },
          subtitle: { en: "10% Kaempferol" },
        },
        {
          _id: "672e0018c6a9a8a317fc872f",
          title: { en: "Fucoxanthin" },
          subtitle: { en: "" },
        },
        {
          _id: "6731ba708c8ffc91ec46b708",
          title: { en: "NADH Disodium Salt" },
          subtitle: { en: "" },
        },
        {
          _id: "6731bff78c8ffc91ec46b72c",
          title: { en: "L-Proline" },
          subtitle: { en: "USP43" },
        },
        {
          _id: "6731c2538c8ffc91ec46b75d",
          title: { en: "L-Lysine HCL Powder" },
          subtitle: { en: "80% Mesh" },
        },
        {
          _id: "673221008c8ffc91ec46b7bf",
          title: { en: "Grape Seed Extract" },
          subtitle: { en: "OPC 80%HPLC" },
        },
        {
          _id: "6732232948f0270c667acd70",
          title: { en: "Green Tea Extract" },
          subtitle: {
            en: "50% Polyphenoles, 30% Catechins, 15% EGCG, 8% Caffeine; Camellia Sinensis (L.) o. Ktze.; Leaf",
          },
        },
        {
          _id: "673337c5be7da7f100385fb3",
          title: { en: "Matcha Green Tea" },
          subtitle: { en: "#1A" },
        },
        {
          _id: "6733529ab949a0342649252b",
          title: { en: "Green Coffee Bean Extract" },
          subtitle: { en: "Caffeine 13%~15%" },
        },
        {
          _id: "6733560acd12fc454439059f",
          title: { en: "L-Lysine HCL Powder" },
          subtitle: { en: "20% Mesh" },
        },
        {
          _id: "6733753dcd12fc45443905d9",
          title: { en: "Fenugreek Powder" },
          subtitle: { en: " 50%" },
        },
        {
          _id: "673377e7e4c2ddf8969adef1",
          title: { en: "Asphaltum Extract " },
          subtitle: { en: "DP 50%" },
        },
        {
          _id: "67337ae5e4c2ddf8969adf24",
          title: { en: "Ashwagandha Extract" },
          subtitle: {
            en: "5% Withanolide; 35:1 to 45:1; Withania Somnifera; Root",
          },
        },
        {
          _id: "67337cace4c2ddf8969adf48",
          title: { en: "Vitamin E powder natural" },
          subtitle: { en: "50% Mixed tocopheryl" },
        },
        {
          _id: "67348378659f8f615b5d33e6",
          title: { en: "Grape Seed Extract" },
          subtitle: { en: "75% OPC (HPLC), 90% Polyphenols" },
        },
        {
          _id: "673486d6659f8f615b5d342a",
          title: { en: "Green Tea Extract" },
          subtitle: { en: "50% L-Theanine, 30% Polythenols, 10% EGCG" },
        },
        {
          _id: "67349253659f8f615b5d344a",
          title: { en: "Vitamin E (D-alpha tocopheryl Acetate Powder 700IU)" },
          subtitle: { en: "(D-alpha tocopheryl Acetate Powder 700IU)" },
        },
        {
          _id: "6734914855abb96105a34916",
          title: { en: "Ruby-O® Omega-3 Phospholipids 40/32 Balance (liquid)" },
          subtitle: {
            en: "11% DHA, 16% EPA, 40% Total Phospholipids, 32% Total Omega-3 Fatty Acids as FFA",
          },
        },
        {
          _id: "6734960155abb96105a34956",
          title: { en: "Ruby-O® Omega-3 Phospholipids 40/35 Neur-O (liquid)" },
          subtitle: {
            en: "26% DHA, 4.2% EPA, 40% Total Phospholipids, 35% Total Omega-3 Fatty Acids as FFA; Haematococcus pluvialis",
          },
        },
        {
          _id: "67349731659f8f615b5d3488",
          title: { en: "Shilajit Dry Extract" },
          subtitle: { en: "50% Fulvic Acid; Mumio Shilajit; Mineral" },
        },
        {
          _id: "67349aa755abb96105a34997",
          title: {
            en: "Ruby-O® Omega-3 Phospholipids 30/40 Plant-based (liquid)",
          },
          subtitle: {
            en: "40% DHA, 30% Total Phospholipids, 30% Astaxanthin; Haematococcus pluvialis",
          },
        },
        {
          _id: "6734b522659f8f615b5d34d4",
          title: { en: "Chlorella Powder(Broken cell wall)" },
          subtitle: { en: "Chlorella vulgaris ext.; Plant" },
        },
        {
          _id: "6734c8c5270ff545099b8966",
          title: { en: "Chlorella Powder(Broken cell wall)" },
          subtitle: { en: "Chlorella Pyrenoidesa" },
        },
        {
          _id: "6734cadb6cdbdf037f8ff223",
          title: { en: "Ashwagandha Extract" },
          subtitle: { en: "5% Withanolide; Withania Somnifera; Root" },
        },
        {
          _id: "6734cc686cdbdf037f8ff265",
          title: { en: "Bromaline" },
          subtitle: { en: "5000 GDU" },
        },
        {
          _id: "6735c2f2d42e33031f1439d3",
          title: { en: "Green Tea Extract" },
          subtitle: { en: "50% L-Theanine (HPLC)" },
        },
        {
          _id: "6735cf94d490e503af8a180b",
          title: { en: "Fenugreek Extract " },
          subtitle: { en: "50%" },
        },
        {
          _id: "6735d2b0b740fef3087d219d",
          title: { en: "Bromelain 5000 GDU/g" },
          subtitle: { en: "Ananas Comosus" },
        },
        {
          _id: "6735d5c6b740fef3087d21bd",
          title: { en: "Ashwagandha Extract" },
          subtitle: { en: "5% Withanolide" },
        },
        {
          _id: "6735d681b740fef3087d21d5",
          title: { en: "Ashwagandha Extract HPLC" },
          subtitle: { en: "5% Withanolide" },
        },
        {
          _id: "6735d9bcb740fef3087d21f3",
          title: { en: "Vitamin D3 Powder " },
          subtitle: { en: "100.000 IU/g" },
        },
        {
          _id: "673609de3ede289cc40ea32e",
          title: { en: "Vitamin H - D-Biotin Powder" },
          subtitle: { en: "" },
        },
        {
          _id: "673611133ede289cc40ea372",
          title: { en: "Reishi Mushroom Extract" },
          subtitle: { en: "40%" },
        },
        {
          _id: "673613aa3ede289cc40ea39c",
          title: { en: "Reishi Mushroom Extract" },
          subtitle: { en: "30%" },
        },
        {
          _id: "673727e91266c7e7668b5207",
          title: { en: "Griffonia Extract" },
          subtitle: { en: "30% 5-HTP; Griffonia simplicifolia; Seed" },
        },
        {
          _id: "67372c6b1266c7e7668b5245",
          title: { en: "Palmitoylethanolamide" },
          subtitle: { en: "Assay 99%" },
        },
        {
          _id: "673768fc1fa05637b444dfa0",
          title: { en: "Medium Chain Triglycerides Oil" },
          subtitle: { en: "" },
        },
        {
          _id: "673b099edf770a35c881a678",
          title: { en: "Atrichoke Extract" },
          subtitle: { en: "2,5%" },
        },
        {
          _id: "673b0b1d5d437ce9dc02ae8b",
          title: { en: "Atrichoke Extract" },
          subtitle: { en: "10%" },
        },
        {
          _id: "673b0bab5d437ce9dc02aead",
          title: { en: "Bitter Orange Extract" },
          subtitle: { en: "6% Citrus Aurantium; Fruit" },
        },
        {
          _id: "673b0ca95d437ce9dc02aec7",
          title: { en: "Bitter Orange Extract" },
          subtitle: { en: "60% Citrus Aurantium; Fruit" },
        },
        {
          _id: "673b0e5b5d437ce9dc02aef3",
          title: { en: "Black Garlic Extract 0,1% S-allyl-cysteine (HPLC)" },
          subtitle: { en: "1.2% S-allyl-cysteine; Allium sativum L.; Bulb" },
        },
        {
          _id: "673b15dbf279c4be5c1dbdaa",
          title: { en: "Fenugreek Seed Extract " },
          subtitle: { en: "50%" },
        },
        {
          _id: "673b172a6ab44a20288612de",
          title: { en: "Organic Lion's Mane Extract" },
          subtitle: {
            en: "30% Polysaccharide, 5% Beta Glucan; 1:1; Hericium Erinaceus; Fruit",
          },
        },
        {
          _id: "673b2a4dc984a63a50de7df6",
          title: { en: "Sophora Japonica Extract" },
          subtitle: { en: "95% Rutin; 5,5-9,0; Sophora Japonica L.; Buds" },
        },
      ],
    ],
  };

  handleSelection = (selected) => {
    if (selected.length > 0) {
      const selectedOption = selected[0];
      window.open("https://app.rawbids.com/commodity/" + selectedOption._id.toString(), "_blank");
    }
  };

  render() {
    const { t } = this.props;

    const commodities = [].concat(...this.state.commodities); // Flaches Array erstellen
    return (
      <>
        <section
          className="big-section cover-background mt-0 mb-4 mx-1 mx-sm-3"
          style={{
            borderRadius: 30,
            margin: 20,
            marginTop: 5,
          }}
        >
          <div
            className="opacity-extra-medium-2 bg-dark-slate-blue"
            style={{ opacity: 0.5, backgroundColor: "#151b2a" }}
          />
          <div className="container">
            <div className="row pt-5 pb-5">
              <div className="col-12 col-xl-12 col-lg-12 col-md-12 overlap-gap-section pb-5">
                <h2
                  className="alt-font text-white font-weight-600 wow animate__fadeIn text-uppercase mb-2 herotitle"
                  style={{ visibility: "visible", animationName: "fadeIn" }}
                >
                  {t("title353")}
                </h2>
                <h2
                  className="alt-font text-white font-weight-600 wow animate__fadeIn mb-3 text-uppercase herotitle"
                  style={{ visibility: "visible", animationName: "fadeIn" }}
                >
                  {t("title354")}
                </h2>
                <h6
                  className="text-white alt-font text-uppercase letter-spacing-1px text-uppercase wow animate__fadeIn herosubtitle"
                  style={{ visibility: "visible", animationName: "fadeIn" }}
                >
                  {t("title355")}
                </h6>
              </div>
              <div className="col-12 col-lg-6">
                <div className="">
                  <div className="input-group p-3 bg-white" style={{ borderRadius: 8 }}>
                    <Typeahead
                      id="custom-typeahead"
                      options={commodities}
                      labelKey={(option) => (option.title && option.title.en ? option.title.en : "Unknown Title")}
                      placeholder="Vitamins, Minerals, Plant Extracts,..."
                      onChange={this.handleSelection}
                      size="lg"
                      className="form-control form-control-lg p-0 border-none border-0"
                      renderMenuItemChildren={(option) => (
                        <div>
                          <strong>{option.title?.en || "Unknown Title"}</strong>
                          <div style={{ fontSize: "12px", color: "#888" }}>
                            {option.subtitle?.en || option.title.en}
                          </div>
                        </div>
                      )}
                    />
                    <button
                      className="btn btn-neon-orange btn-round-edge px-3"
                      style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                      onClick={() => this.fetchCommodities()}
                    >
                      <i className="fa fa-search d-inline" style={{ marginRight: 5, color: "inherit" }}></i>
                      {t("title356")}
                    </button>
                  </div>
                </div>

                <div>
                  <span
                    className="text-white"
                    style={{ marginBottom: 0, marginTop: 5, paddingBottom: 0, fontWeight: 500, marginRight: 3 }}
                  >
                    {t("title357")}:
                  </span>
                  <a
                    href={"https://app.rawbids.com/commodity/6458ae695175287050a4cde7"}
                    className="badge badge-dark badge-lg py-1 px-2 mt-0 mx-1"
                    style={{ background: "rgba(255, 255, 255, 0.3)", paddingTop: 0, marginTop: 0 }}
                  >
                    Green Tea Extract
                  </a>
                  <a
                    href="https://app.rawbids.com/commodity/6458ae695175287050a4cc30"
                    className="badge badge-dark badge-lg py-1 px-2 mt-0 mx-1"
                    style={{ background: "rgba(255, 255, 255, 0.3)", paddingTop: 0, marginTop: 0 }}
                  >
                    BCAA 2:1:1
                  </a>
                  <a
                    href="https://app.rawbids.com/commodity/6458ae695175287050a4cc93"
                    className="badge badge-dark badge-lg py-1 px-2 mt-0 mx-1"
                    style={{ background: "rgba(255, 255, 255, 0.3)", paddingTop: 0, marginTop: 0 }}
                  >
                    Acerola Extract
                  </a>
                  <a
                    href="https://app.rawbids.com/commodity/6458ae695175287050a4d03c"
                    className="badge badge-dark badge-lg py-1 px-2 mt-0 mx-1"
                    style={{ background: "rgba(255, 255, 255, 0.3)", paddingTop: 0, marginTop: 0 }}
                  >
                    Vitamin C
                  </a>
                </div>
              </div>
            </div>
          </div>
          <video loop autoPlay muted className="html-video herovideo" id="video-10" playsInline>
            <source type="video/mp4" src={`${process.env.PUBLIC_URL}/images/bg.mp4`} />
          </video>
        </section>
        <div className="header align-items-stretch" style={{ height: 40 }}>
          <div className="marquee" style={{ width: "100%", padding: 2 }}>
            <div
              className="header-animation"
              style={{ animation: "45s linear 0s infinite normal none running marquee" }}
            >
              {this.state.prices.map((item) => (
                <Price
                  key={item.articleId} // Verwenden Sie den articleId als Schlüssel
                  link={"https://app.rawbids.com/commodity/" + item.articleId}
                  name={item.title.en} // Zugriff auf den englischen Titel
                  price={`${item.commodityPrice.price.toFixed(2)}€`} // Preisformat
                  percent={`${item.change > 0 ? "+" : ""}${item.change.toFixed(2)}%`} // Prozentwert
                  graph={`data:image/svg+xml;utf8,${encodeURIComponent(item.svg)}`} // SVG als Graph
                  color={item.change <= 0 ? "success" : "danger"} // Farbe je nach Veränderung
                />
              ))}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withTranslation("general")(HeroImage2);
